
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kLWhg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $db033d3b9239d66d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("3avtZ");

var $5vQ2T = parcelRequire("5vQ2T");

var $dMpy6 = parcelRequire("dMpy6");

var $2imLM = parcelRequire("2imLM");

var $iCmeE = parcelRequire("iCmeE");

var $aPS2z = parcelRequire("aPS2z");

var $dZRaT = parcelRequire("dZRaT");

var $aV23b = parcelRequire("aV23b");

var $4EKqI = parcelRequire("4EKqI");

var $eJrcF = parcelRequire("eJrcF");
var $jJaSe = parcelRequire("jJaSe");

var $37WtV = parcelRequire("37WtV");

var $kUUkd = parcelRequire("kUUkd");
const $db033d3b9239d66d$var$RelayProjectVersions = ({ match: match })=>{
    const projectContext = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const projectKey = match.params.projectKey ?? '';
    const onExperienceFail = (0, $iCmeE.useJiraProjectVersionExperienceFail)();
    const isNonExistingProjectKey = projectContext.data == null && projectContext.error != null && // Casting to `FetchError` because if the resource was fetched during SSR, the serialisation & deserialisation
    // process will have converted it into an `Error` (even though it still has the `statusCode` property).
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectContext.error.statusCode === 404;
    if ((0, $aPS2z.isProjectArchivedCondition)(projectContext.data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aPS2z.RedirectToArchivedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "project-versions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCmeE.JiraProjectVersionExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, isNonExistingProjectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCmeE.JiraProjectVersionExperienceExpectedFailureSuccess), {
        reason: "Project does not exist with the given project key"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "project-versions",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $37WtV.Skeleton), null)
    }, projectKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "projectVersions",
        packageName: "jiraSpaAppsProjectVersions",
        teamName: "jolt",
        onError: (loc, error)=>{
            onExperienceFail(loc, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kUUkd.default), {
        projectKey: projectKey
    })) : null)));
};
var $db033d3b9239d66d$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($db033d3b9239d66d$var$RelayProjectVersions);

});
parcelRegister("iCmeE", function(module, exports) {
$parcel$export(module.exports, "JiraProjectVersionExperienceStart", () => $069be7588327d845$export$280be5742fc2dc22);
$parcel$export(module.exports, "JiraProjectVersionExperienceSuccess", () => $069be7588327d845$export$6bc513cfb37586f4);
$parcel$export(module.exports, "JiraProjectVersionExperienceExpectedFailureSuccess", () => $069be7588327d845$export$fef40ab145516510);
$parcel$export(module.exports, "useJiraProjectVersionExperienceFail", () => $069be7588327d845$export$13d84dc8cd2d3dfd);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $069be7588327d845$var$EXPERIENCE_NAME = 'viewVersionsPage';
const $069be7588327d845$var$ANALYTICS_SOURCE = 'versions';
const $069be7588327d845$export$280be5742fc2dc22 = ({ experienceId: experienceId })=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experienceId: experienceId,
        experience: $069be7588327d845$var$EXPERIENCE_NAME,
        analyticsSource: $069be7588327d845$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $lBYgs.JIRA_SOFTWARE)
    });
};
const $069be7588327d845$export$6bc513cfb37586f4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $069be7588327d845$var$EXPERIENCE_NAME,
        attributes: {
            isLegacy: false
        }
    });
const $069be7588327d845$export$fef40ab145516510 = ({ reason: reason })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: $069be7588327d845$var$EXPERIENCE_NAME,
        attributes: {
            isLegacy: false,
            expectedFailureReason: reason
        }
    });
const $069be7588327d845$export$13d84dc8cd2d3dfd = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $069be7588327d845$var$EXPERIENCE_NAME,
        attributes: {
            isLegacy: false
        }
    });

});

parcelRegister("aPS2z", function(module, exports) {
$parcel$export(module.exports, "isProjectArchivedCondition", () => $09ee4a6709eeeeea$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $09ee4a6709eeeeea$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $09ee4a6709eeeeea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $2mHfh = parcelRequire("2mHfh");

const $09ee4a6709eeeeea$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $09ee4a6709eeeeea$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, (projectContext)=>$09ee4a6709eeeeea$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
        }) : null);
};
const $09ee4a6709eeeeea$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
    });
var $09ee4a6709eeeeea$export$2e2bcd8739ae039 = $09ee4a6709eeeeea$var$RedirectIfProjectArchived;

});
const $5e412e91f864721a$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("37WtV", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $8df47f740c3f2172$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $83IUp = parcelRequire("83IUp");

var $9YQlE = parcelRequire("9YQlE");
const $8df47f740c3f2172$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "project-versions-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83IUp.ContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9YQlE.SkeletonHeading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9YQlE.SkeletonFilter), {
        avatar: false
    })));

});
parcelRegister("83IUp", function(module, exports) {
$parcel$export(module.exports, "ContentWrapper", () => $8dc494ee8f6020b3$export$6ce170286acaa8d3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8dc494ee8f6020b3$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginRight: marginRight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_129vh1m": (0, $awdRS.default)(__cmplp.marginRight, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _19pk1ejb _18u01jfw _4t3ioskh _1e0c1txw _2lx21bp4 _2hwx17yv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9YQlE", function(module, exports) {
$parcel$export(module.exports, "SkeletonHeading", () => $5357b55a58cff8d4$export$f9d7393532a80768);
$parcel$export(module.exports, "SkeletonItem", () => $5357b55a58cff8d4$export$fbc0ea7debdb77e);
$parcel$export(module.exports, "SkeletonFilter", () => $5357b55a58cff8d4$export$5a0e77037f4561ed);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $5357b55a58cff8d4$export$f9d7393532a80768 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5357b55a58cff8d4$var$marginBottomMap.mdMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$export$fbc0ea7debdb77e, {
        height: 10,
        width: 52,
        "data-testid": "spa-apps-common.skeletons.small-heading"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5357b55a58cff8d4$var$marginBottomMap.noMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$export$fbc0ea7debdb77e, {
        height: 24,
        width: 192,
        "data-testid": "spa-apps-common.skeletons.large-heading"
    }))));
const $5357b55a58cff8d4$export$5a0e77037f4561ed = ({ avatar: avatar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $5357b55a58cff8d4$var$marginTopMap.threeTimesGridSize,
            $5357b55a58cff8d4$var$marginBottomMap.threeTimesGridSize
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5357b55a58cff8d4$var$baseStyleMarginRightStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$export$fbc0ea7debdb77e, {
        height: 40,
        width: 120,
        "data-testid": "spa-apps-common.skeletons.filter"
    })), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$export$d02d1ff29bb075b5, null)));
const $5357b55a58cff8d4$export$d02d1ff29bb075b5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonContainer, {
        "data-testid": "spa-apps-common.skeletons.avatar-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonAvatar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonAvatar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonAvatar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonAvatar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5357b55a58cff8d4$var$SkeletonAvatar, null));
const $5357b55a58cff8d4$var$baseStyleMarginRightStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
});
const $5357b55a58cff8d4$var$marginBottomMap = {
    noMargin: (0, $1DXK0.xcss)({
        marginBottom: 'space.0'
    }),
    mdMargin: (0, $1DXK0.xcss)({
        marginBottom: 'space.150'
    }),
    threeTimesGridSize: (0, $1DXK0.xcss)({
        marginBottom: 'space.300'
    })
};
const $5357b55a58cff8d4$var$marginTopMap = {
    threeTimesGridSize: (0, $1DXK0.xcss)({
        marginTop: 'space.300'
    })
};
const $5357b55a58cff8d4$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _bfhkizff _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $5357b55a58cff8d4$var$SkeletonHeaderContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $5357b55a58cff8d4$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _19pk1b66",
            __cmplp.className
        ])
    });
});
const $5357b55a58cff8d4$var$SkeletonAvatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1rr0 _bfhkizff _4t3ixy5q _1bsbxy5q _18u01i6y _1mfnze3t",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kUUkd", function(module, exports) {
$parcel$export(module.exports, "default", () => $2222e2ec1fe2f7bb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fdpHV = parcelRequire("fdpHV");


var $10s3I = parcelRequire("10s3I");

var $9FYIg = parcelRequire("9FYIg");

var $PZ4Ji = parcelRequire("PZ4Ji");

var $TALfu = parcelRequire("TALfu");

var $cZTMg = parcelRequire("cZTMg");

var $gWu57 = parcelRequire("gWu57");

var $iEXnd = parcelRequire("iEXnd");

var $cH6Qf = parcelRequire("cH6Qf");
const $2222e2ec1fe2f7bb$var$RelayVersions = ({ projectKey: projectKey })=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $PZ4Ji.projectVersionsRelayResource));
    if (!projectKey) throw new Error('Unable to find projectkey');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEXnd.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    }), queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $10s3I.ProjectVersionsComponent), {
        queryReference: queryReference
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $TALfu.default), {
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null));
};
var $2222e2ec1fe2f7bb$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('project-versions', (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a))($2222e2ec1fe2f7bb$var$RelayVersions);

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("10s3I", function(module, exports) {
$parcel$export(module.exports, "ProjectVersionsComponent", () => $f41521b8ca9f6e2a$export$24429f25746ad806);

var $7DVdD = parcelRequire("7DVdD");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jOLxk = parcelRequire("jOLxk");

var $h6slU = parcelRequire("h6slU");

var $6ClNq = parcelRequire("6ClNq");

var $gFB4g = parcelRequire("gFB4g");

var $gHI4w = parcelRequire("gHI4w");

var $dMpy6 = parcelRequire("dMpy6");

var $cSXp8 = parcelRequire("cSXp8");

var $3nL89 = parcelRequire("3nL89");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $dZRaT = parcelRequire("dZRaT");

var $3f8eM = parcelRequire("3f8eM");

var $avEgE = parcelRequire("avEgE");

var $e6YEs = parcelRequire("e6YEs");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $kAwwe = parcelRequire("kAwwe");

var $eSXqs = parcelRequire("eSXqs");

var $eJrcF = parcelRequire("eJrcF");

var $kqd31 = parcelRequire("kqd31");

var $h4BSt = parcelRequire("h4BSt");


var $5StNs = parcelRequire("5StNs");

var $iCmeE = parcelRequire("iCmeE");

var $gsavr = parcelRequire("gsavr");

var $ixOF2 = parcelRequire("ixOF2");

var $iISbl = parcelRequire("iISbl");

var $kDdy7 = parcelRequire("kDdy7");

var $gNPBB = parcelRequire("gNPBB");

var $cU8qD = parcelRequire("cU8qD");

var $l82eg = parcelRequire("l82eg");
const $f41521b8ca9f6e2a$export$24429f25746ad806 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagService)(); /* eslint-disable @atlassian/relay/unused-fields */ 
    const data = (0, $j4oe4.usePreloadedQuery)((0, $7DVdD.default), queryReference);
    const { projectId: projectId, name: name, key: key, jiraProjectType: jiraProjectType } = data.jira.jiraProjectByKey;
    const connectionId = data.jira.jiraProjectByKey.versions.__id;
    const projectType = (0, $l82eg.getProjectType)(jiraProjectType);
    const accountId = (0, $e6YEs.useAccountId)();
    const cloudId = (0, $cHtIB.useCloudId)(); // remove this variable when we don't need delegated admin analytics anymore
    const isJiraAdmin = (0, $kAwwe.useIsAdmin)();
    const activationId = (0, $f2sjT.useActivationId)();
    const projectContext = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource)); // remove this variable when we don't need delegated admin analytics anymore
    const isProjectAdmin = projectContext?.data?.isProjectAdmin || false;
    const canEditVersions = (0, $4cTDP.fg)('vmc-11-manage-versions-permission') && data.jira.jiraProjectByKey.canEditVersions?.canPerform;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const [createReleaseFormQueryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $h4BSt.default));
    const loadCreateReleaseQuery = ()=>{
        if (!createReleaseFormQueryRef && accountId) loadQuery({
            accountId: accountId
        });
    };
    const [createVersionModalOpen, setCreateVersionModalOpen] = (0, $eJOHy.useState)(false);
    const createVersionExperienceStart = (0, $3f8eM.useCreateReleaseExperienceStart)((0, $5e130dc454373f11$export$c5ed97509d0e2aaf));
    const hasPermissionError = (data.jira.jiraProjectByKey.versions.errors ?? []).some((error)=>(error.extensions ?? []).some((extension)=>extension.statusCode === 403)); // Due to this condition, inside any subtree can have `versions @required(action: THROW)`.
    if (hasPermissionError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dMpy6.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCmeE.JiraProjectVersionExperienceExpectedFailureSuccess), {
        reason: "User does not have permission to view this page."
    }));
    const onCreateRelease = (version)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const connectionRecord = store.get(connectionId);
            if (connectionRecord) {
                const versionAri = (0, $jOLxk.JiraVersionAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    versionId: version.id.toString()
                }).toString();
                const dataID = (0, $kqd31.default)({
                    id: versionAri
                }, 'JiraVersion') ?? '';
                const versionRecord = store.get(dataID);
                if (versionRecord) {
                    const newEdgeRecord = (0, $j4oe4.ConnectionHandler).createEdge(store, connectionRecord, versionRecord, 'JiraVersionEdge');
                    (0, $j4oe4.ConnectionHandler).insertEdgeBefore(connectionRecord, newEdgeRecord);
                }
            }
        });
    };
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null);
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixOF2.FeedbackButton), null));
    const createVersionButton = ((0, $4cTDP.fg)('vmc-11-manage-versions-permission') ? canEditVersions : isJiraAdmin || isProjectAdmin) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: (_e, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'createVersionButton');
            setCreateVersionModalOpen(true);
            createVersionExperienceStart();
        },
        onMouseOver: loadCreateReleaseQuery,
        onFocus: loadCreateReleaseQuery,
        testId: "project-directories.versions.main.add-version.create-button"
    }, formatMessage((0, $kDdy7.default).createVersionButton)) : null;
    const createVersionModal = createVersionModalOpen && createReleaseFormQueryRef != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avEgE.CreateReleaseModal), {
        queryReference: createReleaseFormQueryRef,
        onClose: ()=>setCreateVersionModalOpen(false),
        projectId: projectId,
        onReleaseCreation: (version)=>{
            onCreateRelease(version);
            showFlag({
                type: 'success',
                title: formatMessage((0, $kDdy7.default).successFlagDescription, {
                    name: version.name
                }),
                isAutoDismiss: true,
                testId: 'project-directories.versions.flags.create.success',
                messageId: 'project-versions.ui.show-flag.success',
                messageType: 'transactional'
            });
        }
    }) : null;
    const bottomBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f41521b8ca9f6e2a$var$BottomBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f41521b8ca9f6e2a$var$Filter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNPBB.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f41521b8ca9f6e2a$var$versionsFilterContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iISbl.default), null))), projectType === 'software' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, actions, createVersionButton, createVersionModal) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, createVersionButton, createVersionModal));
    const pageContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f41521b8ca9f6e2a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: formatMessage((0, $kDdy7.default).releases)
    }), projectType === 'software' && !(0, $l82eg.isVersionAdminContext)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f41521b8ca9f6e2a$var$headerBarStyles
    }, bottomBar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        truncateTitle: true,
        breadcrumbs: breadcrumbs,
        actions: undefined,
        bottomBar: bottomBar
    }, formatMessage((0, $kDdy7.default).releases)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cU8qD.default), {
        query: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCmeE.JiraProjectVersionExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gsavr.PerformanceTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5StNs.ProjectVersionsAnalyticsContextProvider), {
        canEditVersions: canEditVersions,
        isJiraAdmin: isJiraAdmin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "project-directories.versions.main.name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: key,
        projectName: name
    }, (0, $l82eg.isVersionAdminContext)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ClNq.default), {
        projectKey: key,
        projectType: projectType
    }, pageContent) : pageContent)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f41521b8ca9f6e2a$var$Filter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f41521b8ca9f6e2a$var$versionsFilterContainerStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.150'
});
const $f41521b8ca9f6e2a$var$containerStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.300'
});
const $f41521b8ca9f6e2a$var$headerBarStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.250',
    marginBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f41521b8ca9f6e2a$var$BottomBarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOLxk", function(module, exports) {
$parcel$export(module.exports, "JiraVersionAri", () => $e6d78f962b8d2fb9$export$eff0d18d9de27263);

var $5UgNq = parcelRequire("5UgNq");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/version/manifest.ts
var $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5UgNq.JiraVersionAriResourceOwner),
    resourceType: (0, $5UgNq.JiraVersionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{versionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        versionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/version/index.ts
var $e6d78f962b8d2fb9$export$eff0d18d9de27263 = class _JiraVersionAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._versionId = opts.resourceIdSegmentValues.versionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get versionId() {
        return this._versionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts.qualifier,
            platformQualifier: $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts.resourceOwner,
            resourceType: $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.versionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                versionId: opts.versionId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts);
        return new _JiraVersionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $e6d78f962b8d2fb9$var$jiraVersionAriStaticOpts);
        return new _JiraVersionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            versionId: this.versionId
        };
    }
};

});
parcelRegister("5UgNq", function(module, exports) {
$parcel$export(module.exports, "JiraVersionAriResourceOwner", () => $44cf361911e89f66$export$1b35360c29caced0);
$parcel$export(module.exports, "JiraVersionAriResourceType", () => $44cf361911e89f66$export$680940c40f68f72d);
// src/jira/version/types.ts
var $44cf361911e89f66$export$1b35360c29caced0 = "jira", $44cf361911e89f66$export$680940c40f68f72d = "version";

});


parcelRegister("6ClNq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef98065b0a2c44a3$export$2e2bcd8739ae039);

var $idGBm = parcelRequire("idGBm");

var $hDOar = parcelRequire("hDOar");
var $ef98065b0a2c44a3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $hDOar.default));

});
parcelRegister("hDOar", function(module, exports) {
$parcel$export(module.exports, "default", () => $223d6d435146eb62$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $6T1wD = parcelRequire("6T1wD");

var $cqjwJ = parcelRequire("cqjwJ");

var $61zkv = parcelRequire("61zkv");
const $223d6d435146eb62$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $FhXEJ.CORE_PROJECT) || projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('jcs_project_type_m3')) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: {
            href: (0, $cqjwJ.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $61zkv.default).projectSettingsTitleGalaxia : (0, $61zkv.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $223d6d435146eb62$export$2e2bcd8739ae039 = $223d6d435146eb62$var$ProjectSettingsBreadcrumb;

});
parcelRegister("61zkv", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e6a4be935cc4686$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8e6a4be935cc4686$var$messages = (0, $7qGN1.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    },
    projectSettingsTitleGalaxia: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title-galaxia",
        "defaultMessage": "Space settings"
    }
});
var $8e6a4be935cc4686$export$2e2bcd8739ae039 = $8e6a4be935cc4686$var$messages;

});



parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

parcelRegister("3f8eM", function(module, exports) {
$parcel$export(module.exports, "useCreateReleaseExperienceStart", () => $3b6a2c8dcee84737$export$137d6976ddfff3f4);
$parcel$export(module.exports, "useCreateReleaseExperienceFail", () => $3b6a2c8dcee84737$export$aeb23334e467d1ba);
$parcel$export(module.exports, "useCreateReleaseExperienceSuccess", () => $3b6a2c8dcee84737$export$af6b8a20eaaa829c);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $3b6a2c8dcee84737$export$52919046b94109dc = 'createRelease';
const $3b6a2c8dcee84737$export$137d6976ddfff3f4 = (analyticsSource)=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $3b6a2c8dcee84737$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: analyticsSource,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $3b6a2c8dcee84737$export$aeb23334e467d1ba = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $3b6a2c8dcee84737$export$52919046b94109dc
    });
const $3b6a2c8dcee84737$export$af6b8a20eaaa829c = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $3b6a2c8dcee84737$export$52919046b94109dc
    });

});

parcelRegister("avEgE", function(module, exports) {
$parcel$export(module.exports, "CreateReleaseModal", () => $e6650318c55d0350$export$98347b760d62204c);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e6650318c55d0350$var$LazyCreateReleaseModal = (0, $bQWwW.lazy)(()=>(parcelRequire("hXiEP")).then((module)=>module.CreateReleaseModal), {
    moduleId: "./src/packages/releases/release-modals-relay/src/ui/create-release-modal/index.tsx"
});
const $e6650318c55d0350$export$98347b760d62204c = ({ fallback: fallback = null, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "create-release-modal",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e6650318c55d0350$var$LazyCreateReleaseModal, props));

});
parcelRegister("hXiEP", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8ETP5")
]).then(()=>parcelRequire('9tt3A'));

});


parcelRegister("h4BSt", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a218b261cadeb80$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b973f7193843497a07c1470c89d06f40>>
 * @relayHash 61fe91a04aa18abb03fb45259643fc02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ba7f55b9606c6306f9ffee483513fccb037383f6a29e7aa236eb5cbac386518
const $5a218b261cadeb80$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "createReleaseModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "createReleaseForm_softwareReleasesReleaseModalsRelay"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "user"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "createReleaseModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7ba7f55b9606c6306f9ffee483513fccb037383f6a29e7aa236eb5cbac386518",
            "metadata": {},
            "name": "createReleaseModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5a218b261cadeb80$var$node.hash = "9f85087ab53fe21f6df07185269b323d";
var $5a218b261cadeb80$export$2e2bcd8739ae039 = $5a218b261cadeb80$var$node;

});

const $5e130dc454373f11$export$a181206198b7f50c = 'contains';
const $5e130dc454373f11$export$3e8168848b996f7 = 'status';
const $5e130dc454373f11$export$71089821f361e881 = 'orderDirection';
const $5e130dc454373f11$export$a3482d3a8df0e725 = 'orderField';
const $5e130dc454373f11$export$3c5e605ca7ade9f2 = 'NAME';
const $5e130dc454373f11$export$50241fe906e4f94e = 'RELEASE_DATE';
const $5e130dc454373f11$export$99a467bcc22b8df9 = 'START_DATE';
const $5e130dc454373f11$export$d44826c816b5619b = 'DESCRIPTION';
const $5e130dc454373f11$export$34694f8d8b23ee2a = 'SEQUENCE';
const $5e130dc454373f11$export$cb638d1fae624fbf = 20;
const $5e130dc454373f11$export$bbcbc202f2dfa28c = 3;
const $5e130dc454373f11$export$b983f2cb1f658a55 = 'RELEASED';
const $5e130dc454373f11$export$cb459d726a8530a5 = 'UNRELEASED';
const $5e130dc454373f11$export$c936349447a77fe0 = 'ARCHIVED';
const $5e130dc454373f11$export$c5ed97509d0e2aaf = 'projectVersions';

parcelRegister("5StNs", function(module, exports) {
$parcel$export(module.exports, "ProjectVersionsAnalyticsContextProvider", () => $1508b52eb7d3eb8c$export$4f5b37ee904fc1f9);

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $dZRaT = parcelRequire("dZRaT");

var $9TL1j = parcelRequire("9TL1j");

var $eJrcF = parcelRequire("eJrcF");


var $cYcBU = parcelRequire("cYcBU");
const $1508b52eb7d3eb8c$var$useAnalyticsCustomAttributes = (canEditVersions, isJiraAdmin)=>{
    const projectContext = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const projectId = projectContext?.data?.projectId || undefined;
    const projectType = projectContext?.data?.projectType || undefined;
    const simplified = projectContext?.data?.simplified || undefined;
    const statusAttributes = $1508b52eb7d3eb8c$var$useFilterAnalytics();
    return {
        projectId: projectId,
        projectType: projectType,
        simplified: simplified,
        canEditVersions: canEditVersions,
        isJiraAdmin: isJiraAdmin,
        ...statusAttributes
    };
};
const $1508b52eb7d3eb8c$var$hasStatusSelected = (status, statuses)=>statuses.length === 0 || statuses.some((selectedStatus)=>selectedStatus === status);
const $1508b52eb7d3eb8c$var$useFilterAnalytics = ()=>{
    const [queryParams] = (0, $9TL1j.useQueryParams)((0, $5e130dc454373f11$export$3e8168848b996f7));
    const statuses = (0, $cYcBU.transformStatusFromParam)(queryParams[0, $5e130dc454373f11$export$3e8168848b996f7]);
    const searchFilter = queryParams[0, $5e130dc454373f11$export$a181206198b7f50c] ?? '';
    return {
        hasReleasedStatusFilter: $1508b52eb7d3eb8c$var$hasStatusSelected('RELEASED', statuses),
        hasUnreleasedStatusFilter: $1508b52eb7d3eb8c$var$hasStatusSelected('UNRELEASED', statuses),
        hasArchivedStatusFilter: $1508b52eb7d3eb8c$var$hasStatusSelected('ARCHIVED', statuses),
        hasSearchFilter: searchFilter.length > 0
    };
};
const $1508b52eb7d3eb8c$export$4f5b37ee904fc1f9 = ({ canEditVersions: canEditVersions, isJiraAdmin: isJiraAdmin, children: children })=>{
    const attributes = $1508b52eb7d3eb8c$var$useAnalyticsCustomAttributes(canEditVersions, isJiraAdmin);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
        data: {
            attributes: attributes
        }
    }, children);
};

});

parcelRegister("gsavr", function(module, exports) {
$parcel$export(module.exports, "PerformanceTracker", () => $b0350389ea05922c$export$57a2c9a4973f6a35);

var $eJOHy = parcelRequire("eJOHy");

var $hqYEY = parcelRequire("hqYEY");

var $jUHqr = parcelRequire("jUHqr");
const $b0350389ea05922c$export$5de0383686b855d0 = (0, $hqYEY.metrics).pageLoad({
    key: 'project-versions',
    ssr: {
        doneAsFmp: true
    },
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});
const $b0350389ea05922c$export$57a2c9a4973f6a35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        appName: "jira-project-versions",
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: $b0350389ea05922c$export$5de0383686b855d0
    });

});
parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");

var $4cTDP = parcelRequire("4cTDP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (metric)=>{
    if ((0, $4cTDP.fg)('jfp-magma-remove-ld-client')) return;
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $eaa2e9e24133f900$export$fcc03ee4c944962f(value);
            $eaa2e9e24133f900$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("ixOF2", function(module, exports) {
$parcel$export(module.exports, "FeedbackButton", () => $495238c39a24a15d$export$116fedbe5e2e2bd8);

var $eJOHy = parcelRequire("eJOHy");

var $gdeTc = parcelRequire("gdeTc");

var $lhWt4 = parcelRequire("lhWt4");
const $495238c39a24a15d$export$74189cec821240a6 = 'project-pages.project-directories.versions';
const $495238c39a24a15d$export$116fedbe5e2e2bd8 = ()=>{
    const feedbackContextEntries = [
        {
            id: (0, $gdeTc.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $495238c39a24a15d$export$74189cec821240a6
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhWt4.FeedbackCollectorButton), {
        entrypointId: (0, $gdeTc.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: feedbackContextEntries
    });
};

});
parcelRegister("lhWt4", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorButton", () => $2d44d3cbf65fe67a$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8c712 = parcelRequire("8c712");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $cHtIB = parcelRequire("cHtIB");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $3xTe8 = parcelRequire("3xTe8");
const $2d44d3cbf65fe67a$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: customLabel || formatMessage((0, $3xTe8.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $2d44d3cbf65fe67a$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($8c712))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const buttonRef = (0, $eJOHy.useRef)(null);
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $gdeTc.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $gdeTc.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d44d3cbf65fe67a$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d44d3cbf65fe67a$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #803FA5)" : "var(--ds-text, #292A2E)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $3xTe8.messages).leaveFeedback)) || '',
        "aria-haspopup": "dialog"
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $3xTe8.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $2d44d3cbf65fe67a$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isHighlight && "_1w90dqil _16hgp2ly _1fh1dqil _u1mb1nm4 _r7sm18ah _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8c712", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f74e2e78935ad1f$var$_react = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5f74e2e78935ad1f$var$_baseNew = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5f74e2e78935ad1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f74e2e78935ad1f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5f74e2e78935ad1f$var$_react.default.createElement($5f74e2e78935ad1f$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5f74e2e78935ad1f$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $5f74e2e78935ad1f$var$_default = module.exports.default = $5f74e2e78935ad1f$var$FeedbackIcon;

});

parcelRegister("3xTe8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3ab49be821ee4a1d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3ab49be821ee4a1d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});



parcelRegister("iISbl", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d548abee2fdd9b6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $lG4Az = parcelRequire("lG4Az");
var $jagCZ = parcelRequire("jagCZ");

var $1OQKp = parcelRequire("1OQKp");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9TL1j = parcelRequire("9TL1j");

var $frPES = parcelRequire("frPES");


var $cYcBU = parcelRequire("cYcBU");

var $fYhQM = parcelRequire("fYhQM");
const $4d548abee2fdd9b6$var$statusDropdownItems = [
    {
        id: 'released',
        value: (0, $frPES.RELEASED),
        label: (0, $fYhQM.default).released
    },
    {
        id: 'unreleased',
        value: (0, $frPES.UNRELEASED),
        label: (0, $fYhQM.default).unreleased
    },
    {
        id: 'archived',
        value: (0, $frPES.ARCHIVED),
        label: (0, $fYhQM.default).archived
    }
];
const $4d548abee2fdd9b6$var$StatusFilter = ()=>{
    const [queryParams, setQueryParams] = (0, $9TL1j.useQueryParams)((0, $5e130dc454373f11$export$3e8168848b996f7));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Displayed statuses
    const statuses = (0, $cYcBU.transformStatusFromParam)(queryParams[0, $5e130dc454373f11$export$3e8168848b996f7]);
    // Selected statuses (in the dropdown)
    const [selectedStatuses, setSelectedStatuses] = (0, $eJOHy.useState)(statuses);
    (0, $eJOHy.useEffect)(()=>{
        setSelectedStatuses((0, $cYcBU.transformStatusToDropdownSelection)(queryParams[0, $5e130dc454373f11$export$3e8168848b996f7]));
    }, [
        queryParams
    ]);
    const handleFilterSelection = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((selectedItem)=>{
        const updatedDisplayedStatuses = (0, $cYcBU.getUpdatedDisplayedStatuses)(statuses, selectedStatuses, selectedItem);
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'itemClicked',
            actionSubject: 'filterDropdown'
        }), 'statusFilterFilterDropdown', {
            type: selectedItem
        });
        setQueryParams({
            [(0, $5e130dc454373f11$export$3e8168848b996f7)]: (0, $cYcBU.transformStatusToParam)(updatedDisplayedStatuses)
        });
    }, 300);
    const getStatusFilterDropdownLabel = ()=>{
        if (selectedStatuses.length === 0 || selectedStatuses.length === $4d548abee2fdd9b6$var$statusDropdownItems.length) return formatMessage((0, $fYhQM.default).all);
        const labels = $4d548abee2fdd9b6$var$statusDropdownItems.filter((item)=>selectedStatuses.includes(item.value)).map((item)=>formatMessage(item.label));
        return labels.join(', ');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                // TODO: This ID might be used in polli tests so preserving it until we update them.
                // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                testId: "project-directories.versions.main.filter.versions-filter.filter-dropdown.button",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    label: "",
                    size: "small"
                }),
                ref: triggerRef
            }, getStatusFilterDropdownLabel()),
        shouldRenderToParent: (0, $4cTDP.fg)('should-render-to-parent-should-be-true-nova')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jagCZ.default), {
        id: "actions"
    }, $4d548abee2fdd9b6$var$statusDropdownItems.map((status)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lG4Az.default), {
            id: status.id,
            onClick: ()=>handleFilterSelection(status.value),
            isSelected: selectedStatuses.includes(status.value),
            key: status.value
        }, formatMessage(status.label)))));
};
var $4d548abee2fdd9b6$export$2e2bcd8739ae039 = $4d548abee2fdd9b6$var$StatusFilter;

});
parcelRegister("lG4Az", function(module, exports) {
$parcel$export(module.exports, "default", () => $68c6f37dfc2da9ca$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dQDjy = parcelRequire("dQDjy");

var $7saMl = parcelRequire("7saMl");

var $hMygQ = parcelRequire("hMygQ");

var $8GgUj = parcelRequire("8GgUj");

var $5kbaW = parcelRequire("5kbaW");

var $igDjg = parcelRequire("igDjg");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $68c6f37dfc2da9ca$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $3Vuhz.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $igDjg;
    const [selected, setSelected] = (0, $8GgUj.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eJOHy.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $5kbaW.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQDjy.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hMygQ.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $68c6f37dfc2da9ca$export$2e2bcd8739ae039 = $68c6f37dfc2da9ca$var$DropdownItemCheckbox;

});
parcelRegister("hMygQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f85eb58de3bb91fe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $f85eb58de3bb91fe$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $7bb4c1736002a04a$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
            fillRule: "evenodd",
            children: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        stroke: checked ? `var(--ds-border-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                        x: "5.5",
                        y: "5.5",
                        width: "13",
                        height: "13",
                        rx: "1.5",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        fill: "currentColor",
                        x: "6",
                        y: "6",
                        width: "12",
                        height: "12",
                        rx: "2",
                        stroke: checked ? `var(--ds-border-selected, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $7bb4c1736002a04a$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
                        fill: "inherit"
                    })
                ]
            })
        })
    });
};
var $f85eb58de3bb91fe$export$2e2bcd8739ae039 = $f85eb58de3bb91fe$var$CheckboxIcon;

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("8GgUj", function(module, exports) {
$parcel$export(module.exports, "default", () => $73211f6a96445066$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2b70q = parcelRequire("2b70q");

var $cdbUz = parcelRequire("cdbUz");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $73211f6a96445066$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eJOHy.useContext)((0, $cdbUz.SelectionStoreContext));
    const groupId = (0, $eJOHy.useContext)((0, $2b70q.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eJOHy.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eJOHy.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $73211f6a96445066$export$2e2bcd8739ae039 = $73211f6a96445066$var$useCheckboxState;

});
parcelRegister("2b70q", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroupContext", () => $60738199056e4d12$export$baf37c4be89255b8);

var $eJOHy = parcelRequire("eJOHy");
const $60738199056e4d12$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eJOHy.createContext)('');

});



parcelRegister("jagCZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b487fbbf6fcd6c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gl2vi = parcelRequire("gl2vi");

var $6YEko = parcelRequire("6YEko");

var $8cNLI = parcelRequire("8cNLI");

var $2b70q = parcelRequire("2b70q");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $1b487fbbf6fcd6c1$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $gl2vi.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2b70q.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8cNLI.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $1b487fbbf6fcd6c1$export$2e2bcd8739ae039 = $1b487fbbf6fcd6c1$var$DropdownItemCheckboxGroup;

});

parcelRegister("frPES", function(module, exports) {
$parcel$export(module.exports, "RELEASED", () => $8aa2131c0941c313$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $8aa2131c0941c313$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $8aa2131c0941c313$export$c936349447a77fe0);
const $8aa2131c0941c313$export$b983f2cb1f658a55 = 'RELEASED';
const $8aa2131c0941c313$export$cb459d726a8530a5 = 'UNRELEASED';
const $8aa2131c0941c313$export$c936349447a77fe0 = 'ARCHIVED';
const $8aa2131c0941c313$var$statuses = [
    $8aa2131c0941c313$export$b983f2cb1f658a55,
    $8aa2131c0941c313$export$cb459d726a8530a5,
    $8aa2131c0941c313$export$c936349447a77fe0
];
var $8aa2131c0941c313$export$2e2bcd8739ae039 = $8aa2131c0941c313$var$statuses;

});

parcelRegister("fYhQM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c34060bad7d9a0b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3c34060bad7d9a0b$var$messages = (0, $7qGN1.defineMessages)({
    unreleased: {
        "id": "project-versions.filter.unreleased",
        "defaultMessage": "Unreleased"
    },
    released: {
        "id": "project-versions.filter.released",
        "defaultMessage": "Released"
    },
    archived: {
        "id": "project-versions.filter.archived",
        "defaultMessage": "Archived"
    },
    all: {
        "id": "project-versions.filter.all",
        "defaultMessage": "All statuses"
    }
});
var $3c34060bad7d9a0b$export$2e2bcd8739ae039 = $3c34060bad7d9a0b$var$messages;

});


parcelRegister("kDdy7", function(module, exports) {
$parcel$export(module.exports, "default", () => $72907d8baea9eaa6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $72907d8baea9eaa6$var$messages = (0, $7qGN1.defineMessages)({
    releases: {
        "id": "project-versions.releases",
        "defaultMessage": "Releases"
    },
    createVersionButton: {
        "id": "project-versions.create-version-button",
        "defaultMessage": "Create version"
    },
    successFlagDescription: {
        "id": "project-versions.success-flag-description",
        "defaultMessage": "{name} created."
    },
    searchMessage: {
        "id": "project-versions.search.message",
        "defaultMessage": "Typing any character in this field will update the search results below in the table"
    }
});
var $72907d8baea9eaa6$export$2e2bcd8739ae039 = $72907d8baea9eaa6$var$messages;

});

parcelRegister("gNPBB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e641587a5b0ed8e3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $jjRt1 = parcelRequire("jjRt1");

var $6fs4r = parcelRequire("6fs4r");

var $kRgKj = parcelRequire("kRgKj");

var $9TL1j = parcelRequire("9TL1j");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");


var $kDdy7 = parcelRequire("kDdy7");
const $e641587a5b0ed8e3$var$Search = ()=>{
    const [queryParams, setQueryParams] = (0, $9TL1j.useQueryParams)((0, $5e130dc454373f11$export$a181206198b7f50c));
    const [currentStr, setCurrentStr] = (0, $eJOHy.useState)(queryParams[0, $5e130dc454373f11$export$a181206198b7f50c]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((searchStr, analyticsEvent)=>{
        setCurrentStr(searchStr);
        setQueryParams({
            [(0, $5e130dc454373f11$export$a181206198b7f50c)]: searchStr
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'textFilterFilterSearch', {
            length: searchStr.length
        });
    }, 300);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $4cTDP.fg)('releases_search_results_not_programmatically') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjRt1.default), {
        onChange: handleInputChange,
        value: currentStr || '',
        isAlwaysExpanded: true,
        describedById: "hiddentext1",
        placeholder: "",
        hasAutoFocus: false,
        isCompact: false,
        increasedWidth: false,
        placeholderAlwaysVisible: false
    }) : // @ts-expect-error - Type '{ onChange: DebouncedFunc<(searchStr: string, analyticsEvent: UIAnalyticsEvent) => void>; value: string; isAlwaysExpanded: true; }' is missing the following properties from type 'Omit<{ value: string; placeholder: string; describedById?: string | undefined; hasAutoFocus: boolean; isCompact: boolean; onChange: (value: string, args_1: UIAnalyticsEvent) => void; ... 6 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>': placeholder, hasAutoFocus, isCompact, increasedWidth, placeholderAlwaysVisible
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjRt1.default), {
        onChange: handleInputChange,
        value: currentStr || '',
        isAlwaysExpanded: true
    }), (0, $4cTDP.fg)('releases_search_results_not_programmatically') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fs4r.default), {
        id: "hiddentext1"
    }, formatMessage((0, $kDdy7.default).searchMessage)));
};
var $e641587a5b0ed8e3$export$2e2bcd8739ae039 = $e641587a5b0ed8e3$var$Search;

});
parcelRegister("jjRt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0c664de71f5fe1$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $gPaDt = parcelRequire("gPaDt");
const $5a0c664de71f5fe1$var$FilterSearchWithAnalytics = (0, $as6H2.default)('filterSearch', {
    onChange: 'changed'
})((0, $gPaDt.default));
var $5a0c664de71f5fe1$export$2e2bcd8739ae039 = $5a0c664de71f5fe1$var$FilterSearchWithAnalytics;

});
parcelRegister("gPaDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae2458133d2ad358$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dqc6Z = parcelRequire("dqc6Z");
const $ae2458133d2ad358$export$4c4c11a6ab1f5b09 = 1000;
const $ae2458133d2ad358$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value, callback)=>callback(value), $ae2458133d2ad358$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $ae2458133d2ad358$var$Filter extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: true
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $ae2458133d2ad358$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $ae2458133d2ad358$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $ae2458133d2ad358$export$2e2bcd8739ae039 = $ae2458133d2ad358$var$Filter;

});
parcelRegister("dqc6Z", function(module, exports) {
$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]);
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps;
    const showTooltip = (0, $eJOHy.useMemo)(()=>{
        return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
    }, [
        renderTooltipContent,
        value
    ]);
    const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: renderTooltipContent,
        canAppear: useShowTooltip,
        position: "bottom-start",
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true
    }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ...tooltipProps,
            ...restTextFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {},
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onFocus: (0, $eJOHy.useCallback)((event)=>{
                onFocusTextField && onFocusTextField(event);
                onFocusTooltip(event);
            }, [
                onFocusTooltip
            ]),
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onBlur: (0, $eJOHy.useCallback)((event)=>{
                onBlurTextField && onBlurTextField(event);
                onBlurTooltip(event);
            }, [
                onBlurTooltip
            ]),
            ref: (0, $bzbsd.mergeRefs)(textFieldRef, tooltipRef),
            "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
        }))));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-radius-small, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {
$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {
$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $4cTDP = parcelRequire("4cTDP");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});





parcelRegister("cU8qD", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb92e0c1960c6739$export$2e2bcd8739ae039);

var $1doM0 = parcelRequire("1doM0");

var $fwiHP = parcelRequire("fwiHP");

var $5EXaK = parcelRequire("5EXaK");

var $bxzUg = parcelRequire("bxzUg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7XH79 = parcelRequire("7XH79");

var $cA0Y2 = parcelRequire("cA0Y2");

var $lOOiG = parcelRequire("lOOiG");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $dZRaT = parcelRequire("dZRaT");

var $9TL1j = parcelRequire("9TL1j");

var $cHtIB = parcelRequire("cHtIB");

var $kAwwe = parcelRequire("kAwwe");

var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");


var $cYcBU = parcelRequire("cYcBU");

var $12Kxt = parcelRequire("12Kxt");

var $5KSWe = parcelRequire("5KSWe");

var $3PDhY = parcelRequire("3PDhY");

var $lAMEV = parcelRequire("lAMEV");

var $cYHXH = parcelRequire("cYHXH");

var $gu0u0 = parcelRequire("gu0u0");

var $8nIFm = parcelRequire("8nIFm");

var $89ror = parcelRequire("89ror");
const $fb92e0c1960c6739$var$VersionFetchAnalytics = ({ isLoading: isLoading, totalCount: totalCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading) (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'versions fetched', {
            versionCount: totalCount
        });
    }, [
        isLoading,
        totalCount,
        createAnalyticsEvent
    ]);
    return null;
};
const $fb92e0c1960c6739$var$Table = ({ query: query })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [queryParams, setQueryParams] = (0, $9TL1j.useQueryParams)((0, $5e130dc454373f11$export$a181206198b7f50c), (0, $5e130dc454373f11$export$3e8168848b996f7), (0, $5e130dc454373f11$export$71089821f361e881), (0, $5e130dc454373f11$export$a3482d3a8df0e725));
    const { data: data, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext, refetch: refetch } = (0, $j4oe4.usePaginationFragment)((0, $bxzUg.default), query);
    const connectionId = data?.jira.jiraProjectByKey.versions.__id;
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionPosition] = (0, $j4oe4.useMutation)((0, $5EXaK.default));
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [moveVersionToStart] = (0, $j4oe4.useMutation)((0, $fwiHP.default));
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [moveVersionToEnd] = (0, $j4oe4.useMutation)((0, $1doM0.default));
    const currentProjectKey = data.jira.jiraProjectByKey.key;
    const totalCount = data?.jira?.jiraProjectByKey?.versions.totalCount || 0;
    const versions = (data?.jira?.jiraProjectByKey?.versions?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter(Boolean);
    const { formatDate: formatDate } = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const projectContext = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const canEditVersions = (0, $4cTDP.fg)('vmc-11-manage-versions-permission') && data?.jira?.jiraProjectByKey?.canEditVersions?.canPerform;
    const isProjectAdmin = projectContext?.data?.isProjectAdmin || false;
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const isTableRankable = (0, $4cTDP.fg)('vmc-11-manage-versions-permission') ? canEditVersions : isProjectAdmin || isAdmin;
    const canAtleastOneVersionQuickRelease = ()=>versions.some((version)=>version.status === (0, $5e130dc454373f11$export$cb459d726a8530a5) && version.allIssues?.totalCount && version.allIssues?.totalCount === version.doneIssues?.totalCount);
    const onSortUpdateQueryParams = (field, direction)=>{
        setQueryParams({
            [(0, $5e130dc454373f11$export$a3482d3a8df0e725)]: field,
            [(0, $5e130dc454373f11$export$71089821f361e881)]: direction
        });
    };
    const [suspenselessRefetch, isLoading] = (0, $7XH79.useSuspenselessRefetch)((0, $12Kxt.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const isFirstRenderRef = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (isFirstRenderRef.current) // Initial rendering is done after the query is executed by react-resource-router so
        // we do not call refetch
        isFirstRenderRef.current = false;
        else suspenselessRefetch({
            searchString: queryParams[0, $5e130dc454373f11$export$a181206198b7f50c],
            filter: (0, $cYcBU.transformStatusFromParam)(queryParams[0, $5e130dc454373f11$export$3e8168848b996f7]),
            cloudId: cloudId,
            projectKey: currentProjectKey,
            sortBy: {
                sortByField: (0, $cYcBU.transformSortFieldFromParam)(queryParams[0, $5e130dc454373f11$export$a3482d3a8df0e725]),
                order: (0, $cYcBU.transformSortOrderFromParam)(queryParams[0, $5e130dc454373f11$export$71089821f361e881])
            }
        });
    }, [
        cloudId,
        currentProjectKey,
        queryParams,
        suspenselessRefetch
    ]);
    const head = {
        cells: [
            {
                key: 'NAME',
                content: 'Version',
                isSortable: true,
                width: 18
            },
            {
                key: 'STATUS',
                content: 'Status',
                width: 14
            },
            {
                key: 'PROGRESS',
                content: 'Progress',
                width: 18
            },
            {
                key: 'STARTDATE',
                content: 'Start date',
                isSortable: true,
                width: 10
            },
            {
                key: 'RELEASEDATE',
                content: 'Release date',
                isSortable: true,
                width: 10
            },
            {
                key: 'DESCRIPTION',
                content: 'Description',
                isSortable: true
            },
            {
                key: 'ACTIONS',
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $fb92e0c1960c6739$var$headStyles
                }, formatMessage((0, $lAMEV.default).moreActionsLabel)),
                isSortable: false,
                width: canAtleastOneVersionQuickRelease() ? 13 : 10
            }
        ]
    };
    const handleRankEnd = (rankEnd)=>{
        // Don't do anything if there is only one record in the connection
        if (totalCount === 1) return;
        const { sourceKey: sourceKey, destination: destination } = rankEnd;
        if (destination == null) return;
        const { afterKey: afterKey, beforeKey: beforeKey } = destination;
        const updateStoreParams = {
            connectionId: connectionId,
            sourceVersionAri: sourceKey
        };
        if (afterKey === undefined) {
            moveVersionToEnd({
                variables: {
                    input: {
                        id: sourceKey
                    }
                },
                optimisticUpdater: (store)=>(0, $89ror.updateStoreOnMove)({
                        ...updateStoreParams,
                        store: store,
                        operationType: 'move-to-end'
                    }),
                updater: (store)=>(0, $89ror.updateStoreOnMove)({
                        ...updateStoreParams,
                        store: store,
                        operationType: 'move-to-end'
                    })
            });
            return;
        }
        if (beforeKey === undefined) moveVersionToStart({
            variables: {
                input: {
                    id: sourceKey
                }
            },
            optimisticUpdater: (store)=>(0, $89ror.updateStoreOnMove)({
                    ...updateStoreParams,
                    store: store,
                    operationType: 'move-to-start'
                }),
            updater: (store)=>(0, $89ror.updateStoreOnMove)({
                    ...updateStoreParams,
                    store: store,
                    operationType: 'move-to-start'
                })
        });
        else updateVersionPosition({
            variables: {
                input: {
                    id: sourceKey,
                    afterVersionId: beforeKey
                }
            },
            optimisticUpdater: (store)=>(0, $89ror.updateStoreOnMove)({
                    ...updateStoreParams,
                    store: store,
                    operationType: 'move-position',
                    beforeVersionAri: beforeKey
                }),
            updater: (store)=>(0, $89ror.updateStoreOnMove)({
                    ...updateStoreParams,
                    store: store,
                    operationType: 'move-position',
                    beforeVersionAri: beforeKey
                })
        });
    };
    const getAppearanceFromStatus = (status)=>{
        let appearance;
        switch(status){
            case 0, $5e130dc454373f11$export$b983f2cb1f658a55:
                appearance = 'success';
                break;
            case 0, $5e130dc454373f11$export$cb459d726a8530a5:
                appearance = 'inprogress';
                break;
            case 0, $5e130dc454373f11$export$c936349447a77fe0:
            default:
                appearance = 'default';
        }
        return appearance;
    };
    const rows = ()=>data?.jira?.jiraProjectByKey.versions?.edges?.map((edge)=>edge?.node).filter(Boolean).map((node)=>{
            const cells = [
                {
                    key: 'NAME',
                    content: /* @ts-expect-error - Property 'onClick' is missing in type '{ jiraVersion: { readonly allIssues: { readonly totalCount: number | null | undefined; } | null | undefined; readonly description: string | null | undefined; readonly doneIssues: { readonly totalCount: number | ... 1 more ... | undefined; } | null | undefined; ... 5 more ...; readonly " $fragmentSpreads": FragmentRe...' but required in type 'Props'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYHXH.default), {
                        jiraVersion: node,
                        jiraProject: data?.jira?.jiraProjectByKey
                    })
                },
                {
                    key: 'STATUS',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                        appearance: getAppearanceFromStatus(node?.status)
                    }, node?.status)
                },
                {
                    key: 'PROGRESS',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
                        fallback: "unmount",
                        packageName: "jiraProjectVersions",
                        teamName: "jolt",
                        id: "releasesVersionProgressBar"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gu0u0.default), {
                        query: node
                    }))
                },
                {
                    key: 'STARTDATE',
                    content: node?.startDate ? (0, $cYcBU.getFormattedVersionDate)(node?.startDate, formatDate) : null
                },
                {
                    key: 'RELEASEDATE',
                    content: node?.releaseDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nIFm.ReleaseDateCell), {
                        releaseDate: node?.releaseDate,
                        overdue: !!node?.overdue
                    }) : null
                },
                {
                    key: 'DESCRIPTION',
                    content: node?.description
                }
            ];
            const adminCells = ((0, $4cTDP.fg)('vmc-11-manage-versions-permission') ? canEditVersions : isAdmin || isProjectAdmin) ? [
                {
                    key: 'actions',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
                        fallback: "unmount",
                        packageName: "jiraProjectVersions",
                        teamName: "jolt",
                        id: "releasesActionsMenu"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5KSWe.default), {
                        jiraVersion: node,
                        jiraProject: data?.jira.jiraProjectByKey,
                        showSpinner: isLoading,
                        connectionId: connectionId
                    }))
                }
            ] : [];
            return {
                key: node.id,
                cells: [
                    ...cells,
                    ...adminCells
                ]
            };
        });
    const loadedVersionCount = rows?.length || 0;
    const numVersionsToPaginateIn = Math.min((0, $5e130dc454373f11$export$cb638d1fae624fbf), Math.max(0, totalCount - loadedVersionCount));
    const orderField = queryParams[0, $5e130dc454373f11$export$a3482d3a8df0e725];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "project-directories.versions.main.table.table-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
        caption: formatMessage((0, $lAMEV.default).releaseVersionsTableLabel),
        head: head,
        rows: rows(),
        loadingSpinnerSize: "large",
        isRankable: isTableRankable,
        onRankEnd: handleRankEnd,
        isLoading: isLoading,
        isFixedSize: true,
        onSort: (e)=>{
            onSortUpdateQueryParams(e.key, e.sortOrder);
        },
        sortKey: orderField !== 'RANK' ? orderField : undefined,
        sortOrder: (0, $cYcBU.transformSortOrderFromParam)(queryParams[0, $5e130dc454373f11$export$71089821f361e881]),
        emptyView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3PDhY.default), {
            statusFilter: (0, $cYcBU.transformStatusFromParam)(queryParams[0, $5e130dc454373f11$export$3e8168848b996f7]),
            searchFilter: queryParams[0, $5e130dc454373f11$export$a181206198b7f50c]
        })
    }), hasNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        isLoading: isLoadingNext,
        onClick: (_e, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'showMoreButton');
            loadNext(numVersionsToPaginateIn);
        }
    }, formatMessage((0, $lAMEV.default).showMore, {
        count: numVersionsToPaginateIn
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb92e0c1960c6739$var$VersionFetchAnalytics, {
        isLoading: isLoading,
        totalCount: totalCount
    }));
};
var $fb92e0c1960c6739$export$2e2bcd8739ae039 = $fb92e0c1960c6739$var$Table;
const $fb92e0c1960c6739$var$headStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    paddingInlineEnd: 'space.050',
    justifyContent: 'end'
});

});
parcelRegister("1doM0", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce97075db6abfc02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98fa8e73f33cccf844fc94939fab2e4a>>
 * @relayHash 21ed6d73126532152c226700f74fa15b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59a84b940089ef439c94bc268f68bb3456ce8acf0dbabbcd0e2403aeaa627bc2
const $ce97075db6abfc02$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraUpdateVersionPayload",
                    "kind": "LinkedField",
                    "name": "moveJiraVersionToEnd",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "table_moveVersionToEndMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "table_moveVersionToEndMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "59a84b940089ef439c94bc268f68bb3456ce8acf0dbabbcd0e2403aeaa627bc2",
            "metadata": {},
            "name": "table_moveVersionToEndMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ce97075db6abfc02$var$node.hash = "245d2bb9c0de6e4e57289b64dc0c5201";
var $ce97075db6abfc02$export$2e2bcd8739ae039 = $ce97075db6abfc02$var$node;

});

parcelRegister("fwiHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d421d680e5ad58f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db6c0abdd6d93b8d0fed4fac921c939c>>
 * @relayHash 32a17639683e9787cd0d4b3e77e4a25d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b35ac2c9fb6cf1ee425dc5e7f3398eec80f51f8cc50e9d8213ade874f62c00a1
const $9d421d680e5ad58f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraUpdateVersionPayload",
                    "kind": "LinkedField",
                    "name": "moveJiraVersionToStart",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "table_moveVersionToStartMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "table_moveVersionToStartMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "b35ac2c9fb6cf1ee425dc5e7f3398eec80f51f8cc50e9d8213ade874f62c00a1",
            "metadata": {},
            "name": "table_moveVersionToStartMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9d421d680e5ad58f$var$node.hash = "77939c4fcd78faef0ac2c9e07c8398a6";
var $9d421d680e5ad58f$export$2e2bcd8739ae039 = $9d421d680e5ad58f$var$node;

});

parcelRegister("5EXaK", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f35eeeeec265844$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e662db5156051e745fc55338b99980eb>>
 * @relayHash 34e0c09a47a465c4beae8fe001594b5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15ad5ee8e61447c764ac80e10cc756df9689df6c4dadb969daa52a50669e5642
const $8f35eeeeec265844$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraUpdateVersionPayload",
                    "kind": "LinkedField",
                    "name": "updateJiraVersionPosition",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "table_updateJiraVersionPositionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "table_updateJiraVersionPositionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "15ad5ee8e61447c764ac80e10cc756df9689df6c4dadb969daa52a50669e5642",
            "metadata": {},
            "name": "table_updateJiraVersionPositionMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8f35eeeeec265844$var$node.hash = "28f8db8e730d8adacf8286693c281f13";
var $8f35eeeeec265844$export$2e2bcd8739ae039 = $8f35eeeeec265844$var$node;

});

parcelRegister("bxzUg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1d51769d0a30e3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98a06f3e327acfab3599f483a1e87418>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $12Kxt = parcelRequire("12Kxt");
const $d1d51769d0a30e3f$var$node = function() {
    var v0 = [
        "jira",
        "jiraProjectByKey",
        "versions"
    ], v1 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v2 = [
        v1 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": [
                    "UNRELEASED"
                ],
                "kind": "LocalArgument",
                "name": "filter"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isManageVersionsPermissionEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchString"
            },
            {
                "defaultValue": {
                    "order": "DESC",
                    "sortByField": "SEQUENCE"
                },
                "kind": "LocalArgument",
                "name": "sortBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $12Kxt.default)
            }
        },
        "name": "table_projectVersions",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "key",
                                        "variableName": "projectKey"
                                    }
                                ],
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.key"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "name_projectVersions_NameCell_jiraProject"
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "isManageVersionsPermissionEnabled",
                                                "variableName": "isManageVersionsPermissionEnabled"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "actions_projectVersions_ActionsCell_jiraProject"
                                    },
                                    {
                                        "condition": "isManageVersionsPermissionEnabled",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "alias": "canEditVersions",
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "type",
                                                        "value": "MANAGE_VERSIONS"
                                                    }
                                                ],
                                                "concreteType": "JiraProjectAction",
                                                "kind": "LinkedField",
                                                "name": "action",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.canEditVersions.canPerform"
                                                    }
                                                ],
                                                "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "alias": "versions",
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "filter",
                                                    "variableName": "filter"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "searchString",
                                                    "variableName": "searchString"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "sortBy",
                                                    "variableName": "sortBy"
                                                }
                                            ],
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "__uiProject__versions_connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v1 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.jiraProjectByKey.versions.totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "description"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "startDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "releaseDate"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "overdue"
                                                                },
                                                                {
                                                                    "alias": "allIssues",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "filter",
                                                                            "value": "ALL"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": v2 /*: any*/ ,
                                                                    "storageKey": "issues(filter:\"ALL\")"
                                                                },
                                                                {
                                                                    "alias": "doneIssues",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "filter",
                                                                            "value": "DONE"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": v2 /*: any*/ ,
                                                                    "storageKey": "issues(filter:\"DONE\")"
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "progressBar_projectVersions_VersionProgress"
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "name_projectVersions_NameCell_jiraVersion"
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "actions_projectVersions_ActionsCell_jiraVersion"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.jiraProjectByKey.versions.__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraProjectByKey.versions"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jiraProjectByKey"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$d1d51769d0a30e3f$var$node.hash = "cf9237bc92fce2676b1bfc7b6dbe5172";
var $d1d51769d0a30e3f$export$2e2bcd8739ae039 = $d1d51769d0a30e3f$var$node;

});
parcelRegister("12Kxt", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd2283d2ebc68468$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f9591297349abe4f2a0069e3749cf83>>
 * @relayHash 721e010c554f96a80cc0e7b4c8b01b35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8bc1540bd4922e74c0118dda4a1a405f059de90be1142b8d8648f83bad666aed
const $bd2283d2ebc68468$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": [
                "UNRELEASED"
            ],
            "kind": "LocalArgument",
            "name": "filter"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isManageVersionsPermissionEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "searchString"
        },
        {
            "defaultValue": {
                "order": "DESC",
                "sortByField": "SEQUENCE"
            },
            "kind": "LocalArgument",
            "name": "sortBy"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "Variable",
        "name": "searchString",
        "variableName": "searchString"
    }, v5 = {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": "DONE"
        }
    ], v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectVersion_PaginationQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isManageVersionsPermissionEnabled",
                            "variableName": "isManageVersionsPermissionEnabled"
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "table_projectVersions"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectVersion_PaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "key",
                                    "variableName": "projectKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                v6 /*: any*/ ,
                                {
                                    "condition": "isManageVersionsPermissionEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "canEditVersions",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "MANAGE_VERSIONS"
                                                }
                                            ],
                                            "concreteType": "JiraProjectAction",
                                            "kind": "LinkedField",
                                            "name": "action",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPerform"
                                                }
                                            ],
                                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "releaseDate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "overdue"
                                                        },
                                                        {
                                                            "alias": "allIssues",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "ALL"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"ALL\")"
                                                        },
                                                        {
                                                            "alias": "doneIssues",
                                                            "args": v10 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "done",
                                                            "args": v10 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"DONE\")"
                                                        },
                                                        {
                                                            "alias": "inProgress",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "IN_PROGRESS"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                        },
                                                        {
                                                            "alias": "toDo",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": "TODO"
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": v9 /*: any*/ ,
                                                            "storageKey": "issues(filter:\"TODO\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "searchString",
                                        "sortBy"
                                    ],
                                    "handle": "connection",
                                    "key": "uiProject__versions",
                                    "kind": "LinkedHandle",
                                    "name": "versions"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8bc1540bd4922e74c0118dda4a1a405f059de90be1142b8d8648f83bad666aed",
            "metadata": {},
            "name": "projectVersion_PaginationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bd2283d2ebc68468$var$node.hash = "cf9237bc92fce2676b1bfc7b6dbe5172";
var $bd2283d2ebc68468$export$2e2bcd8739ae039 = $bd2283d2ebc68468$var$node;

});


parcelRegister("7XH79", function(module, exports) {
$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $a5387c0f4da0e3f5$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $a5387c0f4da0e3f5$export$c7ce5f64dc007896);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4im1M = parcelRequire("4im1M");
const $a5387c0f4da0e3f5$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $eJOHy.useRef)([]);
    return (0, $eJOHy.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $a5387c0f4da0e3f5$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const isMounted = (0, $4im1M.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $a5387c0f4da0e3f5$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const [_, startTransition] = (0, $eJOHy.useTransition)();
    return (0, $eJOHy.useCallback)((variables, options)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $j4oe4.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                            options?.onComplete?.();
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $a5387c0f4da0e3f5$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $eJOHy.useState)(null);
    const refetchFunction = $a5387c0f4da0e3f5$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("4im1M", function(module, exports) {
$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("lOOiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("aXVGO", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("khVsD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("1NCSA", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});



parcelRegister("iXYwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {
$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r1uh4 _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syazazsu _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});




parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});


parcelRegister("5KSWe", function(module, exports) {
$parcel$export(module.exports, "default", () => $23482f0362b9a850$export$2e2bcd8739ae039);

var $at5j4 = parcelRequire("at5j4");

var $hSjHN = parcelRequire("hSjHN");

var $eG8nm = parcelRequire("eG8nm");

var $3lqQM = parcelRequire("3lqQM");

var $fduLD = parcelRequire("fduLD");

var $kil6R = parcelRequire("kil6R");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $956it = parcelRequire("956it");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $jOLxk = parcelRequire("jOLxk");

var $as6H2 = parcelRequire("as6H2");

var $5vQ2T = parcelRequire("5vQ2T");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $2imLM = parcelRequire("2imLM");

var $kRgKj = parcelRequire("kRgKj");

var $dZRaT = parcelRequire("dZRaT");

var $jom8W = parcelRequire("jom8W");

var $e8cgA = parcelRequire("e8cgA");

var $mJjwL = parcelRequire("mJjwL");

var $lP5IJ = parcelRequire("lP5IJ");

var $kqiAw = parcelRequire("kqiAw");

var $nmowR = parcelRequire("nmowR");

var $f2sjT = parcelRequire("f2sjT");

var $cHtIB = parcelRequire("cHtIB");

var $1M2hR = parcelRequire("1M2hR");

var $cvuNR = parcelRequire("cvuNR");

var $8sQb9 = parcelRequire("8sQb9");

var $eJrcF = parcelRequire("eJrcF");

var $kqd31 = parcelRequire("kqd31");

var $4cTDP = parcelRequire("4cTDP");

var $lY5Wl = parcelRequire("lY5Wl");

var $gVv7l = parcelRequire("gVv7l");

var $eYqSo = parcelRequire("eYqSo");


var $cFcNJ = parcelRequire("cFcNJ");
const $23482f0362b9a850$var$DropdownItemWithAnalytics = (0, $as6H2.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default));
const $23482f0362b9a850$var$getHasReleaseNote = async (versionId, environment)=>{
    try {
        const data = await (0, $j4oe4.fetchQuery)(environment, (0, $kil6R.default), {
            versionId: versionId
        }).toPromise();
        return data?.jira?.version?.hasReleaseNote ?? false;
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'jiraProjectVersionsHasReleaseNoteQuery',
                packageName: 'jiraProjectVersions',
                teamName: 'jolt'
            },
            error: new Error('Unable to get "hasReleaseNote" for "release version" modal')
        });
        return false;
    }
};
const $23482f0362b9a850$var$useHasReleaseNote = (versionId, shouldLoadHasReleaseNote)=>{
    const [hasReleaseNote, setHasReleaseNote] = (0, $eJOHy.useState)(null);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldLoadHasReleaseNote) $23482f0362b9a850$var$getHasReleaseNote(versionId, environment).then(setHasReleaseNote);
    }, [
        versionId,
        environment,
        shouldLoadHasReleaseNote
    ]);
    return hasReleaseNote;
};
const $23482f0362b9a850$var$ActionsCell = ({ jiraVersion: jiraVersion, jiraProject: jiraProject, showSpinner: showSpinner, connectionId: connectionId })=>{
    const version = (0, $j4oe4.useFragment)((0, $fduLD.default), jiraVersion);
    const project = (0, $j4oe4.useFragment)((0, $3lqQM.default), jiraProject);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const locale = (0, $1M2hR.useLocale)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const projectContext = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const canEditVersions = (0, $4cTDP.fg)('vmc-11-manage-versions-permission') && project?.canEditVersions?.canPerform;
    const isProjectAdmin = projectContext?.data?.isProjectAdmin || false;
    const isSimplified = projectContext?.data?.simplified || false;
    const projectKey = project.key;
    const projectAri = project.id;
    const [editReleaseFormQueryRef, loadEditReleaseModalQuery] = (0, $j4oe4.useQueryLoader)((0, $lY5Wl.default));
    const [releaseNotesQueryRef, loadReleaseNotesQuery] = (0, $j4oe4.useQueryLoader)((0, $gVv7l.default));
    const [mergeReleaseFormQueryRef, loadMergeReleaseModalQuery] = (0, $j4oe4.useQueryLoader)((0, $eYqSo.default));
    const loadEditQuery = ()=>{
        if (!editReleaseFormQueryRef) loadEditReleaseModalQuery({
            versionAri: version.id
        });
    };
    const loadCreateReleaseNotesQuery = ()=>{
        if (!releaseNotesQueryRef) loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
    };
    const loadMergeQuery = ()=>{
        if (!mergeReleaseFormQueryRef) loadMergeReleaseModalQuery({
            projectAri: projectAri
        });
    };
    const editExperienceStart = (0, $mJjwL.useEditReleaseExperienceStart)((0, $5e130dc454373f11$export$c5ed97509d0e2aaf));
    const mergeExperienceStart = (0, $lP5IJ.useMergeReleaseExperienceStart)((0, $5e130dc454373f11$export$c5ed97509d0e2aaf)); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionReleased] = (0, $j4oe4.useMutation)((0, $eG8nm.default)); // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [updateVersionArchived] = (0, $j4oe4.useMutation)((0, $hSjHN.default));
    const [deleteVersionWithNoIssues] = (0, $j4oe4.useMutation)((0, $at5j4.default));
    const [editVersionModalOpen, setEditVersionModalOpen] = (0, $eJOHy.useState)(false);
    const [isReleaseModalOpen, setIsReleaseModalOpen] = (0, $eJOHy.useState)(false);
    const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = (0, $eJOHy.useState)(false);
    const [isDeleteVersionModalOpen, setIsDeleteVersionModalOpen] = (0, $eJOHy.useState)(false);
    const [mergeVersionModalOpen, setMergeVersionModalOpen] = (0, $eJOHy.useState)(false);
    const hasReleaseNote = $23482f0362b9a850$var$useHasReleaseNote(version.id, isReleaseModalOpen);
    const canMergeVersions = ()=>!isSimplified;
    const canBeReleased = ()=>version.status !== 'RELEASED' && version.status !== 'ARCHIVED';
    const canBeArchived = ()=>version.status !== 'ARCHIVED';
    const canBeUnreleased = ()=>version.status === 'RELEASED';
    const canDelete = ()=>(0, $4cTDP.fg)('vmc-11-manage-versions-permission') ? canEditVersions : isProjectAdmin;
    const canQuickRelease = ()=>version.status === 'UNRELEASED' && version.allIssues.totalCount > 0 && version.allIssues.totalCount === version.doneIssues.totalCount;
    const onReleaseClicked = ()=>{
        if (!(0, $jom8W.isDevopsFeatureDisabledInFedRamp)()) loadCreateReleaseNotesQuery();
        setIsReleaseModalOpen(true);
    };
    const reportError = ({ metaId: metaId, errorMessage: errorMessage, messageId: messageId, title: title, description: description })=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: metaId,
                packageName: 'jiraProjectVersions',
                teamName: 'jolt'
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            type: 'error',
            title: title,
            description: description,
            messageId: messageId,
            messageType: 'transactional'
        });
    };
    const onUnreleaseClicked = ()=>{
        updateVersionReleased({
            variables: {
                input: {
                    id: version.id,
                    isReleased: false
                }
            },
            onCompleted: (data)=>{
                const success = data?.jira?.updateVersionReleasedStatus?.success;
                if (success || !(0, $4cTDP.fg)('jira-versions-list-success-false-error-handling')) showFlag({
                    type: 'success',
                    title: [
                        (0, $cFcNJ.default).unReleaseTitle,
                        {
                            name: version.name
                        }
                    ],
                    messageId: 'project-versions.ui.table.actions.show-flag.success.on-unrelease-clicked.on-completed.show-flag.success',
                    messageType: 'transactional'
                });
                else reportError({
                    metaId: 'jiraProjectVersionsUnReleaseMutation',
                    errorMessage: 'Update version released status returned success=false',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-unrelease-clicked.on-completed.success-false',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).releaseFailedFlagDescription
                });
            },
            onError: ()=>{
                reportError({
                    metaId: 'jiraProjectVersionsUnReleaseMutation',
                    errorMessage: 'Unable to update version released status',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-unrelease-clicked.on-error.show-flag.error',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).releaseFailedFlagDescription
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionReleasedStatus: {
                        success: true,
                        version: {
                            id: version.id,
                            status: (0, $5e130dc454373f11$export$cb459d726a8530a5)
                        }
                    }
                }
            }
        });
    };
    const onArchiveClicked = ()=>{
        updateVersionArchived({
            variables: {
                input: {
                    id: version.id,
                    isArchived: true
                }
            },
            onCompleted: (data)=>{
                const success = data?.jira?.updateVersionArchivedStatus?.success;
                if (success || !(0, $4cTDP.fg)('jira-versions-list-success-false-error-handling')) showFlag({
                    type: 'success',
                    title: [
                        (0, $cFcNJ.default).archiveTitle,
                        {
                            name: version.name
                        }
                    ],
                    messageId: 'project-versions.ui.table.actions.show-flag.success.on-archive-clicked.on-completed.show-flag.success',
                    messageType: 'transactional'
                });
                else reportError({
                    metaId: 'jiraProjectVersionsArchiveMutation',
                    errorMessage: 'Update version archived status returned success=false',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-archive-clicked.on-completed.success-false',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).archiveFailedFlagDescription
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionArchivedStatus: {
                        success: true,
                        version: {
                            id: version.id,
                            status: (0, $5e130dc454373f11$export$c936349447a77fe0)
                        }
                    }
                }
            },
            onError: ()=>{
                reportError({
                    metaId: 'jiraProjectVersionsArchiveMutation',
                    errorMessage: 'Unable to update version archived status',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-archive-clicked.on-error.show-flag.error',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).archiveFailedFlagDescription
                });
            }
        });
    };
    const onUnarchiveClicked = ()=>{
        updateVersionArchived({
            variables: {
                input: {
                    id: version.id,
                    isArchived: false
                }
            },
            onCompleted: (data)=>{
                const success = data?.jira?.updateVersionArchivedStatus?.success;
                if (success || !(0, $4cTDP.fg)('jira-versions-list-success-false-error-handling')) showFlag({
                    type: 'success',
                    title: [
                        (0, $cFcNJ.default).unarchiveTitle,
                        {
                            name: version.name
                        }
                    ],
                    messageId: 'project-versions.ui.table.actions.show-flag.success.on-unarchive-clicked.on-completed.show-flag.success',
                    messageType: 'transactional'
                });
                else reportError({
                    metaId: 'jiraProjectVersionsUnArchiveMutation',
                    errorMessage: 'Update version archived status returned success=false',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-unarchive-clicked.on-completed.success-false',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).archiveFailedFlagDescription
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionArchivedStatus: {
                        success: true,
                        version: {
                            id: version.id,
                            status: (0, $5e130dc454373f11$export$cb459d726a8530a5)
                        }
                    }
                }
            },
            onError: ()=>{
                reportError({
                    metaId: 'jiraProjectVersionsUnArchiveMutation',
                    errorMessage: 'Unable to update version archived status',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-unarchive-clicked.on-error.show-flag.error',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).archiveFailedFlagDescription
                });
            }
        });
    };
    const onMergeClicked = ()=>{
        mergeExperienceStart();
        setMergeVersionModalOpen(true);
    };
    const onEditClicked = ()=>{
        editExperienceStart();
        setEditVersionModalOpen(true);
    };
    const onDeleteClicked = ()=>{
        if (version.allIssues.totalCount) setIsDeleteVersionModalOpen(true);
        else deleteVersionWithNoIssues({
            variables: {
                input: {
                    id: version.id
                }
            },
            optimisticUpdater: updateStoreOnDeleteVersionWithNoIssues,
            updater: updateStoreOnDeleteVersionWithNoIssues,
            onCompleted: (data)=>{
                const success = data?.jira?.deleteJiraVersionWithNoIssues?.success;
                if (success || !(0, $4cTDP.fg)('jira-versions-list-success-false-error-handling')) showFlag({
                    type: 'success',
                    title: formatMessage((0, $cFcNJ.default).deleteTitle, {
                        name: version.name
                    }),
                    testId: 'project-directories.versions.flags.delete.success',
                    messageId: 'project-versions.ui.table.actions.show-flag.success.on-delete-clicked.on-completed.show-flag.success',
                    messageType: 'transactional'
                });
                else reportError({
                    metaId: 'jiraProjectVersionsDeleteVersionWithNoIssuesMutation',
                    errorMessage: 'Unable to delete version',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-delete-clicked.on-error.show-flag.error',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).deleteFailedDescription
                });
            },
            onError: ()=>{
                reportError({
                    metaId: 'jiraProjectVersionsDeleteVersionWithNoIssuesMutation',
                    errorMessage: 'Unable to delete version',
                    messageId: 'project-versions.ui.table.actions.show-flag.error.on-delete-clicked.on-error.show-flag.error',
                    title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                    description: (0, $cFcNJ.default).deleteFailedDescription
                });
            }
        });
    };
    const updateStoreOnReleased = ()=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const dataID = (0, $kqd31.default)({
                id: version.id
            }, 'JiraVersion') ?? '';
            const versionRecord = store.get(dataID);
            if (versionRecord) versionRecord.setValue((0, $5e130dc454373f11$export$b983f2cb1f658a55), 'status');
        });
    };
    const updateStoreOnDelete = (targetVersionId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            const getVersionLinkedRecordByStatus = (record, status)=>record.getLinkedRecord(`issues(filter:"${status}")`);
            const getVersionIssueCountByStatus = (record, status)=>Number(getVersionLinkedRecordByStatus(record, status)?.getValue('totalCount')) || 0;
            if (connectionId) {
                const connectionRecord = store.get(connectionId);
                if (connectionRecord) {
                    if (targetVersionId) {
                        const targetVersionAri = (0, $jOLxk.JiraVersionAri).create({
                            siteId: cloudId,
                            activationId: activationId,
                            versionId: targetVersionId
                        }).toString();
                        const targetVersionRecord = store.get((0, $kqd31.default)({
                            id: targetVersionAri
                        }, 'JiraVersion') ?? '');
                        const sourceVersionRecord = store.get((0, $kqd31.default)({
                            id: version.id
                        }, 'JiraVersion') ?? '');
                        if (targetVersionRecord && sourceVersionRecord) [
                            'ALL',
                            'TODO',
                            'IN_PROGRESS',
                            'DONE'
                        ].forEach((status)=>{
                            getVersionLinkedRecordByStatus(targetVersionRecord, status).setValue(getVersionIssueCountByStatus(targetVersionRecord, status) + getVersionIssueCountByStatus(sourceVersionRecord, status), 'totalCount');
                        });
                    }
                    (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, version.__id);
                }
            }
        });
    };
    const updateStoreOnDeleteVersionWithNoIssues = (store)=>{
        const deletedVersionRecord = store.get((0, $kqd31.default)({
            id: version.id
        }, 'JiraVersion') ?? '');
        if (deletedVersionRecord) store.delete(deletedVersionRecord.getDataID());
    };
    const renderReleaseButton = ()=>{
        if (!canQuickRelease()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23482f0362b9a850$var$ButtonGroupItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            isDisabled: showSpinner,
            onClick: onReleaseClicked
        }, formatMessage((0, $cFcNJ.default).releaseAction)));
    };
    const renderDropdownItem = (action, message, analyticsEventTitle, href, testId, disabledTooltipMessage, preload)=>{
        const otherProps = testId ? {
            'data-test-id': testId
        } : {};
        if (disabledTooltipMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage(disabledTooltipMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: action,
            isDisabled: true,
            href: href,
            ...otherProps,
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage(message)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            onFocus: preload || undefined,
            onMouseOver: preload || undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23482f0362b9a850$var$DropdownItemWithAnalytics // @ts-expect-error - Type '(_e: React.MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'.
        , {
            onClick: (_e, analyticsEvent)=>{
                (0, $kRgKj.fireUIAnalytics)(analyticsEvent, analyticsEventTitle);
                action();
            },
            href: href,
            ...otherProps
        }, formatMessage(message)));
    };
    const renderDropdownGroup = ()=>{
        if (!canBeArchived()) {
            const innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderDropdownItem(onUnarchiveClicked, (0, $cFcNJ.default).unarchiveAction, 'unarchive'), canMergeVersions() ? renderDropdownItem(onMergeClicked, (0, $cFcNJ.default).mergeAction, 'merge', undefined, undefined, undefined, loadMergeQuery) : null, renderDropdownItem(onEditClicked, (0, $cFcNJ.default).editAction, 'edit', undefined, undefined, undefined, loadEditQuery), renderDropdownItem(onDeleteClicked, (0, $cFcNJ.default).deleteAction, 'delete', undefined, undefined, !canDelete() ? (0, $cFcNJ.default).deleteActionDisabledTooltip : undefined));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, innerContent);
        }
        const innerContentDefault = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !canQuickRelease() && canBeReleased() ? renderDropdownItem(onReleaseClicked, (0, $cFcNJ.default).releaseAction, 'release', undefined, 'project-directories.versions.main.release-version-item') : null, canBeUnreleased() ? renderDropdownItem(onUnreleaseClicked, (0, $cFcNJ.default).unreleaseAction, 'unrelease') : null, renderDropdownItem(onArchiveClicked, (0, $cFcNJ.default).archiveAction, 'archive'), canMergeVersions() ? renderDropdownItem(onMergeClicked, (0, $cFcNJ.default).mergeAction, 'merge', undefined, undefined, undefined, loadMergeQuery) : null, renderDropdownItem(onEditClicked, (0, $cFcNJ.default).editAction, 'edit', undefined, undefined, undefined, loadEditQuery), renderDropdownItem(onDeleteClicked, (0, $cFcNJ.default).deleteAction, 'delete', undefined, 'project-directories.versions.main.delete-version-item', !canDelete() ? (0, $cFcNJ.default).deleteActionDisabledTooltip : undefined));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, innerContentDefault);
    };
    const IconBefore = showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $23482f0362b9a850$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
        spacing: "spacious",
        label: formatMessage((0, $cFcNJ.default).moreActionsLabel, {
            versionName: version.name
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23482f0362b9a850$var$ActionsCellWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, renderReleaseButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23482f0362b9a850$var$ButtonGroupItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        shouldRenderToParent: true,
        placement: "bottom-end",
        defaultOpen: false,
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                hideTooltipOnClick: true,
                content: formatMessage((0, $cFcNJ.default).moreActionsTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                onClick: (event, analyticsEvent)=>{
                    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'versionAction');
                    if (onClick != null) onClick(event);
                },
                ref: triggerRef,
                appearance: "subtle",
                iconBefore: IconBefore,
                isDisabled: showSpinner
            }))
    }, renderDropdownGroup()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, editReleaseFormQueryRef && editVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqiAw.EditReleaseModal), {
        versionId: version.versionId,
        isOpen: editVersionModalOpen,
        onClose: ()=>setEditVersionModalOpen(false),
        queryReference: editReleaseFormQueryRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        packageName: "jiraProjectVersions",
        teamName: "jolt",
        id: "releasesReleaseNotesModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "release-notes-modal",
        fallback: null
    }, isReleaseNotesModalOpen && releaseNotesQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8cgA.ReleaseNotesModal), {
        queryReference: releaseNotesQueryRef,
        onClose: ()=>setIsReleaseNotesModalOpen(false)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isReleaseModalOpen && hasReleaseNote !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8sQb9.default // @ts-expect-error - TS2322 - Type '{ locale: Locale; projectKey: string; versionId: string; onOpened: (...args: any[]) => void; onCancel: () => void; onSuccess: () => void; onError: () => void; }' is not assignable to type 'IntrinsicAttributes & StateProps & Handlers & { children?: ReactNode; }'.
    ), {
        locale: locale,
        projectKey: project.key,
        versionId: version.versionId,
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: ()=>setIsReleaseModalOpen(false),
        onSuccess: (_updatedVersion, params)=>{
            setIsReleaseModalOpen(false);
            updateStoreOnReleased();
            if (params && params.shouldRedirectToCreateReleaseNotes) setIsReleaseNotesModalOpen(true);
        },
        onError: ()=>{
            reportError({
                metaId: 'jiraProjectVersionsReleaseModal',
                errorMessage: 'Failed to release the version',
                messageId: 'project-versions.ui.table.actions.show-flag.error.release-modal.on-error.show-flag.error',
                title: (0, $cFcNJ.default).genericUpdateFailedFlagTitle,
                description: (0, $cFcNJ.default).releaseFailedFlagDescription
            });
        },
        shouldShowCreateReleaseNotesOption: !(0, $jom8W.isDevopsFeatureDisabledInFedRamp)(),
        hasReleaseNote: hasReleaseNote ?? false
    })), mergeReleaseFormQueryRef && mergeVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $nmowR.MergeReleaseModal), {
        jiraVersion: version,
        queryReference: mergeReleaseFormQueryRef,
        onClose: ()=>setMergeVersionModalOpen(false)
    }), isDeleteVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        fallback: "flag",
        packageName: "jiraProjectVersions",
        teamName: "jolt",
        id: "releasesDeleteModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cvuNR.default), {
        projectKey: projectKey,
        version: {
            id: version.versionId,
            name: version.name
        },
        onError: ()=>{
            reportError({
                metaId: 'jiraProjectVersionsDeleteModal',
                errorMessage: 'Failed to delete the version',
                messageId: 'project-versions.ui.table.actions.show-flag.error.delete-modal.on-error.show-flag.error',
                title: formatMessage((0, $cFcNJ.default).deleteFailedTitle),
                description: formatMessage((0, $cFcNJ.default).deleteFailedDescription)
            });
        },
        onSuccess: (successParams)=>{
            showFlag({
                type: 'success',
                title: formatMessage((0, $cFcNJ.default).deleteTitle, {
                    name: version.name
                }),
                messageId: 'project-versions.ui.table.actions.show-flag.success.delete-modal.on-success.show-flag.success',
                messageType: 'transactional'
            });
            updateStoreOnDelete(successParams.movedRelatedIssuesTo);
        },
        onCancel: ()=>setIsDeleteVersionModalOpen(false),
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    })));
};
var $23482f0362b9a850$export$2e2bcd8739ae039 = $23482f0362b9a850$var$ActionsCell;
const $23482f0362b9a850$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    height: 'space.025',
    width: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23482f0362b9a850$var$ButtonGroupItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23482f0362b9a850$var$ActionsCellWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21sbv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("at5j4", function(module, exports) {
$parcel$export(module.exports, "default", () => $7720f80b22947199$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<550c3e82f5306d696c8ee96988a77cb1>>
 * @relayHash 645755f269992aa280c50df84ede4be6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c9ba59756316e1ee64f1543626c9781e9bdc074e90056f11cf2c1ae0ed92f25
const $7720f80b22947199$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraUpdateVersionPayload",
                    "kind": "LinkedField",
                    "name": "deleteJiraVersionWithNoIssues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_deleteVersionWithNoIssuesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_deleteVersionWithNoIssuesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5c9ba59756316e1ee64f1543626c9781e9bdc074e90056f11cf2c1ae0ed92f25",
            "metadata": {},
            "name": "actions_deleteVersionWithNoIssuesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7720f80b22947199$var$node.hash = "b81aa40061fe9aaae97b566e66bb6164";
var $7720f80b22947199$export$2e2bcd8739ae039 = $7720f80b22947199$var$node;

});

parcelRegister("hSjHN", function(module, exports) {
$parcel$export(module.exports, "default", () => $841b48b304153665$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eacaadcf72926c0aba5b20c31ab03199>>
 * @relayHash 98fd2b6970f280d77846c12d4fbc3f29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cf4f9a703d62bd2a8533178b0a0aa399f1de2f3c946bddac7ffc8b2f7fbc28f
const $841b48b304153665$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5cf4f9a703d62bd2a8533178b0a0aa399f1de2f3c946bddac7ffc8b2f7fbc28f",
            "metadata": {},
            "name": "actions_updateVersionArchivedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$841b48b304153665$var$node.hash = "072694ea470a98bb3011a1ec0f8078ca";
var $841b48b304153665$export$2e2bcd8739ae039 = $841b48b304153665$var$node;

});

parcelRegister("eG8nm", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb125b949e7003cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dec983d9db54356e7b52612ebd8e07b2>>
 * @relayHash cf2fd9709cd91b06ae7d93597ce4abd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00a59505c39bdec9611c09609b088eb9b01dc4a27e481b28382e3db659bcec17
const $bb125b949e7003cf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "00a59505c39bdec9611c09609b088eb9b01dc4a27e481b28382e3db659bcec17",
            "metadata": {},
            "name": "actions_updateVersionReleasedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$bb125b949e7003cf$var$node.hash = "de8237e18f09aa8fe2fa05dd5d8cd028";
var $bb125b949e7003cf$export$2e2bcd8739ae039 = $bb125b949e7003cf$var$node;

});

parcelRegister("3lqQM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1daf300ce0f978b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f09efc9c650ce75f4ca778895a0d3ee0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1daf300ce0f978b2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isManageVersionsPermissionEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "actions_projectVersions_ActionsCell_jiraProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "condition": "isManageVersionsPermissionEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "canEditVersions",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "MANAGE_VERSIONS"
                        }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            "action": "THROW",
                            "path": "canEditVersions.canPerform"
                        }
                    ],
                    "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$1daf300ce0f978b2$var$node.hash = "d0649a1e75ed2aeb169aade35f2d6e09";
var $1daf300ce0f978b2$export$2e2bcd8739ae039 = $1daf300ce0f978b2$var$node;

});

parcelRegister("fduLD", function(module, exports) {
$parcel$export(module.exports, "default", () => $337eaaa666727f7e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<182e721961a543ba0b9ca69c4ec2aa01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $337eaaa666727f7e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "actions_projectVersions_ActionsCell_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "versionId"
                },
                "action": "THROW",
                "path": "versionId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "status"
                },
                "action": "THROW",
                "path": "status"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "allIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "allIssues.totalCount"
                        }
                    ],
                    "storageKey": "issues(filter:\"ALL\")"
                },
                "action": "THROW",
                "path": "allIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssues",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "DONE"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssues.totalCount"
                        }
                    ],
                    "storageKey": "issues(filter:\"DONE\")"
                },
                "action": "THROW",
                "path": "doneIssues"
            },
            {
                "kind": "FragmentSpread",
                "name": "mergeReleaseModal_softwareReleasesReleaseModalsRelay_jiraVersion"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "__id"
                        },
                        "action": "THROW",
                        "path": "__id"
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
}();
$337eaaa666727f7e$var$node.hash = "de48072074c29111b9724b11cad9c676";
var $337eaaa666727f7e$export$2e2bcd8739ae039 = $337eaaa666727f7e$var$node;

});

parcelRegister("kil6R", function(module, exports) {
$parcel$export(module.exports, "default", () => $2382c0b480869f4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2381eb29b26006c4348f6bd01aaf47b4>>
 * @relayHash c7cac68ba4471f191152224845385747
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f93d76c6ef6566bb8fcd64936b6b1bff727e8f9d0d3cc511066903d28697d6e0
const $2382c0b480869f4c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasReleaseNote"
            }
        ],
        "type": "JiraVersion"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_versionHasReleaseNoteQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_versionHasReleaseNoteQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f93d76c6ef6566bb8fcd64936b6b1bff727e8f9d0d3cc511066903d28697d6e0",
            "metadata": {},
            "name": "actions_versionHasReleaseNoteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2382c0b480869f4c$var$node.hash = "ef82cca181efdaab2168c14aa947a137";
var $2382c0b480869f4c$export$2e2bcd8739ae039 = $2382c0b480869f4c$var$node;

});

parcelRegister("e8cgA", function(module, exports) {
$parcel$export(module.exports, "ReleaseNotesModal", () => $6e88c6a4ef39b384$export$d334132901e7fcb2);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ik0CA = parcelRequire("ik0CA");

var $7ep4S = parcelRequire("7ep4S");

var $4B7rn = parcelRequire("4B7rn");

var $lJKII = parcelRequire("lJKII");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6e88c6a4ef39b384$var$LazyReleaseNotesModalContent = (0, $bQWwW.lazy)(()=>(parcelRequire("hrMIC")).then((module)=>module.ReleaseNotesModalContent), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6e88c6a4ef39b384$var$LazyEmbeddedPageReleaseNotesEditorModal = (0, $bQWwW.lazy)(()=>(parcelRequire("2bWrJ")).then((module)=>module.EmbeddedPageReleaseNotesEditorModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/embedded-page-release-notes-editor-modal/EmbeddedPageReleaseNotesEditorModal.tsx"
});
const $6e88c6a4ef39b384$var$LoadingModalBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    })));
const $6e88c6a4ef39b384$export$d334132901e7fcb2 = (props)=>{
    const [confluenceReleaseNotesDraftUrl, setConfluenceReleaseNotesDraftUrl] = (0, $eJOHy.useState)(null);
    const { onClose: onClose } = props;
    const onCreateConfluenceReleaseNotes = (0, $eJOHy.useCallback)((draftUrl)=>{
        setConfluenceReleaseNotesDraftUrl(draftUrl);
    }, []);
    const onCloseConfluenceReleaseNotes = (0, $eJOHy.useCallback)(()=>{
        setConfluenceReleaseNotesDraftUrl(null);
        onClose();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, confluenceReleaseNotesDraftUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$var$LazyEmbeddedPageReleaseNotesEditorModal, {
        draftUrl: confluenceReleaseNotesDraftUrl,
        onClose: onCloseConfluenceReleaseNotes
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        width: "x-large",
        autoFocus: false,
        onClose: onClose,
        messageId: "software-releases-add-release-notes-modal.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "release-notes-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$var$LoadingModalBody, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6e88c6a4ef39b384$var$LazyReleaseNotesModalContent, {
        ...props,
        onCreateConfluenceReleaseNotes: onCreateConfluenceReleaseNotes
    }))));
};
const $6e88c6a4ef39b384$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kdj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hrMIC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l5M0H").then(()=>parcelRequire('fOGtY'));

});

parcelRegister("2bWrJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dVu8o").then(()=>parcelRequire('4OIqI'));

});


parcelRegister("mJjwL", function(module, exports) {
$parcel$export(module.exports, "useEditReleaseExperienceStart", () => $5b572d9cad11d13e$export$577bb5b810a3f6a6);
$parcel$export(module.exports, "useEditReleaseExperienceFail", () => $5b572d9cad11d13e$export$469ee200c06358a7);
$parcel$export(module.exports, "useEditReleaseExperienceSuccess", () => $5b572d9cad11d13e$export$83d1c1cb383d6e6b);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $5b572d9cad11d13e$export$52919046b94109dc = 'editRelease';
const $5b572d9cad11d13e$export$577bb5b810a3f6a6 = (analyticsSource)=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $5b572d9cad11d13e$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: analyticsSource,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $5b572d9cad11d13e$export$469ee200c06358a7 = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $5b572d9cad11d13e$export$52919046b94109dc
    });
const $5b572d9cad11d13e$export$83d1c1cb383d6e6b = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $5b572d9cad11d13e$export$52919046b94109dc
    });

});

parcelRegister("lP5IJ", function(module, exports) {
$parcel$export(module.exports, "useMergeReleaseExperienceStart", () => $0ef919f8ba6da212$export$c4e891e089b16790);
$parcel$export(module.exports, "useMergeReleaseExperienceFail", () => $0ef919f8ba6da212$export$e8301e99207d212b);
$parcel$export(module.exports, "useMergeReleaseExperienceSuccess", () => $0ef919f8ba6da212$export$d6f0dd934084b04a);

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $lBYgs = parcelRequire("lBYgs");

var $1BZ8a = parcelRequire("1BZ8a");
const $0ef919f8ba6da212$export$52919046b94109dc = 'mergeRelease';
const $0ef919f8ba6da212$export$c4e891e089b16790 = (analyticsSource)=>{
    const appEditions = (0, $1BZ8a.useAppEditions)();
    return (0, $8Uqf3.useExperienceStart)({
        experience: $0ef919f8ba6da212$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: analyticsSource,
        application: (0, $lBYgs.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $0ef919f8ba6da212$export$e8301e99207d212b = ()=>(0, $aqnJa.useExperienceFail)({
        experience: $0ef919f8ba6da212$export$52919046b94109dc
    });
const $0ef919f8ba6da212$export$d6f0dd934084b04a = ()=>(0, $4ctwv.useExperienceSuccess)({
        experience: $0ef919f8ba6da212$export$52919046b94109dc
    });

});

parcelRegister("kqiAw", function(module, exports) {
$parcel$export(module.exports, "EditReleaseModal", () => $115b973c915bd1ce$export$6569c3e6e9f50540);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $mJjwL = parcelRequire("mJjwL");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $115b973c915bd1ce$var$LazyEditReleaseModal = (0, $bQWwW.lazy)(()=>(parcelRequire("cGelx")).then((module)=>module.EditReleaseModal), {
    moduleId: "./src/packages/releases/release-modals-relay/src/ui/edit-release-modal/index.tsx"
});
const $115b973c915bd1ce$export$6569c3e6e9f50540 = (props)=>{
    const experienceFail = (0, $mJjwL.useEditReleaseExperienceFail)();
    return props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraSoftwareReleasesReleaseModalsRelay",
        teamName: "jolt",
        id: "editReleaseModal",
        fallback: "flag",
        onError: (location, error)=>experienceFail(location, error)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "edit-release-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($115b973c915bd1ce$var$LazyEditReleaseModal, props))) : null;
};

});
parcelRegister("cGelx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("g56i4")
]).then(()=>parcelRequire('cPayA'));

});


parcelRegister("nmowR", function(module, exports) {
$parcel$export(module.exports, "MergeReleaseModal", () => $41993f6dc5fb6158$export$d42ace32f7ad150f);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $41993f6dc5fb6158$var$LazyMergeReleaseModal = (0, $bQWwW.lazy)(()=>(parcelRequire("lhLrv")).then((module)=>module.MergeReleaseModal), {
    moduleId: "./src/packages/releases/release-modals-relay/src/ui/merge-release-modal/index.tsx"
});
const $41993f6dc5fb6158$export$d42ace32f7ad150f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "merge-release-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($41993f6dc5fb6158$var$LazyMergeReleaseModal, props));

});
parcelRegister("lhLrv", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l0xyj").then(()=>parcelRequire('1tbmT'));

});


parcelRegister("cvuNR", function(module, exports) {
$parcel$export(module.exports, "default", () => $42575da4739368e5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $j5V5L = parcelRequire("j5V5L");

var $3Tef8 = parcelRequire("3Tef8");

var $5bodI = parcelRequire("5bodI");

var $kQb0T = parcelRequire("kQb0T");

var $eu9jx = parcelRequire("eu9jx");
class $42575da4739368e5$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.store = (0, $kQb0T.default)((0, $3Tef8.default));
        this.store.dispatch((0, $5bodI.initializeAppProps)(this.props));
        this.store.dispatch((0, $5bodI.getRelatedIssuesCount)());
    }
    componentDidUpdate(prevProps) {
        if ((0, $j5V5L.default)(prevProps, this.props)) return;
        this.store.dispatch((0, $5bodI.initializeAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eu9jx.default), null)));
    }
}

});
parcelRegister("3Tef8", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e5c7e2fa0dc9974$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $aTMzC = parcelRequire("aTMzC");

var $5g0z3 = parcelRequire("5g0z3");

var $8EBPl = parcelRequire("8EBPl");

var $8uL3O = parcelRequire("8uL3O");
var $4e5c7e2fa0dc9974$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $8EBPl.epic), (0, $5g0z3.epic), (0, $aTMzC.errorEpic), (0, $aTMzC.successEpic), (0, $aTMzC.cancelEpic), (0, $aTMzC.modalShownEpic), (0, $8uL3O.epic));

});
parcelRegister("aTMzC", function(module, exports) {
$parcel$export(module.exports, "cancelEpic", () => $7d9e7334c7c2b17f$export$54b67771de971d85);
$parcel$export(module.exports, "successEpic", () => $7d9e7334c7c2b17f$export$37094086df254c90);
$parcel$export(module.exports, "modalShownEpic", () => $7d9e7334c7c2b17f$export$b8769bb96f58e8ad);
$parcel$export(module.exports, "errorEpic", () => $7d9e7334c7c2b17f$export$6b665fe9832a87ab);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $5bodI = parcelRequire("5bodI");

var $iRsY0 = parcelRequire("iRsY0");
const $7d9e7334c7c2b17f$export$54b67771de971d85 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $5bodI.CANCEL)).mergeMap(()=>{
        (0, $iRsY0.getCancelCallback)(store.getState())();
        return (0, $7kixv.Observable).empty();
    });
const $7d9e7334c7c2b17f$export$37094086df254c90 = (action$, store)=>action$.ofType((0, $5bodI.DELETION_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        (0, $iRsY0.getSuccessCallback)(state)({
            movedRelatedIssuesTo: (0, $iRsY0.getTargetVersionForFixVersionField)(state)
        });
        return (0, $7kixv.Observable).empty();
    });
const $7d9e7334c7c2b17f$export$b8769bb96f58e8ad = (action$, store)=>action$.ofType((0, $5bodI.SHOW_DIALOG)).mergeMap(()=>{
        const state = store.getState();
        (0, $iRsY0.getModalShownCallback)(state)();
        return (0, $7kixv.Observable).empty();
    });
const $7d9e7334c7c2b17f$export$6b665fe9832a87ab = (action$, store)=>action$.ofType((0, $5bodI.DELETION_FAILURE)).mergeMap((action)=>{
        (0, $iRsY0.getErrorCallback)(store.getState())(action.payload);
        return (0, $7kixv.Observable).empty();
    });

});
parcelRegister("5bodI", function(module, exports) {
$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $a6ee5bb8753d560a$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $a6ee5bb8753d560a$export$5f0e35553cecddfe);
$parcel$export(module.exports, "GET_RELATED_ISSUES_COUNT", () => $a6ee5bb8753d560a$export$615f9c4a62763ff3);
$parcel$export(module.exports, "getRelatedIssuesCount", () => $a6ee5bb8753d560a$export$cbaa0ff7bfb57fc);
$parcel$export(module.exports, "SET_RELATED_ISSUES_COUNT", () => $a6ee5bb8753d560a$export$7e8b8dbf8b2d288c);
$parcel$export(module.exports, "setRelatedIssuesCount", () => $a6ee5bb8753d560a$export$27989d72f62c8ab5);
$parcel$export(module.exports, "SHOW_DIALOG", () => $a6ee5bb8753d560a$export$b41a4d6f993c3c30);
$parcel$export(module.exports, "showDialog", () => $a6ee5bb8753d560a$export$61e0a65f251cfdb3);
$parcel$export(module.exports, "DELETE_VERSION", () => $a6ee5bb8753d560a$export$16dd37fceb6070aa);
$parcel$export(module.exports, "deleteVersion", () => $a6ee5bb8753d560a$export$deb9d79d96b11bc6);
$parcel$export(module.exports, "SET_OPERATION_FOR_FIELD", () => $a6ee5bb8753d560a$export$ae4fc50e7b424b6f);
$parcel$export(module.exports, "setOperationForField", () => $a6ee5bb8753d560a$export$e05bdbc3d852df90);
$parcel$export(module.exports, "SET_VERSION_FOR_FIELD", () => $a6ee5bb8753d560a$export$e2c9bbdeccabda4f);
$parcel$export(module.exports, "setVersionForField", () => $a6ee5bb8753d560a$export$128dcd6805442f12);
$parcel$export(module.exports, "DELETION_SUCCESS", () => $a6ee5bb8753d560a$export$e212c7761003d0c0);
$parcel$export(module.exports, "deletionSuccess", () => $a6ee5bb8753d560a$export$ac8a826dc2795329);
$parcel$export(module.exports, "DELETION_FAILURE", () => $a6ee5bb8753d560a$export$3e9642deec0d27d1);
$parcel$export(module.exports, "deletionFailure", () => $a6ee5bb8753d560a$export$c94cb18caba25f86);
$parcel$export(module.exports, "CANCEL", () => $a6ee5bb8753d560a$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $a6ee5bb8753d560a$export$70b61ad426ddbe54);
const $a6ee5bb8753d560a$export$84856e4ae7cd7538 = 'delete-version.state.INITIALIZE_APP_PROPS';
const $a6ee5bb8753d560a$export$5f0e35553cecddfe = (appProps)=>({
        type: $a6ee5bb8753d560a$export$84856e4ae7cd7538,
        payload: appProps
    });
const $a6ee5bb8753d560a$export$615f9c4a62763ff3 = 'delete-version.state.GET_RELATED_ISSUES_COUNT';
const $a6ee5bb8753d560a$export$cbaa0ff7bfb57fc = ()=>({
        type: $a6ee5bb8753d560a$export$615f9c4a62763ff3
    });
const $a6ee5bb8753d560a$export$7e8b8dbf8b2d288c = 'delete-version.state.SET_RELATED_ISSUES_COUNT';
const $a6ee5bb8753d560a$export$27989d72f62c8ab5 = (payload)=>({
        type: $a6ee5bb8753d560a$export$7e8b8dbf8b2d288c,
        payload: payload
    });
const $a6ee5bb8753d560a$export$b41a4d6f993c3c30 = 'delete-version.state.SHOW_DIALOG';
const $a6ee5bb8753d560a$export$61e0a65f251cfdb3 = ()=>({
        type: $a6ee5bb8753d560a$export$b41a4d6f993c3c30
    });
const $a6ee5bb8753d560a$export$16dd37fceb6070aa = 'delete-version.state.DELETE_VERSION';
const $a6ee5bb8753d560a$export$deb9d79d96b11bc6 = ()=>({
        type: $a6ee5bb8753d560a$export$16dd37fceb6070aa
    });
const $a6ee5bb8753d560a$export$ae4fc50e7b424b6f = 'delete-version.state.SET_OPERATION_FOR_FIELD';
const $a6ee5bb8753d560a$export$e05bdbc3d852df90 = (payload)=>({
        type: $a6ee5bb8753d560a$export$ae4fc50e7b424b6f,
        payload: payload
    });
const $a6ee5bb8753d560a$export$e2c9bbdeccabda4f = 'delete-version.state.SET_VERSION_FOR_FIELD';
const $a6ee5bb8753d560a$export$128dcd6805442f12 = (payload)=>({
        type: $a6ee5bb8753d560a$export$e2c9bbdeccabda4f,
        payload: payload
    });
const $a6ee5bb8753d560a$export$e212c7761003d0c0 = 'delete-version.state.DELETION_SUCCESS';
const $a6ee5bb8753d560a$export$ac8a826dc2795329 = ()=>({
        type: $a6ee5bb8753d560a$export$e212c7761003d0c0
    });
const $a6ee5bb8753d560a$export$3e9642deec0d27d1 = 'delete-version.state.DELETION_FAILURE';
const $a6ee5bb8753d560a$export$c94cb18caba25f86 = (payload)=>({
        type: $a6ee5bb8753d560a$export$3e9642deec0d27d1,
        payload: payload
    });
const $a6ee5bb8753d560a$export$2b10f4b30fb65583 = 'delete-version.state.CANCEL';
const $a6ee5bb8753d560a$export$70b61ad426ddbe54 = ()=>({
        type: $a6ee5bb8753d560a$export$2b10f4b30fb65583
    });

});

parcelRegister("iRsY0", function(module, exports) {
$parcel$export(module.exports, "getProjectKey", () => $2c07722fb0eacd01$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getVersionName", () => $2c07722fb0eacd01$export$1c8770fb67bc1686);
$parcel$export(module.exports, "getVersionId", () => $2c07722fb0eacd01$export$d0a84488c5034e2b);
$parcel$export(module.exports, "getSuccessCallback", () => $2c07722fb0eacd01$export$f916928c6ed991ef);
$parcel$export(module.exports, "getErrorCallback", () => $2c07722fb0eacd01$export$be7719b1c8edb902);
$parcel$export(module.exports, "getCancelCallback", () => $2c07722fb0eacd01$export$daa6fcadbe6b8199);
$parcel$export(module.exports, "getModalShownCallback", () => $2c07722fb0eacd01$export$b4b8c1e0789de5b);
$parcel$export(module.exports, "getFields", () => $2c07722fb0eacd01$export$d5523731e7fe4ded);
$parcel$export(module.exports, "getSortedFields", () => $2c07722fb0eacd01$export$556e7723f75d8f85);
$parcel$export(module.exports, "getFieldOperation", () => $2c07722fb0eacd01$export$5c89158bea368dea);
$parcel$export(module.exports, "isFieldVersionPickerDisabled", () => $2c07722fb0eacd01$export$5cf1684ed04fcae4);
$parcel$export(module.exports, "getFieldTargetVersion", () => $2c07722fb0eacd01$export$ffcc490b2a32206e);
$parcel$export(module.exports, "getTargetVersionForFixVersionField", () => $2c07722fb0eacd01$export$70b9462681b3dcab);
$parcel$export(module.exports, "isDialogVisible", () => $2c07722fb0eacd01$export$6931412cced8431b);
$parcel$export(module.exports, "isSwapValid", () => $2c07722fb0eacd01$export$fba1dcdce680a78);
$parcel$export(module.exports, "isInProgress", () => $2c07722fb0eacd01$export$350bfa81fecdb6f3);

var $ahm5r = parcelRequire("ahm5r");


var $i8Frv = parcelRequire("i8Frv");
const $2c07722fb0eacd01$export$667f2a0f99c75faa = (state)=>state.projectKey;
const $2c07722fb0eacd01$export$1c8770fb67bc1686 = (state)=>state.version.name;
const $2c07722fb0eacd01$export$d0a84488c5034e2b = (state)=>state.version.id;
const $2c07722fb0eacd01$export$f916928c6ed991ef = (state)=>state.onSuccess;
const $2c07722fb0eacd01$export$be7719b1c8edb902 = (state)=>state.onError;
const $2c07722fb0eacd01$export$daa6fcadbe6b8199 = (state)=>state.onCancel;
const $2c07722fb0eacd01$export$b4b8c1e0789de5b = (state)=>state.onOpened;
const $2c07722fb0eacd01$export$d5523731e7fe4ded = (state)=>Object.values(state.fields);
const $2c07722fb0eacd01$export$556e7723f75d8f85 = (0, $ahm5r.createSelector)([
    $2c07722fb0eacd01$export$d5523731e7fe4ded
], (fields)=>{
    const fieldIdx = (field)=>{
        if (field.id === (0, $i8Frv.FIXED_IN).id) return 2;
        if (field.id === (0, $i8Frv.AFFECTS).id) return 1;
        return 0;
    };
    const sortFields = (fo1, fo2)=>fieldIdx(fo2.relatedField.field) - fieldIdx(fo1.relatedField.field);
    return fields.sort(sortFields);
});
const $2c07722fb0eacd01$export$5c89158bea368dea = (state, id)=>state.fields[id] && state.fields[id].operation;
const $2c07722fb0eacd01$export$5cf1684ed04fcae4 = (state, id)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.inProgress || $2c07722fb0eacd01$export$5c89158bea368dea(state, id) === (0, $7ffa84e48e7c4be1$export$4bd2facc4a3e6aa1);
const $2c07722fb0eacd01$export$ffcc490b2a32206e = (state, id)=>state.fields[id] && state.fields[id].targetVersion;
const $2c07722fb0eacd01$export$70b9462681b3dcab = (state)=>$2c07722fb0eacd01$export$5c89158bea368dea(state, (0, $i8Frv.FIXED_IN).id) === (0, $7ffa84e48e7c4be1$export$346f08c1f0d0fe41) ? $2c07722fb0eacd01$export$ffcc490b2a32206e(state, (0, $i8Frv.FIXED_IN).id) : undefined;
const $2c07722fb0eacd01$export$6931412cced8431b = (state)=>state.isVisible;
const $2c07722fb0eacd01$export$fba1dcdce680a78 = (0, $ahm5r.createSelector)([
    $2c07722fb0eacd01$export$d5523731e7fe4ded
], (fields)=>fields.reduce((valid, { operation: operation, targetVersion: targetVersion })=>valid && (operation !== (0, $7ffa84e48e7c4be1$export$346f08c1f0d0fe41) || Boolean(targetVersion)), true));
const $2c07722fb0eacd01$export$350bfa81fecdb6f3 = (state)=>state.inProgress;

});
const $7ffa84e48e7c4be1$export$346f08c1f0d0fe41 = 'move';
const $7ffa84e48e7c4be1$export$4bd2facc4a3e6aa1 = 'delete';

parcelRegister("i8Frv", function(module, exports) {
$parcel$export(module.exports, "FIXED_IN", () => $8c4751638bd008ed$export$c1319bacb5863ea8);
$parcel$export(module.exports, "AFFECTS", () => $8c4751638bd008ed$export$fc27897d4865f00b);
$parcel$export(module.exports, "default", () => $8c4751638bd008ed$export$2e2bcd8739ae039);
const $8c4751638bd008ed$export$c1319bacb5863ea8 = {
    id: 'fixVersion',
    name: 'Fix Version'
};
const $8c4751638bd008ed$export$fc27897d4865f00b = {
    id: 'affectedVersion',
    name: 'Affects version'
};
const $8c4751638bd008ed$var$systemFields = [
    $8c4751638bd008ed$export$c1319bacb5863ea8,
    $8c4751638bd008ed$export$fc27897d4865f00b
];
var $8c4751638bd008ed$export$2e2bcd8739ae039 = $8c4751638bd008ed$var$systemFields;

});



parcelRegister("5g0z3", function(module, exports) {
$parcel$export(module.exports, "epic", () => $370cea9a3116aa1f$export$8ec5145af6f76965);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $4q7it = parcelRequire("4q7it");

var $5bodI = parcelRequire("5bodI");

var $iRsY0 = parcelRequire("iRsY0");
const $370cea9a3116aa1f$var$LOG_LOCATION = 'project-directories.versions.delete-version.ops.delete';
const $370cea9a3116aa1f$export$8ec5145af6f76965 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $5bodI.DELETE_VERSION)).mergeMap(()=>(0, $7kixv.Observable).fromPromise((0, $4q7it.deleteAndSwapVersion)((0, $iRsY0.getVersionId)(store.getState()), (0, $iRsY0.getFields)(store.getState()))).map((0, $5bodI.deletionSuccess)).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData($370cea9a3116aa1f$var$LOG_LOCATION, error.message, error);
            return (0, $7kixv.Observable).of((0, $5bodI.deletionFailure)(error));
        }));

});
parcelRegister("4q7it", function(module, exports) {
$parcel$export(module.exports, "deleteAndSwapVersion", () => $6d347a6bae48da45$export$8d0d936cc5a9c564);

var $agiqH = parcelRequire("agiqH");

var $eSnSE = parcelRequire("eSnSE");

var $euNax = parcelRequire("euNax");

var $goOxs = parcelRequire("goOxs");
const $6d347a6bae48da45$export$8d0d936cc5a9c564 = (id, swapConfiguration)=>(0, $euNax.deleteAndSwapVersion)(id, (0, $goOxs.transformSwapConfiguration)(swapConfiguration)).then((result)=>{
        try {
            id && (0, $agiqH.default).remove(id);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.cache.remove', error.message);
        }
        return result;
    });

});
parcelRegister("agiqH", function(module, exports) {
$parcel$export(module.exports, "default", () => $14a1754d883fa299$export$2e2bcd8739ae039);

var $gB3jQ = parcelRequire("gB3jQ");

var $7Ix33 = parcelRequire("7Ix33");
var $14a1754d883fa299$export$2e2bcd8739ae039 = (0, $gB3jQ.default)((0, $7Ix33.props));

});
parcelRegister("7Ix33", function(module, exports) {
$parcel$export(module.exports, "props", () => $6dd95d740de41246$export$8128bb6492cf3de7);

const $6dd95d740de41246$var$MAX_RESULTS = 10;
const $6dd95d740de41246$var$CACHE_SIZE = $6dd95d740de41246$var$MAX_RESULTS * 2;
const $6dd95d740de41246$var$VERSIONS_CACHE_KEY = 'versions';
const $6dd95d740de41246$export$8128bb6492cf3de7 = {
    size: $6dd95d740de41246$var$CACHE_SIZE,
    cacheKey: $6dd95d740de41246$var$VERSIONS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $08db7ac9f9f525e1$export$2670cb7d5d4f7184)
};

});
const $08db7ac9f9f525e1$export$7271276960377470 = 'common-cache';
const $08db7ac9f9f525e1$export$a61768fefd33fcb1 = 'capacity exceeded';
const $08db7ac9f9f525e1$export$6c4d37c7f376a1de = 'clear';
const $08db7ac9f9f525e1$export$e271b26eefe41db8 = 'update';
const $08db7ac9f9f525e1$export$4bd2facc4a3e6aa1 = 'delete';
const $08db7ac9f9f525e1$export$26d12233004a7a60 = 'delete stale entry';
const $08db7ac9f9f525e1$export$1bb358554aac31c1 = 'get';
const $08db7ac9f9f525e1$export$61f74127e2b53cbe = 'hydrate';
const $08db7ac9f9f525e1$export$5e8f180ef0142226 = 'set';
const $08db7ac9f9f525e1$export$9eb68924983e00fb = 'get entries';
const $08db7ac9f9f525e1$export$bf340b99118a1511 = 'memory';
const $08db7ac9f9f525e1$export$2670cb7d5d4f7184 = 'local';
const $08db7ac9f9f525e1$export$b796061ff0c82e1a = 'session';



parcelRegister("euNax", function(module, exports) {
$parcel$export(module.exports, "deleteAndSwapVersion", () => $65109a3e93446d90$export$8d0d936cc5a9c564);

var $14RSn = parcelRequire("14RSn");

var $eBhI6 = parcelRequire("eBhI6");
const $65109a3e93446d90$export$b2e9fbb4ccceec79 = (id)=>`/rest/api/2/version/${id}/removeAndSwap`;
const $65109a3e93446d90$export$8d0d936cc5a9c564 = async (versionId, swap)=>{
    const url = $65109a3e93446d90$export$b2e9fbb4ccceec79(versionId);
    const response = await fetch(url, {
        ...(0, $eBhI6.getDefaultOptions)(url),
        method: 'POST',
        body: JSON.stringify(swap)
    });
    if (response.ok) return;
    const text = await response.text();
    throw new (0, $14RSn.default)(response.status, text);
};

});

parcelRegister("goOxs", function(module, exports) {
$parcel$export(module.exports, "transformSwapConfiguration", () => $1d14e48d3339f1df$export$b87e89a18e0e57e5);

var $4sprp = parcelRequire("4sprp");

var $16aVR = parcelRequire("16aVR");


var $i8Frv = parcelRequire("i8Frv");
const $1d14e48d3339f1df$var$mapFieldToKey = (field, targetVersion)=>{
    if (field.id === (0, $i8Frv.FIXED_IN).id) return {
        moveFixIssuesTo: targetVersion
    };
    if (field.id === (0, $i8Frv.AFFECTS).id) return {
        moveAffectedIssuesTo: targetVersion
    };
    return {
        customFieldReplacementList: [
            {
                customFieldId: field.id,
                moveTo: targetVersion
            }
        ]
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1d14e48d3339f1df$var$customizer = (objValue, srcValue)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(objValue)) return objValue.concat(srcValue);
    return undefined;
};
const $1d14e48d3339f1df$export$b87e89a18e0e57e5 = (configuration)=>(0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))({}, ...configuration.map(({ operation: operation, relatedField: relatedField, targetVersion: targetVersion })=>operation === (0, $7ffa84e48e7c4be1$export$346f08c1f0d0fe41) && targetVersion ? $1d14e48d3339f1df$var$mapFieldToKey(relatedField.field, targetVersion) : {}), $1d14e48d3339f1df$var$customizer);

});



parcelRegister("8EBPl", function(module, exports) {
$parcel$export(module.exports, "epic", () => $3de4c7d282977b07$export$8ec5145af6f76965);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $fMQQA = parcelRequire("fMQQA");

var $5bodI = parcelRequire("5bodI");

var $iRsY0 = parcelRequire("iRsY0");
const $3de4c7d282977b07$var$LOG_LOCATION = 'project-directories.versions.delete-version.ops.get-related-issues-count';
const $3de4c7d282977b07$export$8ec5145af6f76965 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
action$, store)=>action$.ofType((0, $5bodI.GET_RELATED_ISSUES_COUNT)).mergeMap(()=>(0, $7kixv.Observable).fromPromise((0, $fMQQA.getRelatedIssues)((0, $iRsY0.getVersionId)(store.getState()))).map((relatedIssues)=>(0, $5bodI.setRelatedIssuesCount)(relatedIssues)).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData($3de4c7d282977b07$var$LOG_LOCATION, error.message, error);
            return (0, $7kixv.Observable).of((0, $5bodI.deletionFailure)(error));
        }));

});
parcelRegister("fMQQA", function(module, exports) {
$parcel$export(module.exports, "getRelatedIssues", () => $b7e142bace27cceb$export$5d18be4905cf7f19);

var $kbkRL = parcelRequire("kbkRL");

var $lGYFi = parcelRequire("lGYFi");
const $b7e142bace27cceb$export$5d18be4905cf7f19 = (id)=>(0, $kbkRL.getRelatedIssueCount)(id).then((0, $lGYFi.transformRelatedIssueCountsResponse));

});
parcelRegister("kbkRL", function(module, exports) {
$parcel$export(module.exports, "getRelatedIssueCount", () => $58e18f392b98a1e1$export$a589d742480d1165);

var $hgi0g = parcelRequire("hgi0g");
const $58e18f392b98a1e1$export$925758e6be80617a = (id)=>`/rest/api/2/version/${id}/relatedIssueCounts`;
const $58e18f392b98a1e1$export$a589d742480d1165 = (versionId)=>(0, $hgi0g.default)($58e18f392b98a1e1$export$925758e6be80617a(versionId));

});

parcelRegister("lGYFi", function(module, exports) {
$parcel$export(module.exports, "transformRelatedIssueCountsResponse", () => $715dab3d784e4e1b$export$95d9c414d6450d15);

var $i8Frv = parcelRequire("i8Frv");
const $715dab3d784e4e1b$var$affectsFieldCount = (issueCount)=>({
        [(0, $i8Frv.AFFECTS).id]: {
            field: (0, $i8Frv.AFFECTS),
            issueCount: issueCount
        }
    });
const $715dab3d784e4e1b$var$fixedInFieldCount = (issueCount)=>({
        [(0, $i8Frv.FIXED_IN).id]: {
            field: (0, $i8Frv.FIXED_IN),
            issueCount: issueCount
        }
    });
const $715dab3d784e4e1b$var$customFieldsCount = (customFields)=>Object.assign({}, ...customFields.map(({ fieldName: fieldName, customFieldId: customFieldId, issueCountWithVersionInCustomField: issueCountWithVersionInCustomField })=>({
            [customFieldId]: {
                field: {
                    name: fieldName,
                    id: customFieldId
                },
                issueCount: issueCountWithVersionInCustomField
            }
        })));
const $715dab3d784e4e1b$export$95d9c414d6450d15 = (response)=>({
        ...response.issuesAffectedCount > 0 ? $715dab3d784e4e1b$var$affectsFieldCount(response.issuesAffectedCount) : {},
        ...response.issuesFixedCount > 0 ? $715dab3d784e4e1b$var$fixedInFieldCount(response.issuesFixedCount) : {},
        ...response.issueCountWithCustomFieldsShowingVersion > 0 && response.customFieldUsage ? $715dab3d784e4e1b$var$customFieldsCount(response.customFieldUsage) : {}
    });

});



parcelRegister("8uL3O", function(module, exports) {
$parcel$export(module.exports, "epic", () => $d0680419dde339f5$export$8ec5145af6f76965);
parcelRequire("1o2WJ");

var $8dH3d = parcelRequire("8dH3d");

var $5bodI = parcelRequire("5bodI");
const $d0680419dde339f5$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, $5bodI.SET_RELATED_ISSUES_COUNT)).map((action)=>{
        const relatedIssues = action.payload;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(relatedIssues)) return (0, $5bodI.deleteVersion)();
        return (0, $5bodI.showDialog)();
    });

});


parcelRegister("kQb0T", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b826322c7a533ef$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $j53j6 = parcelRequire("j53j6");
const $5b826322c7a533ef$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'delete-version',
        rootReducer: $j53j6.default,
        rootEpic: rootEpic
    });
var $5b826322c7a533ef$export$2e2bcd8739ae039 = $5b826322c7a533ef$var$createStore;

});
parcelRegister("j53j6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ae879c129213055$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");


var $5bodI = parcelRequire("5bodI");
const $7ae879c129213055$export$49d5fc8cba920a0 = {
    projectKey: '',
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    version: {
        name: '',
        id: ''
    },
    fields: {},
    inProgress: false,
    isVisible: false
};
const $7ae879c129213055$var$reducer = (state = $7ae879c129213055$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $5bodI.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload,
                version: {
                    name: action.payload.version.name,
                    id: action.payload.version.id
                },
                fields: {}
            };
        case 0, $5bodI.SET_RELATED_ISSUES_COUNT:
            return {
                ...state,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fields: Object.entries(action.payload).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                (fields, [fieldId, field])=>{
                    // eslint-disable-next-line no-param-reassign
                    fields[fieldId] = {
                        relatedField: field,
                        operation: (0, $7ffa84e48e7c4be1$export$346f08c1f0d0fe41)
                    };
                    return fields;
                }, {})
            };
        case 0, $5bodI.SHOW_DIALOG:
            return {
                ...state,
                isVisible: true
            };
        case 0, $5bodI.SET_VERSION_FOR_FIELD:
            if (Object.prototype.hasOwnProperty.call(state.fields, action.payload.fieldId)) return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.payload.fieldId]: {
                        ...state.fields[action.payload.fieldId],
                        targetVersion: action.payload.target
                    }
                }
            };
            return state;
        case 0, $5bodI.SET_OPERATION_FOR_FIELD:
            if (Object.prototype.hasOwnProperty.call(state.fields, action.payload.fieldId)) return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.payload.fieldId]: {
                        ...state.fields[action.payload.fieldId],
                        operation: action.payload.operation
                    }
                }
            };
            return state;
        case 0, $5bodI.DELETE_VERSION:
            return {
                ...state,
                inProgress: true
            };
        case 0, $5bodI.DELETION_FAILURE:
            return {
                ...state,
                inProgress: false
            };
        case 0, $5bodI.DELETION_SUCCESS:
        case 0, $5bodI.CANCEL:
            return {
                ...state,
                inProgress: false,
                isVisible: false
            };
        case 0, $5bodI.GET_RELATED_ISSUES_COUNT:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $7ae879c129213055$export$2e2bcd8739ae039 = $7ae879c129213055$var$reducer;

});


parcelRegister("eu9jx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4954aa3bc61036ad$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $5bodI = parcelRequire("5bodI");

var $iRsY0 = parcelRequire("iRsY0");

var $60juE = parcelRequire("60juE");

var $26dF6 = parcelRequire("26dF6");

var $fCPpJ = parcelRequire("fCPpJ");
const $4954aa3bc61036ad$var$mapStateToProps = (state)=>({
        Content: $60juE.default,
        Footer: $26dF6.default,
        isDialogVisible: (0, $iRsY0.isDialogVisible)(state),
        versionName: (0, $iRsY0.getVersionName)(state)
    });
const $4954aa3bc61036ad$var$mapDispatchToProps = {
    onClose: (0, $5bodI.cancel)
};
var $4954aa3bc61036ad$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4954aa3bc61036ad$var$mapStateToProps, $4954aa3bc61036ad$var$mapDispatchToProps)((0, $fCPpJ.default));

});
parcelRegister("60juE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e84ab979e8738eba$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $fDigG = parcelRequire("fDigG");

var $iRsY0 = parcelRequire("iRsY0");

var $ESBiz = parcelRequire("ESBiz");

var $cW2HH = parcelRequire("cW2HH");
const $e84ab979e8738eba$var$mapStateToProps = (state)=>({
        MoveVersion: $ESBiz.default,
        fields: (0, $iRsY0.getSortedFields)(state),
        versionName: (0, $iRsY0.getVersionName)(state),
        renderVersionUrl: (field)=>(0, $fDigG.getIssuesForRelatedFieldUrl)((0, $iRsY0.getProjectKey)(state), (0, $iRsY0.getVersionId)(state), field)
    });
var $e84ab979e8738eba$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($e84ab979e8738eba$var$mapStateToProps, {})((0, $cW2HH.default));

});
parcelRegister("fDigG", function(module, exports) {
$parcel$export(module.exports, "getIssuesForRelatedFieldUrl", () => $355ee9a63427e066$export$1f88f7aa26cf4491);

var $bnIBr = parcelRequire("bnIBr");

var $i8Frv = parcelRequire("i8Frv");
const $355ee9a63427e066$export$1f88f7aa26cf4491 = (projectKey, versionId, field)=>{
    const fieldInJql = (0, $i8Frv.default).includes(field) ? field.id : (0, $bnIBr.toQuotedString)(field.name);
    const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND ${fieldInJql} = ${versionId}`;
    return (0, $bnIBr.createAllWorkUrl)(jql);
};

});
parcelRegister("bnIBr", function(module, exports) {
$parcel$export(module.exports, "toQuotedString", () => $a183e8d5995c289a$export$dbeab020a4aa404);
$parcel$export(module.exports, "createProjectAllWorkUri", () => $a183e8d5995c289a$export$497544a08e0b5e51);
$parcel$export(module.exports, "createAllWorkUrl", () => $a183e8d5995c289a$export$ca075a1255c9a76d);

var $4cTDP = parcelRequire("4cTDP");
const $a183e8d5995c289a$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $a183e8d5995c289a$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $a183e8d5995c289a$var$ENCODE_MAP[character] || character;
};
const $a183e8d5995c289a$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $a183e8d5995c289a$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $a183e8d5995c289a$export$497544a08e0b5e51 = (jql)=>(0, $4cTDP.fg)('jira_list_nin_merge') ? `/list/?jql=${encodeURIComponent(jql)}` : `/issues/?jql=${encodeURIComponent(jql)}`;
const $a183e8d5995c289a$export$ca075a1255c9a76d = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("ESBiz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ceb6c2055afee08$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gnQAk = parcelRequire("gnQAk");

var $7zFqE = parcelRequire("7zFqE");

var $5bodI = parcelRequire("5bodI");

var $iRsY0 = parcelRequire("iRsY0");

var $ebIF1 = parcelRequire("ebIF1");
const $3ceb6c2055afee08$var$VERSION_STATUS_WHITELIST = [
    'released',
    'unreleased'
];
const $3ceb6c2055afee08$var$mapStateToProps = (state, ownProps)=>({
        renderVersionPicker: ({ onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zFqE.default), {
                onSelected: onChange,
                projectKey: (0, $iRsY0.getProjectKey)(state),
                ignore: [
                    (0, $iRsY0.getVersionId)(state)
                ],
                versionStatuses: $3ceb6c2055afee08$var$VERSION_STATUS_WHITELIST,
                isDisabled: (0, $iRsY0.isFieldVersionPickerDisabled)(state, ownProps.id)
            }),
        operation: (0, $iRsY0.getFieldOperation)(state, ownProps.id),
        target: (0, $iRsY0.getFieldTargetVersion)(state, ownProps.id),
        isDisabled: (0, $iRsY0.isInProgress)(state)
    });
const $3ceb6c2055afee08$var$mapDispatchToProps = (dispatch, ownProps)=>({
        // @ts-expect-error - TS7006 - Parameter 'operation' implicitly has an 'any' type.
        onOperationChanged: (operation)=>dispatch((0, $5bodI.setOperationForField)({
                operation: operation,
                fieldId: ownProps.id
            })),
        // @ts-expect-error - TS7006 - Parameter 'versionId' implicitly has an 'any' type.
        onTargetVersionChanged: (versionId)=>dispatch((0, $5bodI.setVersionForField)({
                target: versionId,
                fieldId: ownProps.id
            }))
    });
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<{ renderVersionPicker: ({ onChange }: VersionPickerProps) => Element; operation: Operation | undefined; target: string | undefined; isDisabled: boolean; } & { ...; } & Props>'.
$3ceb6c2055afee08$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($3ceb6c2055afee08$var$mapStateToProps, $3ceb6c2055afee08$var$mapDispatchToProps)((0, $ebIF1.default));

});
parcelRegister("7zFqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8eeee8d4b29e30db$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $6sjW5 = parcelRequire("6sjW5");

var $fJTOm = parcelRequire("fJTOm");

var $idGBm = parcelRequire("idGBm");

var $fdDZf = parcelRequire("fdDZf");

var $dqHWY = parcelRequire("dqHWY");

var $kTLpN = parcelRequire("kTLpN");
class $8eeee8d4b29e30db$export$c7c815960e157d78 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearableWithCrossIcon: false,
            noPortal: false,
            value: undefined,
            label: '',
            placeholder: undefined,
            ignore: [],
            versionStatuses: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    getVersionIdsToIgnore() {
        const { value: value, ignore: ignore } = this.props;
        if (value) return [
            value.id,
            ...ignore
        ];
        return ignore;
    }
    getPlaceholder() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return this.props.placeholder === undefined ? formatMessage((0, $kTLpN.default).placeholder) : this.props.placeholder;
    }
    getValue() {
        const { value: value } = this.props;
        if (value === null || value === undefined) return value;
        return (0, $dqHWY.transformVersion)(value);
    }
    render() {
        const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.Picker), {
            ...this.props,
            value: this.getValue(),
            label: label,
            placeholder: this.getPlaceholder(),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $kTLpN.default).error),
            onSelected: this.onSelected,
            options: this.onFetchOptions,
            noPortal: noPortal,
            intl: intl
        });
    }
    constructor(...args){
        super(...args), this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                id: selectedOption.value,
                name: selectedOption.label
            }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent), this.onFetchOptions = (filter)=>(0, $fdDZf.requestVersions)(this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
    }
}
var $8eeee8d4b29e30db$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $6sjW5.default)({
    onSelected: 'versionPicker'
})($8eeee8d4b29e30db$export$c7c815960e157d78));

});
parcelRegister("fJTOm", function(module, exports) {
$parcel$export(module.exports, "getOptionBaseStyles", () => $69685483963d086b$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $69685483963d086b$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $69685483963d086b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $4ibbN = parcelRequire("4ibbN");

var $1jVV7 = parcelRequire("1jVV7");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $3DNvO = parcelRequire("3DNvO");
var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");
var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $lxUP5 = parcelRequire("lxUP5");

var $6joHJ = parcelRequire("6joHJ");

var $6YFG2 = parcelRequire("6YFG2");

var $6rlhA = parcelRequire("6rlhA");
const $69685483963d086b$export$3a3072dd741f354b = 500;
const $69685483963d086b$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #6B6E76)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $69685483963d086b$export$ba25329847403e11 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.clearButtonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $6rlhA.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.valueContainer,
                onClick: onValueContainerClick,
                testId: "common-components-picker.base.react-dnd-and-select-focus-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props)));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $69685483963d086b$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $3DNvO.default) : (0, $kVcjU.default);
        if (isAsync) return 0, $4ibbN.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $6UCkD.default) : (0, $c4OV1.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $6rlhA.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $6rlhA.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $6rlhA.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : (0, $fceQU.getDocument)()?.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $1jVV7.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$69685483963d086b$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                menu: (base)=>{
                    return {
                        ...base,
                        width: 'max-content',
                        // This makes the menu fit the widest content
                        minWidth: '100%'
                    };
                }
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxUP5.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
// @ts-expect-error This is required because of the ratcheted conversion from intlV2 to intl
const $69685483963d086b$var$PickerWithIntl = (0, $6YFG2.default)($69685483963d086b$export$ba25329847403e11);
const $69685483963d086b$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$PickerWithIntl, props);
};
$69685483963d086b$var$DefaultPicker.defaultProps = $69685483963d086b$export$ba25329847403e11.defaultProps;
var $69685483963d086b$export$2e2bcd8739ae039 = $69685483963d086b$var$DefaultPicker;
const $69685483963d086b$var$styles = {
    clearButtonWrapper: "_n7zlia51",
    valueContainer: "_16jlkb7n"
};

});
parcelRegister("4ibbN", function(module, exports) {
$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $ff7c32c387190ed2$export$ee664e5add893f9);

var $gWITR = parcelRequire("gWITR");

var $as6H2 = parcelRequire("as6H2");
const $ff7c32c387190ed2$export$ee664e5add893f9 = (0, $as6H2.default)('select', {
    onChange: 'changed'
})((0, $gWITR.default));

});

parcelRegister("3DNvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aa8c3d4d43b8a4$export$2e2bcd8739ae039);

var $7pkFT = parcelRequire("7pkFT");

var $dDv66 = parcelRequire("dDv66");
const $35aa8c3d4d43b8a4$var$AsyncCreatableSelect = (0, $dDv66.default)((0, $7pkFT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35aa8c3d4d43b8a4$export$2e2bcd8739ae039 = $35aa8c3d4d43b8a4$var$AsyncCreatableSelect;

});
parcelRegister("7pkFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $69fba18f5363b86b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $69fba18f5363b86b$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iSKoM.default)(props);
    const creatableProps = (0, $gVVTN.default)(stateManagerProps);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69fba18f5363b86b$export$2e2bcd8739ae039 = $69fba18f5363b86b$var$AsyncCreatableSelect;

});


parcelRegister("6UCkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bb5dff77a1a2ff0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jzkyh = parcelRequire("jzkyh");

var $c4OV1 = parcelRequire("c4OV1");
const $3bb5dff77a1a2ff0$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eJOHy.useMemo)(()=>({
            ...components,
            Option: (0, $jzkyh.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $3bb5dff77a1a2ff0$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($3bb5dff77a1a2ff0$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bb5dff77a1a2ff0$export$2e2bcd8739ae039 = $3bb5dff77a1a2ff0$var$CheckboxSelect;

});

parcelRegister("lxUP5", function(module, exports) {
$parcel$export(module.exports, "FieldLabel", () => $02d61fcf6733b580$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $02d61fcf6733b580$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02d61fcf6733b580$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1rpy _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02d61fcf6733b580$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $02d61fcf6733b580$var$labelStyle = null;
const $02d61fcf6733b580$var$requiredIndicatorStyle = null;

});

parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("6rlhA", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c5e69dae6a49f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $742c5e69dae6a49f$var$messages = (0, $7qGN1.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});
var $742c5e69dae6a49f$export$2e2bcd8739ae039 = $742c5e69dae6a49f$var$messages;

});


parcelRegister("fdDZf", function(module, exports) {
$parcel$export(module.exports, "requestVersions", () => $5a2419ee51463761$export$aadfb092a4919504);

var $3i6bm = parcelRequire("3i6bm");

var $dqHWY = parcelRequire("dqHWY");
const $5a2419ee51463761$export$aadfb092a4919504 = async (projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
    const pageVersions = await (0, $3i6bm.requestVersions)(projectKey, filter, versionStatuses, ignore);
    return (0, $dqHWY.transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
};

});
parcelRegister("3i6bm", function(module, exports) {
$parcel$export(module.exports, "MAX_RESULTS", () => $61ccc071e11282ed$export$f6b2881bc1090cea);
$parcel$export(module.exports, "requestVersions", () => $61ccc071e11282ed$export$aadfb092a4919504);

var $b5RwB = parcelRequire("b5RwB");

var $hgi0g = parcelRequire("hgi0g");
const $61ccc071e11282ed$export$f6b2881bc1090cea = 5;
const $61ccc071e11282ed$export$b702ac644ba114c = (projectKey)=>`/rest/api/2/project/${projectKey}/version`;
const $61ccc071e11282ed$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $b5RwB.stringify)({
        startAt: 0,
        query: filter,
        maxResults: $61ccc071e11282ed$export$f6b2881bc1090cea + ignore.length,
        orderBy: '+NAME',
        status: versionStatuses.join(',')
    });
const $61ccc071e11282ed$export$8395ad088d65e586 = (projectKey, filter, versionStatuses, ignore)=>`${$61ccc071e11282ed$export$b702ac644ba114c(projectKey)}?${$61ccc071e11282ed$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
const $61ccc071e11282ed$export$aadfb092a4919504 = async (projectKey, filter, versionStatuses, ignore)=>(0, $hgi0g.default)($61ccc071e11282ed$export$8395ad088d65e586(projectKey, filter, versionStatuses, ignore));

});

parcelRegister("dqHWY", function(module, exports) {
$parcel$export(module.exports, "transformVersion", () => $6e5a5e3fef83cd9d$export$390ab7123357e756);
$parcel$export(module.exports, "transformVersions", () => $6e5a5e3fef83cd9d$export$8bc7a3929156b65e);

var $3i6bm = parcelRequire("3i6bm");
const $6e5a5e3fef83cd9d$export$390ab7123357e756 = (component)=>({
        value: component.id,
        label: component.name
    });
const $6e5a5e3fef83cd9d$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($6e5a5e3fef83cd9d$export$390ab7123357e756).slice(0, (0, $3i6bm.MAX_RESULTS));

});


parcelRegister("kTLpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d36aee28257e64be$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d36aee28257e64be$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "version-picker.error",
        "defaultMessage": "We couldn't retrieve versions"
    },
    placeholder: {
        "id": "version-picker.placeholder",
        "defaultMessage": "Select version"
    }
});
var $d36aee28257e64be$export$2e2bcd8739ae039 = $d36aee28257e64be$var$messages;

});


parcelRegister("ebIF1", function(module, exports) {
$parcel$export(module.exports, "default", () => $79c6ad994f01a0fd$export$2e2bcd8739ae039);
/* MoveVersion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gPG64 = parcelRequire("gPG64");

var $4cTDP = parcelRequire("4cTDP");

var $idGBm = parcelRequire("idGBm");


var $3MVvq = parcelRequire("3MVvq");
class $79c6ad994f01a0fd$export$7dd97fb25ed038e extends (0, $eJOHy.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, renderVersionPicker: renderVersionPicker, operation: operation, isDisabled: isDisabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
            isChecked: operation === (0, $7ffa84e48e7c4be1$export$346f08c1f0d0fe41),
            onChange: this.onMoveSelected,
            isDisabled: isDisabled,
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $3MVvq.default).moveIssuesIssueTermRefresh : (0, $3MVvq.default).moveIssues),
            testId: "version-modals.delete-version.content.move-version.move-radio"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79c6ad994f01a0fd$var$PickerContainer, null, renderVersionPicker({
            onChange: this.onVersionPicked
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
            isChecked: operation === (0, $7ffa84e48e7c4be1$export$4bd2facc4a3e6aa1),
            onChange: this.onDeleteSelected,
            isDisabled: isDisabled,
            label: formatMessage((0, $3MVvq.default).removeVersion),
            testId: "version-modals.delete-version.content.move-version.remove-radio"
        }));
    }
    constructor(...args){
        super(...args), this.onMoveSelected = ()=>{
            this.props.onOperationChanged((0, $7ffa84e48e7c4be1$export$346f08c1f0d0fe41));
        }, this.onDeleteSelected = ()=>{
            this.props.onOperationChanged((0, $7ffa84e48e7c4be1$export$4bd2facc4a3e6aa1));
        }, this.onVersionPicked = (version)=>{
            this.props.onTargetVersionChanged(version ? version.id : undefined);
        };
    }
}
var $79c6ad994f01a0fd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($79c6ad994f01a0fd$export$7dd97fb25ed038e);
const $79c6ad994f01a0fd$var$PickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv _19pk1b66 _2hwxidpf _otyrpxbi _18u01ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3MVvq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9b8f6914dfa465$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2e9b8f6914dfa465$var$messages = (0, $7qGN1.defineMessages)({
    moveIssues: {
        "id": "project-directories.versions.delete-version.content.move-version.move-issues",
        "defaultMessage": "Move issues to"
    },
    removeVersion: {
        "id": "project-directories.versions.delete-version.content.move-version.remove-version",
        "defaultMessage": "Remove the version"
    },
    moveIssuesIssueTermRefresh: {
        "id": "project-directories.versions.delete-version.content.move-version.move-issues-issue-term-refresh",
        "defaultMessage": "Move work items to"
    }
});
var $2e9b8f6914dfa465$export$2e2bcd8739ae039 = $2e9b8f6914dfa465$var$messages;

});



parcelRegister("cW2HH", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7e26555ec336ad6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $6svxr = parcelRequire("6svxr");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $i8Frv = parcelRequire("i8Frv");

var $i59Vs = parcelRequire("i59Vs");
class $e7e26555ec336ad6$export$7c6e2c02157bb7d2 extends (0, $eJOHy.Component) {
    getFieldName(field) {
        if ((0, $i8Frv.default).includes(field)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ fixVersion: MessageDescriptorV2; affectedVersion: MessageDescriptorV2; multipleFieldsDescription: MessageDescriptorV2; issueCount: MessageDescriptorV2; oneFieldDescription: MessageDescriptorV2; }'.
        return this.props.intl.formatMessage((0, $i59Vs.default)[field.id]);
        return field.name;
    }
    renderSingleField() {
        const { fields: [first], intl: { formatMessage: formatMessage }, MoveVersion: MoveVersion, renderVersionUrl: renderVersionUrl } = this.props;
        const issueCountLink = (0, $4cTDP.fg)('replace-anchor-with-link__fusion-solaris') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: renderVersionUrl(first.relatedField.field),
            target: "_blank"
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $i59Vs.default).issueCountIssueTermRefresh : (0, $i59Vs.default).issueCount, {
            count: first.relatedField.issueCount
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            href: renderVersionUrl(first.relatedField.field),
            target: "_blank",
            xcss: $e7e26555ec336ad6$var$anchorStyles
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $i59Vs.default).issueCountIssueTermRefresh : (0, $i59Vs.default).issueCount, {
            count: first.relatedField.issueCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $i59Vs.default).oneFieldDescription,
            values: {
                issueCountLink: issueCountLink
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $e7e26555ec336ad6$var$deleteSingleOptionContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MoveVersion, {
            id: first.relatedField.field.id
        })));
    }
    renderFieldDescription(relatedField) {
        const { renderVersionUrl: renderVersionUrl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, this.getFieldName(relatedField.field), "(", (0, $4cTDP.fg)('replace-anchor-with-link__fusion-solaris') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            target: "_blank",
            href: renderVersionUrl(relatedField.field)
        }, relatedField.issueCount) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
            target: "_blank",
            href: renderVersionUrl(relatedField.field),
            xcss: $e7e26555ec336ad6$var$anchorStyles
        }, relatedField.issueCount), ")");
    }
    renderMultipleFields() {
        const { fields: fields, intl: { formatMessage: formatMessage }, MoveVersion: MoveVersion, versionName: versionName } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $i59Vs.default).multipleFieldsDescriptionIssueTermRefresh : (0, $i59Vs.default).multipleFieldsDescription, {
            name: versionName
        }), fields.map(({ relatedField: relatedField })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                key: relatedField.field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                name: relatedField.field.name,
                label: this.renderFieldDescription(relatedField)
            }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MoveVersion, {
                    id: relatedField.field.id
                })))));
    }
    render() {
        return this.props.fields.length === 1 ? this.renderSingleField() : this.renderMultipleFields();
    }
}
var $e7e26555ec336ad6$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($e7e26555ec336ad6$export$7c6e2c02157bb7d2);
const $e7e26555ec336ad6$var$deleteSingleOptionContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.200'
});
const $e7e26555ec336ad6$var$anchorStyles = (0, $1DXK0.xcss)({
    textDecoration: 'none',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("i59Vs", function(module, exports) {
$parcel$export(module.exports, "default", () => $688c19bccc33d61f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $688c19bccc33d61f$var$messages = (0, $7qGN1.defineMessages)({
    oneFieldDescription: {
        "id": "project-directories.versions.delete-version.content.one-field-description",
        "defaultMessage": "Deleting this version will remove it from {issueCountLink}."
    },
    issueCount: {
        "id": "project-directories.versions.delete-version.content.issue-count",
        "defaultMessage": "{count} {count, plural, one {issue} other {issues}}"
    },
    multipleFieldsDescription: {
        "id": "project-directories.versions.delete-version.content.multiple-fields-description",
        "defaultMessage": "A few issue fields reference {name}. You can update the fields to reference another version or clear the value of those fields."
    },
    affectedVersion: {
        "id": "project-directories.versions.delete-version.content.affected-version",
        "defaultMessage": "Affects version"
    },
    fixVersion: {
        "id": "project-directories.versions.delete-version.content.fix-version",
        "defaultMessage": "Fix version"
    },
    issueCountIssueTermRefresh: {
        "id": "project-directories.versions.delete-version.content.issue-count-issue-term-refresh",
        "defaultMessage": "{count} {count, plural, one {work item} other {work items}}"
    },
    multipleFieldsDescriptionIssueTermRefresh: {
        "id": "project-directories.versions.delete-version.content.multiple-fields-description-issue-term-refresh",
        "defaultMessage": "A few fields in the work item reference {name}. You can update the fields to reference another version or clear the value of those fields."
    }
});
var $688c19bccc33d61f$export$2e2bcd8739ae039 = $688c19bccc33d61f$var$messages;

});



parcelRegister("26dF6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d18b5540ab59a62$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $5bodI = parcelRequire("5bodI");

var $iRsY0 = parcelRequire("iRsY0");

var $h1fSX = parcelRequire("h1fSX");
const $8d18b5540ab59a62$var$mapStateToProps = (state)=>({
        isDeleteEnabled: (0, $iRsY0.isSwapValid)(state),
        isDeleteInProgress: (0, $iRsY0.isInProgress)(state)
    });
const $8d18b5540ab59a62$var$mapDispatchToProps = {
    onCancel: (0, $5bodI.cancel),
    onDelete: (0, $5bodI.deleteVersion)
};
var $8d18b5540ab59a62$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($8d18b5540ab59a62$var$mapStateToProps, $8d18b5540ab59a62$var$mapDispatchToProps)((0, $h1fSX.default));

});
parcelRegister("h1fSX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6772c8dfb9005672$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $6sjW5 = parcelRequire("6sjW5");

var $idGBm = parcelRequire("idGBm");

var $9TMpR = parcelRequire("9TMpR");
function $6772c8dfb9005672$export$a06f1c675e846f6f(props) {
    const { intl: { formatMessage: formatMessage }, onCancel: onCancel, onDelete: onDelete, isDeleteEnabled: isDeleteEnabled, isDeleteInProgress: isDeleteInProgress } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6772c8dfb9005672$var$ButtonsContainer, null, isDeleteInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6772c8dfb9005672$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "warning",
        isDisabled: !isDeleteEnabled || isDeleteInProgress,
        onClick: onDelete
    }, formatMessage((0, $9TMpR.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancel
    }, formatMessage((0, $9TMpR.default).cancel)));
}
$6772c8dfb9005672$export$a06f1c675e846f6f.defaultProps = {
    isDeleteEnabled: true,
    isDeleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $6772c8dfb9005672$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6sjW5.default)({
    onCancel: 'cancel',
    onDelete: 'delete'
})((0, $idGBm.injectIntlV2)($6772c8dfb9005672$export$a06f1c675e846f6f));
const $6772c8dfb9005672$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6772c8dfb9005672$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
});

});
parcelRegister("9TMpR", function(module, exports) {
$parcel$export(module.exports, "default", () => $873ac858b28138a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $873ac858b28138a6$var$messages = (0, $7qGN1.defineMessages)({
    delete: {
        "id": "project-directories.versions.delete-version.footer.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "project-directories.versions.delete-version.footer.cancel",
        "defaultMessage": "Cancel"
    }
});
var $873ac858b28138a6$export$2e2bcd8739ae039 = $873ac858b28138a6$var$messages;

});



parcelRegister("fCPpJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e378eaca28ed21bb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $lJKII = parcelRequire("lJKII");

var $fdpHV = parcelRequire("fdpHV");

var $guWba = parcelRequire("guWba");

var $4B7rn = parcelRequire("4B7rn");

var $idGBm = parcelRequire("idGBm");


var $4cTDP = parcelRequire("4cTDP");

var $c4BXL = parcelRequire("c4BXL");
function $e378eaca28ed21bb$export$73392e09138fecd6({ Content: Content, Footer: Footer, isDialogVisible: isDialogVisible, onClose: onClose, intl: { formatMessage: formatMessage }, versionName: versionName }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isDialogVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        messageId: "version-modals.delete-version.modal-dialog",
        messageType: "transactional",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('enghealth-41206-modal-header-close-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $c4BXL.default).title, {
        name: versionName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, null)))));
}
var $e378eaca28ed21bb$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('deleteVersion', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))((0, $idGBm.injectIntlV2)($e378eaca28ed21bb$export$73392e09138fecd6));

});
parcelRegister("c4BXL", function(module, exports) {
$parcel$export(module.exports, "default", () => $84a6531ab466f7a3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $84a6531ab466f7a3$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "project-directories.versions.delete-version.title",
        "defaultMessage": "Delete {name}"
    }
});
var $84a6531ab466f7a3$export$2e2bcd8739ae039 = $84a6531ab466f7a3$var$messages;

});




parcelRegister("8sQb9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4297691ddd51e7cf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dFg4o = parcelRequire("dFg4o");

var $7iHUq = parcelRequire("7iHUq");

var $j5V5L = parcelRequire("j5V5L");

var $vZJ04 = parcelRequire("vZJ04");

var $1j2EU = parcelRequire("1j2EU");

var $8qLnW = parcelRequire("8qLnW");

var $55VVW = parcelRequire("55VVW");
class $4297691ddd51e7cf$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.store = (0, $8qLnW.default)((0, $vZJ04.default));
        this.setAppProps(this.props);
        this.store.dispatch((0, $1j2EU.initialRequest)(this.props.versionId));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((0, $j5V5L.default)(nextProps, this.props)) return;
        this.setAppProps(this.props);
    }
    setAppProps(props) {
        const { projectKey: projectKey, onOpened: onOpened, onError: onError, onSuccess: onSuccess, onCancel: onCancel, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption = false, hasReleaseNote: hasReleaseNote = false } = props;
        this.store.dispatch((0, $dFg4o.batchActions)([
            (0, $1j2EU.setContext)({
                projectKey: projectKey
            }),
            (0, $1j2EU.setHandlers)({
                onOpened: onOpened,
                onError: onError,
                onSuccess: onSuccess,
                onCancel: onCancel
            }),
            (0, $1j2EU.setCreateReleaseNotesOptionConfig)({
                shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption,
                hasReleaseNote: hasReleaseNote
            })
        ]));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            id: "versionReleaseModal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $55VVW.default), null));
    }
}

});
parcelRegister("vZJ04", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf7ae6bc664c708d$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $ibYAQ = parcelRequire("ibYAQ");

var $55jCe = parcelRequire("55jCe");
var $bf7ae6bc664c708d$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $ibYAQ.initialRequestEpic), (0, $ibYAQ.fetchUnresolvedIssues), (0, $55jCe.initialRequestSuccessEpic), (0, $ibYAQ.releaseVersionRequestEpic), (0, $55jCe.releaseVersionRequestFailureEpic), (0, $55jCe.releaseVersionRequestSuccessEpic));

});
parcelRegister("ibYAQ", function(module, exports) {
$parcel$export(module.exports, "initialRequestEpic", () => $5fe985a361418a84$export$73dafa621a3e5eba);
$parcel$export(module.exports, "fetchUnresolvedIssues", () => $5fe985a361418a84$export$5f5c175d78772606);
$parcel$export(module.exports, "releaseVersionRequestEpic", () => $5fe985a361418a84$export$b327638b0f58ac49);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $8dH3d = parcelRequire("8dH3d");

var $jFHCE = parcelRequire("jFHCE");

var $8sbs2 = parcelRequire("8sbs2");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $6a5Bv = parcelRequire("6a5Bv");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");
const $5fe985a361418a84$export$73dafa621a3e5eba = (action$, _store)=>action$.ofType((0, $1j2EU.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        return (0, $7kixv.Observable).fromPromise((0, $6a5Bv.getVersion)(versionId)).mergeMap((version)=>(0, $7kixv.Observable).of((0, $1j2EU.initialRequestSuccess)(version))).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.release.ops.get.version', error.message, error);
            return (0, $7kixv.Observable).of((0, $1j2EU.releaseVersionFailure)({
                id: versionId
            }));
        });
    });
const $5fe985a361418a84$export$5f5c175d78772606 = (action$, _store)=>action$.ofType((0, $1j2EU.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        return (0, $7kixv.Observable).fromPromise((0, $6a5Bv.getUnresolvedIssues)(versionId)).mergeMap((unresolvedIssuesCount)=>(0, $7kixv.Observable).of((0, $1j2EU.setUnreleasedIssuesCount)(unresolvedIssuesCount))).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.release.ops.get.getUnresolvedIssues', error.message, error);
            return (0, $7kixv.Observable).empty();
        });
    });
const $5fe985a361418a84$export$b327638b0f58ac49 = (action$, store)=>action$.ofType((0, $1j2EU.RELEASE_VERSION_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const keepIssues = (0, $gLW5o.isKeepingIssues)(state);
        const version = (0, $gLW5o.getVersion)(state);
        const versionToRelease = keepIssues ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(version, 'moveUnfixedIssuesTo') : version;
        return (0, $7kixv.Observable).fromPromise((0, $6a5Bv.releaseVersion)(versionToRelease)).mergeMap((releasedVersion)=>(0, $7kixv.Observable).of((0, $1j2EU.releaseVersionSuccess)(releasedVersion)))// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ReleaseVersionFailureAction> | Observable<ReleaseVersionValidationFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<ReleaseVersionSuccessAction>) => ObservableInput<ReleaseVersionFailureAction>'.
        .catch((error)=>{
            try {
                const errors = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(JSON.parse(error.message).errors, [
                    'releaseDate',
                    'moveUnfixedIssuesTo'
                ]);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errors)) return (0, $7kixv.Observable).of((0, $1j2EU.releaseVersionValidationFailure)(errors));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
            /**/ }
            (0, $eSnSE.default).safeErrorWithoutCustomerData('project-directories.versions.release.ops.release.version', error.message, error);
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            return (0, $7kixv.Observable).of((0, $1j2EU.releaseVersionFailure)());
        });
    });

});
parcelRegister("6a5Bv", function(module, exports) {
$parcel$export(module.exports, "getVersion", () => $3bcc2cb8286a4087$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssues", () => $3bcc2cb8286a4087$export$d98ed0fcfb679bfe);
$parcel$export(module.exports, "releaseVersion", () => $3bcc2cb8286a4087$export$b8e3d145af76ef26);
$parcel$export(module.exports, "useReleaseAutomationBanner", () => $3bcc2cb8286a4087$export$d9a4a1588da51f7c);

var $eJOHy = parcelRequire("eJOHy");

var $e6YEs = parcelRequire("e6YEs");

var $2aY2d = parcelRequire("2aY2d");

var $f5OzW = parcelRequire("f5OzW");

var $4cTDP = parcelRequire("4cTDP");

var $9lIhr = parcelRequire("9lIhr");

var $dcQQu = parcelRequire("dcQQu");

var $j1zq0 = parcelRequire("j1zq0");

var $4y5Q3 = parcelRequire("4y5Q3");

var $b89ZB = parcelRequire("b89ZB");
const $3bcc2cb8286a4087$export$c506eb22e615ba4a = (versionId)=>(0, $9lIhr.getVersion)(versionId).then((0, $dcQQu.transformVersion)).then((0, $4y5Q3.addDefaultReleaseDate));
const $3bcc2cb8286a4087$export$d98ed0fcfb679bfe = (versionId)=>(0, $9lIhr.getUnresolvedIssuesCount)(versionId).then((0, $dcQQu.transformUnresolvedIssuesCount));
const $3bcc2cb8286a4087$export$b8e3d145af76ef26 = (version)=>(0, $j1zq0.releaseVersion)((0, $4y5Q3.transformReleasableToRestVersion)(version)).then((0, $dcQQu.transformVersion));
const $3bcc2cb8286a4087$export$d9a4a1588da51f7c = ()=>{
    const [showBanner, setShowBanner] = (0, $eJOHy.useState)(false);
    const accountId = (0, $e6YEs.useAccountId)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const safeProjectKey = projectContext?.projectKey ?? '';
    const isJiraAdmin = (0, $f5OzW.useCanAdministerJira)(safeProjectKey);
    const isProjectAdmin = (0, $f5OzW.useCanAdministerProject)(safeProjectKey);
    (0, $eJOHy.useEffect)(()=>{
        if (accountId != null) (0, $b89ZB.getHasDismissedReleaseAutomationBanner)(accountId).then((hasDismissed)=>{
            const canSee = !(0, $4cTDP.fg)('vmc-48-hide-automation-link-for-da') || isJiraAdmin || isProjectAdmin;
            setShowBanner(!hasDismissed && canSee);
        }).catch((0, $b89ZB.fireReleaseAutomationBannerError));
    }, [
        accountId,
        isJiraAdmin,
        isProjectAdmin
    ]);
    const dismissBanner = async ()=>{
        setShowBanner(false);
        if (accountId != null) await (0, $b89ZB.dismissReleaseAutomationBanner)(accountId).catch((0, $b89ZB.fireReleaseAutomationBannerError));
    };
    return {
        showBanner: showBanner,
        dismissBanner: dismissBanner
    };
};

});
parcelRegister("f5OzW", function(module, exports) {
$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $6PAED = parcelRequire("6PAED");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $6PAED.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {
$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$var$store = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {
$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});



parcelRegister("9lIhr", function(module, exports) {
$parcel$export(module.exports, "getVersionEndpointUrl", () => $a9d69a1bff2a7354$export$9513b66f34c81f7d);
$parcel$export(module.exports, "getVersion", () => $a9d69a1bff2a7354$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $a9d69a1bff2a7354$export$b7679bf23524baba);

var $hgi0g = parcelRequire("hgi0g");
const $a9d69a1bff2a7354$export$9513b66f34c81f7d = (versionId)=>`/rest/api/2/version/${versionId}`;
const $a9d69a1bff2a7354$export$18ba274da71f4912 = (versionId)=>`${$a9d69a1bff2a7354$export$9513b66f34c81f7d(versionId)}?expand=issuesstatus`;
const $a9d69a1bff2a7354$export$fdc7e642e6597237 = (versionId)=>`${$a9d69a1bff2a7354$export$9513b66f34c81f7d(versionId)}/unresolvedIssueCount`;
const $a9d69a1bff2a7354$export$c506eb22e615ba4a = (versionId)=>(0, $hgi0g.default)($a9d69a1bff2a7354$export$18ba274da71f4912(versionId));
const $a9d69a1bff2a7354$export$b7679bf23524baba = (versionId)=>(0, $hgi0g.default)($a9d69a1bff2a7354$export$fdc7e642e6597237(versionId));

});

parcelRegister("dcQQu", function(module, exports) {
$parcel$export(module.exports, "transformVersion", () => $31eca736f49fc223$export$390ab7123357e756);
$parcel$export(module.exports, "transformUnresolvedIssuesCount", () => $31eca736f49fc223$export$9c917bd1ad6cfd7f);

var $frPES = parcelRequire("frPES");
const $31eca736f49fc223$var$transformStatus = (archived, released)=>{
    if (archived) return 0, $frPES.ARCHIVED;
    if (released) return 0, $frPES.RELEASED;
    return 0, $frPES.UNRELEASED;
};
const $31eca736f49fc223$var$transformIssuesStatus = ({ toDo: toDo, inProgress: inProgress, done: done })=>({
        toDo: toDo,
        inProgress: inProgress,
        done: done
    });
const $31eca736f49fc223$export$390ab7123357e756 = (restVersion)=>{
    const version = {
        id: restVersion.id,
        name: restVersion.name,
        description: restVersion.description ? restVersion.description : '',
        status: $31eca736f49fc223$var$transformStatus(restVersion.archived, restVersion.released),
        startDate: restVersion.startDate,
        releaseDate: restVersion.releaseDate,
        overdue: !!restVersion.overdue,
        projectId: restVersion.projectId
    };
    if (restVersion.issuesStatusForFixVersion) version.issuesStatus = $31eca736f49fc223$var$transformIssuesStatus(restVersion.issuesStatusForFixVersion);
    return version;
};
const $31eca736f49fc223$export$9c917bd1ad6cfd7f = (rest)=>rest.issuesUnresolvedCount;

});

parcelRegister("j1zq0", function(module, exports) {
$parcel$export(module.exports, "releaseVersion", () => $d806689819f2ce8e$export$b8e3d145af76ef26);

var $l6f8u = parcelRequire("l6f8u");

var $9lIhr = parcelRequire("9lIhr");
const $d806689819f2ce8e$export$b8e3d145af76ef26 = (version)=>{
    const url = (0, $9lIhr.getVersionEndpointUrl)(version.id);
    return (0, $l6f8u.default)(url, {
        method: 'put',
        body: JSON.stringify({
            ...version
        })
    });
};

});
parcelRegister("l6f8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cc1e57cde3e9822$export$2e2bcd8739ae039);

var $14RSn = parcelRequire("14RSn");

var $eBhI6 = parcelRequire("eBhI6");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7cc1e57cde3e9822$var$fetchJson = (url, options = {})=>{
    const option = {
        ...(0, $eBhI6.getDefaultOptions)(url),
        ...options
    };
    return fetch(url, option).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $14RSn.default)(status, str);
            });
        }
        return response.json();
    });
};
var $7cc1e57cde3e9822$export$2e2bcd8739ae039 = $7cc1e57cde3e9822$var$fetchJson;

});


parcelRegister("4y5Q3", function(module, exports) {
$parcel$export(module.exports, "transformReleasableToRestVersion", () => $810f38dae917f803$export$6c7ef87ae81a803f);
$parcel$export(module.exports, "addDefaultReleaseDate", () => $810f38dae917f803$export$a3871b8272282d64);

var $jFHCE = parcelRequire("jFHCE");

var $2M9u3 = parcelRequire("2M9u3");
const $810f38dae917f803$export$6c7ef87ae81a803f = (version)=>{
    const restVersion = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(version, [
        'issuesStatus'
    ]);
    return {
        ...restVersion,
        released: true,
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
        releaseDate: (0, $2M9u3.atlasKitToServerDateFormat)(version.releaseDate)
    };
};
const $810f38dae917f803$export$a3871b8272282d64 = (version)=>{
    const { id: id, name: name, releaseDate: releaseDate, issuesStatus: issuesStatus } = version;
    return {
        id: id,
        name: name,
        issuesStatus: issuesStatus,
        moveUnfixedIssuesTo: '',
        releaseDate: releaseDate ? (0, $2M9u3.ISOToAtlasKitDateFormat)(releaseDate) : (0, $2M9u3.todayToAtlasKitDateFormat)()
    };
};

});
parcelRegister("2M9u3", function(module, exports) {
$parcel$export(module.exports, "ISOToAtlasKitDateFormat", () => $fb23e6c1d2768f48$export$4df2a4adbb0e5391);
$parcel$export(module.exports, "todayToAtlasKitDateFormat", () => $fb23e6c1d2768f48$export$d9939b5b983bc908);
$parcel$export(module.exports, "atlasKitToServerDateFormat", () => $fb23e6c1d2768f48$export$bcd9d8ad44970e94);
// GOOD TO KNOW
// ------------
// Atlaskit DatePicker has two date formats:
// 1. YYYY/MM/DD which user sees on the screen
// 2. YYYY-MM-DD which DatePicker passes to the onChange callback (ISO format)
//
// Sometimes Atlaskit doesn't convert user-input date (YYYY/MM/DD) to the ISO format.
// It happens when some action gets dispatched before DatePicker receives blur event.
// So we fix it here by replacing `/` with `-`.

var $57raR = parcelRequire("57raR");

var $guEFH = parcelRequire("guEFH");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $lTtQZ = parcelRequire("lTtQZ");
const $fb23e6c1d2768f48$export$c9b0b9ddba618847 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $kQ82p.default)(dateStr.replace(/\//g, '-'));
        if ((0, $dBLX0.default)(date)) return (0, $57raR.default)(new Date(date), 'yyyy-MM-dd');
    }
    return '';
};
const $fb23e6c1d2768f48$export$4df2a4adbb0e5391 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $kQ82p.default)(dateStr);
        if ((0, $dBLX0.default)(date)) return (0, $57raR.default)(new Date(date), 'yyyy/MM/dd');
    }
    return '';
};
const $fb23e6c1d2768f48$export$d9939b5b983bc908 = ()=>(0, $57raR.default)((0, $lTtQZ.default)(), 'yyyy/MM/dd');
const $fb23e6c1d2768f48$export$6350eb346dee22fe = (dateStr)=>{
    if (dateStr) return (0, $dBLX0.default)((0, $kQ82p.default)(dateStr.replace(/\//g, '-')));
    return false;
};
const $fb23e6c1d2768f48$export$bcd9d8ad44970e94 = (dateStr)=>{
    let dateISO;
    if (dateStr && $fb23e6c1d2768f48$export$6350eb346dee22fe(dateStr)) dateISO = $fb23e6c1d2768f48$export$c9b0b9ddba618847(dateStr);
    return dateISO || null;
};
const $fb23e6c1d2768f48$export$e36c611b04695a2e = (dateStr)=>{
    const date = (0, $kQ82p.default)(dateStr);
    if ((0, $dBLX0.default)(date)) return (0, $guEFH.default)(date);
    return undefined;
};
const $fb23e6c1d2768f48$export$8d60448f563c47a6 = {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
};

});


parcelRegister("b89ZB", function(module, exports) {
$parcel$export(module.exports, "getHasDismissedReleaseAutomationBanner", () => $95158b9658bbb040$export$b8702a08258e1098);
$parcel$export(module.exports, "dismissReleaseAutomationBanner", () => $95158b9658bbb040$export$7f678873378110b8);
$parcel$export(module.exports, "fireReleaseAutomationBannerError", () => $95158b9658bbb040$export$76cf25de6ffb8030);

var $9pTd3 = parcelRequire("9pTd3");

var $eBhI6 = parcelRequire("eBhI6");
const $95158b9658bbb040$export$b8702a08258e1098 = async (accountId)=>{
    const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
    const fetchResponse = await fetch(url, (0, $eBhI6.getDefaultOptions)(url));
    // ok is true only when status code is 2xx.
    if (fetchResponse.ok) {
        const responseObj = await fetchResponse.json();
        return responseObj.value;
    }
    const { status: status } = fetchResponse;
    // 401: If credential is incorrect, the user is not authorised and should not see the banner
    if (status === 401) return true;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the banner
    if (status === 404) return false;
    throw new Error(`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`);
};
const $95158b9658bbb040$export$7f678873378110b8 = async (accountId)=>{
    const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
    const fetchResponse = await fetch(url, {
        ...(0, $eBhI6.getDefaultOptions)(url),
        method: 'PUT',
        body: JSON.stringify(true)
    });
    if (!fetchResponse.ok) throw Error('Failed to dismiss release automation banner via user properties.');
};
const $95158b9658bbb040$export$76cf25de6ffb8030 = (error)=>(0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'versions.release.version.modal.release.automation.user.property',
            packageName: 'jiraVersionModals',
            teamName: 'jolt'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });

});


parcelRegister("1j2EU", function(module, exports) {
$parcel$export(module.exports, "SET_CONTEXT", () => $4059eda9add4a05f$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $4059eda9add4a05f$export$2f04de43fe27971a);
$parcel$export(module.exports, "SET_HANDLERS", () => $4059eda9add4a05f$export$bc2eae499d5e6cec);
$parcel$export(module.exports, "setHandlers", () => $4059eda9add4a05f$export$241365d6eef6c169);
$parcel$export(module.exports, "INITIAL_REQUEST", () => $4059eda9add4a05f$export$e1efaa8f406867bb);
$parcel$export(module.exports, "initialRequest", () => $4059eda9add4a05f$export$3bccc812fdbc3954);
$parcel$export(module.exports, "INITIAL_REQUEST_SUCCESS", () => $4059eda9add4a05f$export$37a4e72ae1c0a1b5);
$parcel$export(module.exports, "initialRequestSuccess", () => $4059eda9add4a05f$export$fbef4e4c40c06dae);
$parcel$export(module.exports, "SET_VERSION_UNRESOLVED_ISSUES_COUNT", () => $4059eda9add4a05f$export$a558394b02430fa);
$parcel$export(module.exports, "setUnreleasedIssuesCount", () => $4059eda9add4a05f$export$521ad3c091ef9f4b);
$parcel$export(module.exports, "SWAP_ISSUES", () => $4059eda9add4a05f$export$1e105c795f4df801);
$parcel$export(module.exports, "swapIssues", () => $4059eda9add4a05f$export$f9d0b46042c1093d);
$parcel$export(module.exports, "RELEASE_VERSION_UPDATE", () => $4059eda9add4a05f$export$a7943bb075347bd4);
$parcel$export(module.exports, "releaseVersionUpdate", () => $4059eda9add4a05f$export$6e5a7b93aba64e1c);
$parcel$export(module.exports, "RELEASE_VERSION_REQUEST", () => $4059eda9add4a05f$export$b482a6a2418379a4);
$parcel$export(module.exports, "releaseVersionRequest", () => $4059eda9add4a05f$export$f25b64441359ac5d);
$parcel$export(module.exports, "RELEASE_VERSION_SUCCESS", () => $4059eda9add4a05f$export$9f45f3d28614fd39);
$parcel$export(module.exports, "releaseVersionSuccess", () => $4059eda9add4a05f$export$ef2ca233886223dd);
$parcel$export(module.exports, "RELEASE_VERSION_FAILURE", () => $4059eda9add4a05f$export$f79008eab89d4f56);
$parcel$export(module.exports, "releaseVersionFailure", () => $4059eda9add4a05f$export$f40837cd887e0e7d);
$parcel$export(module.exports, "RELEASE_VERSION_VALIDATION_FAILURE", () => $4059eda9add4a05f$export$15feef518e3a0f72);
$parcel$export(module.exports, "releaseVersionValidationFailure", () => $4059eda9add4a05f$export$d206bb816a78117c);
$parcel$export(module.exports, "CREATE_RELEASE_NOTES_OPTIONS", () => $4059eda9add4a05f$export$95df9c1149c6615a);
$parcel$export(module.exports, "setCreateReleaseNotesOptionConfig", () => $4059eda9add4a05f$export$778db09b7ef0e606);
$parcel$export(module.exports, "RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS", () => $4059eda9add4a05f$export$95c8c0da90c589f);
$parcel$export(module.exports, "releaseRedirectToCreateReleaseNotesStatus", () => $4059eda9add4a05f$export$bec051bc82fda7b3);
const $4059eda9add4a05f$export$4bc4e62e7d72b94b = 'release-version-modal.state.SET_CONTEXT';
const $4059eda9add4a05f$export$2f04de43fe27971a = (payload)=>({
        type: $4059eda9add4a05f$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $4059eda9add4a05f$export$bc2eae499d5e6cec = 'release-version-modal.state.SET_HANDLERS';
const $4059eda9add4a05f$export$241365d6eef6c169 = (payload)=>({
        type: $4059eda9add4a05f$export$bc2eae499d5e6cec,
        payload: payload
    });
const $4059eda9add4a05f$export$e1efaa8f406867bb = 'release-version-modal.state.INITIAL_REQUEST';
const $4059eda9add4a05f$export$3bccc812fdbc3954 = (versionId)=>({
        type: $4059eda9add4a05f$export$e1efaa8f406867bb,
        payload: versionId
    });
const $4059eda9add4a05f$export$37a4e72ae1c0a1b5 = 'release-version-modal.state.INITIAL_REQUEST_SUCCESS';
const $4059eda9add4a05f$export$fbef4e4c40c06dae = (version)=>({
        type: $4059eda9add4a05f$export$37a4e72ae1c0a1b5,
        payload: version
    });
const $4059eda9add4a05f$export$a558394b02430fa = 'release-version-modal.state.SET_VERSION_UNRESOLVED_ISSUES_COUNT';
const $4059eda9add4a05f$export$521ad3c091ef9f4b = (payload)=>({
        type: $4059eda9add4a05f$export$a558394b02430fa,
        payload: payload
    });
const $4059eda9add4a05f$export$33d1af9ce619539e = 'release-version-modal.state.SET_VERSION';
const $4059eda9add4a05f$export$f99c3c9c04cda7ae = (payload)=>({
        type: $4059eda9add4a05f$export$33d1af9ce619539e,
        payload: payload
    });
const $4059eda9add4a05f$export$1e105c795f4df801 = 'release-version-modal.state.SWAP_ISSUES';
const $4059eda9add4a05f$export$f9d0b46042c1093d = (payload)=>({
        type: $4059eda9add4a05f$export$1e105c795f4df801,
        payload: payload
    });
const $4059eda9add4a05f$export$a7943bb075347bd4 = 'release-version-modal.state.RELEASE_VERSION_UPDATE';
const $4059eda9add4a05f$export$6e5a7b93aba64e1c = (payload)=>({
        type: $4059eda9add4a05f$export$a7943bb075347bd4,
        payload: payload
    });
const $4059eda9add4a05f$export$b482a6a2418379a4 = 'release-version-modal.state.RELEASE_VERSION_REQUEST';
const $4059eda9add4a05f$export$f25b64441359ac5d = ()=>({
        type: $4059eda9add4a05f$export$b482a6a2418379a4
    });
const $4059eda9add4a05f$export$9f45f3d28614fd39 = 'release-version-modal.state.RELEASE_VERSION_SUCCESS';
const $4059eda9add4a05f$export$ef2ca233886223dd = (payload)=>({
        type: $4059eda9add4a05f$export$9f45f3d28614fd39,
        payload: payload
    });
const $4059eda9add4a05f$export$f79008eab89d4f56 = 'release-version-modal.state.RELEASE_VERSION_FAILURE';
const $4059eda9add4a05f$export$f40837cd887e0e7d = (payload)=>({
        type: $4059eda9add4a05f$export$f79008eab89d4f56,
        payload: payload
    });
const $4059eda9add4a05f$export$15feef518e3a0f72 = 'release-version-modal.state.RELEASE_VERSION_VALIDATION_FAILURE';
const $4059eda9add4a05f$export$d206bb816a78117c = (payload)=>({
        type: $4059eda9add4a05f$export$15feef518e3a0f72,
        payload: payload
    });
const $4059eda9add4a05f$export$95df9c1149c6615a = 'release-version-modal.state.CREATE_RELEASE_NOTES_OPTIONS';
const $4059eda9add4a05f$export$778db09b7ef0e606 = (payload)=>({
        type: $4059eda9add4a05f$export$95df9c1149c6615a,
        payload: payload
    });
const $4059eda9add4a05f$export$95c8c0da90c589f = 'release-version-modal.state.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS';
const $4059eda9add4a05f$export$bec051bc82fda7b3 = (payload)=>({
        type: $4059eda9add4a05f$export$95c8c0da90c589f,
        payload: payload
    });

});

parcelRegister("gLW5o", function(module, exports) {
$parcel$export(module.exports, "getProjectKey", () => $1a8df3e691c7a226$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getVersion", () => $1a8df3e691c7a226$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getVersionId", () => $1a8df3e691c7a226$export$d0a84488c5034e2b);
$parcel$export(module.exports, "getTodoInProgressIssuesCount", () => $1a8df3e691c7a226$export$7c32856ef2a2cb6);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $1a8df3e691c7a226$export$b7679bf23524baba);
$parcel$export(module.exports, "getResolvedIssuesCount", () => $1a8df3e691c7a226$export$96488947387acc21);
$parcel$export(module.exports, "getDoneIssuesCount", () => $1a8df3e691c7a226$export$51a75c074eb3f4d4);
$parcel$export(module.exports, "getName", () => $1a8df3e691c7a226$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getReleaseDate", () => $1a8df3e691c7a226$export$9664966f747b3c18);
$parcel$export(module.exports, "getErrors", () => $1a8df3e691c7a226$export$501239432719417d);
$parcel$export(module.exports, "isSwapSelected", () => $1a8df3e691c7a226$export$8fff49f07292ff94);
$parcel$export(module.exports, "isSaving", () => $1a8df3e691c7a226$export$3b51d1dcee070cea);
$parcel$export(module.exports, "isInitiating", () => $1a8df3e691c7a226$export$8b35c3a55e549a0d);
$parcel$export(module.exports, "getOnOpenedHandler", () => $1a8df3e691c7a226$export$9cb228195867c4ba);
$parcel$export(module.exports, "getOnErrorHandler", () => $1a8df3e691c7a226$export$1a207b7e599ecdc7);
$parcel$export(module.exports, "getOnSuccessHandler", () => $1a8df3e691c7a226$export$8fb55c0bc571e8e7);
$parcel$export(module.exports, "getOnCancelHandler", () => $1a8df3e691c7a226$export$e776433ed4e15cc4);
$parcel$export(module.exports, "getPropsForVersionPicker", () => $1a8df3e691c7a226$export$95a1217518b748b8);
$parcel$export(module.exports, "isReleaseDisabled", () => $1a8df3e691c7a226$export$2a2f3b8b22c4af1f);
$parcel$export(module.exports, "isKeepingIssues", () => $1a8df3e691c7a226$export$e783a0e680cad4ec);
$parcel$export(module.exports, "shouldShowCreateReleaseNotesOption", () => $1a8df3e691c7a226$export$37c3a3cc47342e65);
$parcel$export(module.exports, "shouldRedirectToCreateReleaseNotes", () => $1a8df3e691c7a226$export$24122e8f86a884b6);

var $ahm5r = parcelRequire("ahm5r");
const $1a8df3e691c7a226$export$667f2a0f99c75faa = (state)=>state.context.projectKey;
const $1a8df3e691c7a226$export$c506eb22e615ba4a = (state)=>state.version;
const $1a8df3e691c7a226$export$57294fc3393f82ae = (state)=>state.version.moveUnfixedIssuesTo;
const $1a8df3e691c7a226$export$d0a84488c5034e2b = (state)=>state.version.id;
const $1a8df3e691c7a226$export$7c32856ef2a2cb6 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $1a8df3e691c7a226$export$b7679bf23524baba = (state)=>state.unresolvedIssuesCount;
const $1a8df3e691c7a226$export$36e4434605c3220 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done + state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $1a8df3e691c7a226$export$96488947387acc21 = (state)=>$1a8df3e691c7a226$export$36e4434605c3220(state) - $1a8df3e691c7a226$export$b7679bf23524baba(state);
const $1a8df3e691c7a226$export$51a75c074eb3f4d4 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done;
    return 0;
};
const $1a8df3e691c7a226$export$7d9f7e9c1c02b41e = (state)=>$1a8df3e691c7a226$export$c506eb22e615ba4a(state).name || '';
const $1a8df3e691c7a226$export$9664966f747b3c18 = (state)=>$1a8df3e691c7a226$export$c506eb22e615ba4a(state).releaseDate || '';
const $1a8df3e691c7a226$export$501239432719417d = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.errors, (errors)=>{
    const { releaseDate: releaseDate = '', moveUnfixedIssuesTo: moveUnfixedIssuesTo = '' } = errors || {};
    return {
        releaseDate: releaseDate,
        moveUnfixedIssuesTo: moveUnfixedIssuesTo
    };
});
const $1a8df3e691c7a226$export$8fff49f07292ff94 = (state)=>state.shouldSwapIssues;
const $1a8df3e691c7a226$export$3b51d1dcee070cea = (state)=>!!state.isSaving;
const $1a8df3e691c7a226$export$8b35c3a55e549a0d = (state)=>!!state.isInitiating;
const $1a8df3e691c7a226$export$9cb228195867c4ba = (state)=>state.handlers.onOpened;
const $1a8df3e691c7a226$export$1a207b7e599ecdc7 = (state)=>state.handlers.onError;
const $1a8df3e691c7a226$export$8fb55c0bc571e8e7 = (state)=>state.handlers.onSuccess;
const $1a8df3e691c7a226$export$e776433ed4e15cc4 = (state)=>state.handlers.onCancel;
const $1a8df3e691c7a226$export$95a1217518b748b8 = (state)=>({
        projectKey: state.context.projectKey,
        shouldSwapIssues: state.shouldSwapIssues,
        isSaving: state.isSaving,
        versionId: state.version.id
    });
const $1a8df3e691c7a226$var$hasTodoInProgressIssues = (state)=>$1a8df3e691c7a226$export$7c32856ef2a2cb6(state) > 0;
const $1a8df3e691c7a226$export$2a2f3b8b22c4af1f = (state)=>state.isSaving || $1a8df3e691c7a226$export$b7679bf23524baba(state) > 0 && state.shouldSwapIssues && !$1a8df3e691c7a226$export$57294fc3393f82ae(state);
const $1a8df3e691c7a226$export$e783a0e680cad4ec = (state)=>{
    if ($1a8df3e691c7a226$var$hasTodoInProgressIssues(state)) return state.shouldSwapIssues ? !$1a8df3e691c7a226$export$57294fc3393f82ae(state) : true;
    return true;
};
const $1a8df3e691c7a226$export$37c3a3cc47342e65 = (state)=>state.shouldShowCreateReleaseNotesOption;
const $1a8df3e691c7a226$export$24122e8f86a884b6 = (state)=>state.shouldRedirectToCreateReleaseNotes;

});


parcelRegister("55jCe", function(module, exports) {
$parcel$export(module.exports, "initialRequestSuccessEpic", () => $4b1d07453b825a2a$export$9d210f02e9fc914d);
$parcel$export(module.exports, "releaseVersionRequestSuccessEpic", () => $4b1d07453b825a2a$export$77863bf7469abd8f);
$parcel$export(module.exports, "releaseVersionRequestFailureEpic", () => $4b1d07453b825a2a$export$79de050f634d0345);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");
const $4b1d07453b825a2a$export$9d210f02e9fc914d = (action$, store)=>action$.ofType((0, $1j2EU.INITIAL_REQUEST_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const versionId = (0, $gLW5o.getVersionId)(state);
        (0, $gLW5o.getOnOpenedHandler)(state)({
            id: versionId
        });
        return (0, $7kixv.Observable).empty();
    });
const $4b1d07453b825a2a$export$77863bf7469abd8f = (action$, store)=>action$.ofType((0, $1j2EU.RELEASE_VERSION_SUCCESS)).mergeMap(({ payload: version })=>{
        const state = store.getState();
        (0, $gLW5o.getOnSuccessHandler)(state)(version, {
            shouldRedirectToCreateReleaseNotes: (0, $gLW5o.shouldRedirectToCreateReleaseNotes)(state)
        });
        return (0, $7kixv.Observable).empty();
    });
const $4b1d07453b825a2a$export$79de050f634d0345 = (action$, store)=>action$.ofType((0, $1j2EU.RELEASE_VERSION_FAILURE)).mergeMap(({ payload: id })=>{
        const state = store.getState();
        (0, $gLW5o.getOnErrorHandler)(state)(id);
        return (0, $7kixv.Observable).empty();
    });

});


parcelRegister("8qLnW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b547e08dd4b5da3$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $lRdZJ = parcelRequire("lRdZJ");
const $0b547e08dd4b5da3$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'release-version',
        rootReducer: $lRdZJ.default,
        rootEpic: rootEpic
    });
var $0b547e08dd4b5da3$export$2e2bcd8739ae039 = $0b547e08dd4b5da3$var$createStore;

});
parcelRegister("lRdZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1940dfed1e9cdbea$export$2e2bcd8739ae039);

var $Xz6kS = parcelRequire("Xz6kS");

var $1O6Yz = parcelRequire("1O6Yz");

var $12DRg = parcelRequire("12DRg");

var $jFHCE = parcelRequire("jFHCE");

var $1j2EU = parcelRequire("1j2EU");
const $1940dfed1e9cdbea$export$d4c72bab9d6cc13a = {
    context: {
        projectKey: ''
    },
    handlers: {
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    },
    version: {
        id: '0',
        name: ''
    },
    unresolvedIssuesCount: 0,
    shouldSwapIssues: true,
    isInitiating: true,
    isSaving: false,
    shouldShowCreateReleaseNotesOption: false,
    hasReleaseNote: false,
    shouldRedirectToCreateReleaseNotes: true
};
const $1940dfed1e9cdbea$var$reducer = (state = $1940dfed1e9cdbea$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $1j2EU.SET_CONTEXT:
            {
                const context = action.payload;
                // @ts-expect-error - TS2322 - Type 'SetContextPayload | undefined' is not assignable to type '{ readonly readonly projectKey: string; }'.
                return {
                    ...state,
                    context: context
                };
            }
        case 0, $1j2EU.SET_VERSION_UNRESOLVED_ISSUES_COUNT:
            {
                const unresolvedIssuesCount = action.payload;
                return {
                    ...state,
                    unresolvedIssuesCount: unresolvedIssuesCount || 0
                };
            }
        case 0, $1j2EU.SWAP_ISSUES:
            // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            return {
                ...state,
                shouldSwapIssues: action.payload
            };
        case 0, $1j2EU.SET_HANDLERS:
            {
                const handlers = action.payload;
                return {
                    ...state,
                    handlers: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, state.handlers, handlers)
                };
            }
        case 0, $1j2EU.INITIAL_REQUEST_SUCCESS:
            {
                const version = action.payload;
                // @ts-expect-error - TS2322 - Type 'Pick<{ version: ReleasableVersion | undefined; context: { readonly readonly projectKey: string; }; handlers: Handlers; errors?: ReleaseVersionValidationErrors | undefined; isInitiating?: boolean | undefined; isSaving?: boolean | undefined; shouldSwapIssues: boolean; }, "version" | ... 4 more ... | "...' is not assignable to type 'State'.
                return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
                    ...state,
                    version: version
                }, 'isInitiating');
            }
        case 0, $1j2EU.RELEASE_VERSION_UPDATE:
            {
                const prevVersion = state.version;
                const prevErrors = state.errors;
                const nextVersion = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const errors = {};
                if (action.payload && action.payload.moveUnfixedIssuesTo) errors.moveUnfixedIssuesTo = '';
                if (action.payload && action.payload.releaseDate) errors.releaseDate = '';
                return {
                    ...state,
                    errors: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, prevErrors, errors),
                    version: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, prevVersion, nextVersion)
                };
            }
        case 0, $1j2EU.RELEASE_VERSION_VALIDATION_FAILURE:
            {
                const errors = action.payload;
                return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
                    ...state,
                    errors: errors
                }, 'isSaving');
            }
        case 0, $1j2EU.RELEASE_VERSION_REQUEST:
            return {
                ...state,
                isSaving: true
            };
        case 0, $1j2EU.RELEASE_VERSION_SUCCESS:
        case 0, $1j2EU.RELEASE_VERSION_FAILURE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state, 'isSaving');
        case 0, $1j2EU.INITIAL_REQUEST:
            return state;
        case 0, $1j2EU.CREATE_RELEASE_NOTES_OPTIONS:
            return {
                ...state,
                ...action.payload,
                shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false)
            };
        case 0, $1j2EU.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS:
            {
                const shouldRedirectToCreateReleaseNotes = action.payload !== undefined ? action.payload : false;
                return {
                    ...state,
                    shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $1940dfed1e9cdbea$export$2e2bcd8739ae039 = $1940dfed1e9cdbea$var$reducer;

});


parcelRegister("55VVW", function(module, exports) {
$parcel$export(module.exports, "default", () => $509dc8b928671c4f$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");

var $btYbu = parcelRequire("btYbu");

var $fZ8fz = parcelRequire("fZ8fz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $509dc8b928671c4f$var$mapStateToProps = (state)=>({
        unresolvedIssuesCount: (0, $gLW5o.getUnresolvedIssuesCount)(state),
        isReleaseDisabled: (0, $gLW5o.isReleaseDisabled)(state),
        name: (0, $gLW5o.getName)(state),
        isSaving: (0, $gLW5o.isSaving)(state),
        isInitiating: (0, $gLW5o.isInitiating)(state),
        onCancel: (0, $gLW5o.getOnCancelHandler)(state),
        Content: $btYbu.default,
        shouldRedirectToCreateReleaseNotes: (0, $gLW5o.shouldRedirectToCreateReleaseNotes)(state),
        shouldShowCreateReleaseNotesOption: (0, $gLW5o.shouldShowCreateReleaseNotesOption)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $509dc8b928671c4f$var$dispatcher = (dispatch)=>({
        onRelease: ()=>dispatch((0, $1j2EU.releaseVersionRequest)()),
        setRedirectToCreateReleaseNotesStatus: (value)=>dispatch((0, $1j2EU.releaseRedirectToCreateReleaseNotesStatus)(value))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $509dc8b928671c4f$var$mapDispatchToProps = (dispatch)=>$509dc8b928671c4f$var$dispatcher(dispatch);
var $509dc8b928671c4f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($509dc8b928671c4f$var$mapStateToProps, $509dc8b928671c4f$var$mapDispatchToProps)((0, $fZ8fz.default));

});
parcelRegister("btYbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $25159c5cf854cb39$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $duHz5 = parcelRequire("duHz5");

var $gLW5o = parcelRequire("gLW5o");

var $6bKRV = parcelRequire("6bKRV");

var $aMFUs = parcelRequire("aMFUs");

var $7LVYa = parcelRequire("7LVYa");

var $kb64x = parcelRequire("kb64x");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $25159c5cf854cb39$var$mapStateToProps = (state)=>({
        SwapIssues: $7LVYa.default,
        ReleaseDate: $aMFUs.default,
        ReleaseAutomationBanner: $6bKRV.ReleaseAutomationBanner,
        doneIssues: (0, $gLW5o.getDoneIssuesCount)(state),
        unresolvedIssuesCount: (0, $gLW5o.getUnresolvedIssuesCount)(state),
        resolvedIssuesCount: (0, $gLW5o.getResolvedIssuesCount)(state),
        unresolvedIssuesUrl: (0, $duHz5.getUnresolvedIssuesInVersionJql)((0, $gLW5o.getProjectKey)(state), (0, $gLW5o.getName)(state)),
        resolvedIssueUrl: (0, $duHz5.getResolvedIssuesInVersionJql)((0, $gLW5o.getProjectKey)(state), (0, $gLW5o.getName)(state))
    });
var $25159c5cf854cb39$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($25159c5cf854cb39$var$mapStateToProps, {})((0, $kb64x.default));

});
parcelRegister("duHz5", function(module, exports) {
$parcel$export(module.exports, "getUnresolvedIssuesInVersionJql", () => $c1dc4f42aad7c9ce$export$6ec377b2fc8168c7);
$parcel$export(module.exports, "getResolvedIssuesInVersionJql", () => $c1dc4f42aad7c9ce$export$c14e075033246e76);

var $bnIBr = parcelRequire("bnIBr");
const $c1dc4f42aad7c9ce$export$6ec377b2fc8168c7 = (projectKey, versionName)=>{
    const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND fixVersion = ${(0, $bnIBr.toQuotedString)(versionName)} AND resolution is EMPTY`;
    return (0, $bnIBr.createAllWorkUrl)(jql);
};
const $c1dc4f42aad7c9ce$export$c14e075033246e76 = (projectKey, versionName)=>(0, $bnIBr.createAllWorkUrl)(`project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND fixVersion = ${(0, $bnIBr.toQuotedString)(versionName)} AND resolution is NOT EMPTY`);

});

parcelRegister("6bKRV", function(module, exports) {
$parcel$export(module.exports, "ReleaseAutomationBanner", () => $cdcff1031e7cba19$export$45e1a2bd60e730ec);
/* ReleaseAutomationBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bmZ1f = parcelRequire("bmZ1f");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $4ECjj = parcelRequire("4ECjj");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $6a5Bv = parcelRequire("6a5Bv");

var $jM32i = parcelRequire("jM32i");

var $hh0mH = parcelRequire("hh0mH");
const $cdcff1031e7cba19$export$d6be0a6034032add = (projectProps)=>`${(0, $4ECjj.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $cdcff1031e7cba19$export$45e1a2bd60e730ec = ({ isTransitionEnabled: isTransitionEnabled = true })=>{
    const { showBanner: showBanner, dismissBanner: dismissBanner } = (0, $6a5Bv.useReleaseAutomationBanner)();
    const { data: projectContext, loading: loading, error: error } = (0, $2aY2d.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if (loading) return null;
    if (error) throw error;
    if (projectContext == null) throw Error('Missing project context when rendering ReleaseAutomationBanner');
    const { simplified: isSimplified, projectKey: projectKey, projectType: projectType } = projectContext;
    const renderBannerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        width: 14,
        height: 16,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jM32i))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$CallToAction, {
        href: $cdcff1031e7cba19$export$d6be0a6034032add({
            isSimplified: isSimplified,
            projectKey: projectKey,
            projectType: projectType
        }),
        target: "_blank",
        rel: "noopener noreferrer",
        title: formatMessage((0, $hh0mH.default).setupReleaseAutomation),
        onClick: ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'newRuleAutomationLink');
            dismissBanner();
        }
    }, formatMessage((0, $hh0mH.default).setupReleaseAutomation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Dismiss, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        shouldFitContainer: true,
        appearance: "subtle" // eslint-disable-next-line jira/react-no-inline-function-prop
        ,
        onClick: (_, analyticsEvent)=>{
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'dismissButton');
            dismissBanner();
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: formatMessage((0, $hh0mH.default).dismiss)
        })
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$238d30785c4bca84),
        sourceName: "releaseAutomationCallToAction"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), isTransitionEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cdcff1031e7cba19$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmZ1f.default), {
        in: showBanner,
        timeout: $cdcff1031e7cba19$var$TRANSITION_DURATION,
        classNames: "release-automation-banner",
        unmountOnExit: true
    }, renderBannerContent)) : renderBannerContent);
};
const $cdcff1031e7cba19$var$BANNER_HEIGHT = 80;
const $cdcff1031e7cba19$var$TRANSITION_DURATION = 400; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _zulppxbi _189e1dm9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$CallToAction = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Dismiss = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Spacer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdcff1031e7cba19$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lnbg15vq _11ok15vq _1k7uidpf _pmb0idpf _1sz115vq _iayz15vq _19q1o91y _lghnkb7n _3g9qys9h _1b0e15vq _19ci15vq _28jmkb7n _13e1ys9h _1g5d15vq _153n15vq _khvao91y _zsv0idpf _qigkidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ECjj", function(module, exports) {
$parcel$export(module.exports, "getBaseAutomationUrl", () => $b690f45aef8a790c$export$8e479e490e1e69bc);
const $b690f45aef8a790c$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("jM32i", function(module, exports) {
module.exports = new URL("lightning.44c03a60.svg", import.meta.url).toString();

});

parcelRegister("hh0mH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f22b00838365592$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5f22b00838365592$var$messages = (0, $7qGN1.defineMessages)({
    setupReleaseAutomation: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation",
        "defaultMessage": "Set up release automation"
    },
    dismiss: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $5f22b00838365592$export$2e2bcd8739ae039 = $5f22b00838365592$var$messages;

});


parcelRegister("aMFUs", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a46d50b5ab0119a$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");

var $hzbrQ = parcelRequire("hzbrQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a46d50b5ab0119a$var$mapStateToProps = (state)=>({
        releaseDate: (0, $gLW5o.getReleaseDate)(state),
        errors: (0, $gLW5o.getErrors)(state),
        isSaving: (0, $gLW5o.isSaving)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a46d50b5ab0119a$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $1j2EU.releaseVersionUpdate)(version))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a46d50b5ab0119a$var$mapDispatchToProps = (dispatch)=>$7a46d50b5ab0119a$var$dispatcher(dispatch);
var $7a46d50b5ab0119a$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($7a46d50b5ab0119a$var$mapStateToProps, $7a46d50b5ab0119a$var$mapDispatchToProps)((0, $hzbrQ.default));

});
parcelRegister("hzbrQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7633d1d443ba987b$export$2e2bcd8739ae039);
/* ReleaseDatePicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fTjQo = parcelRequire("fTjQo");

var $iUa8i = parcelRequire("iUa8i");

var $6svxr = parcelRequire("6svxr");

var $h3OS7 = parcelRequire("h3OS7");

var $idGBm = parcelRequire("idGBm");

var $fgNUD = parcelRequire("fgNUD");

var $fvP65 = parcelRequire("fvP65");
class $7633d1d443ba987b$export$55e7fadddcffb796 extends (0, $eJOHy.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            releaseDate: update.releaseDate
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage, locale: locale }, releaseDate: releaseDate, errors: errors, isSaving: isSaving } = this.props;
        const { releaseDate: releaseDateError } = errors;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            id: formatMessage((0, $fvP65.default).releaseDate),
            name: "releaseDate",
            label: formatMessage((0, $fvP65.default).releaseDate)
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7633d1d443ba987b$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgNUD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUa8i.default), {
                id: formatMessage((0, $fvP65.default).releaseDate),
                isDisabled: isSaving,
                defaultValue: releaseDate !== '' ? (0, $fTjQo.default)(new Date(releaseDate)) : releaseDate,
                onChange: this.onReleaseDateChange,
                placeholder: formatMessage((0, $h3OS7.default).placeholderDate),
                locale: locale,
                shouldShowCalendarButton: true
            })))), releaseDateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7633d1d443ba987b$var$ValidationError, null, releaseDateError));
    }
    constructor(...args){
        super(...args), this.onReleaseDateChange = (releaseDate)=>{
            if (releaseDate) this.inputChange({
                releaseDate: releaseDate
            });
            else this.inputChange({
                releaseDate: ''
            });
        };
    }
}
var $7633d1d443ba987b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($7633d1d443ba987b$export$55e7fadddcffb796);
const $7633d1d443ba987b$var$DatePickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7633d1d443ba987b$var$ValidationError = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _syaz1tmw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUa8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8d7b5e7995f81e7$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");
const $b8d7b5e7995f81e7$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b8d7b5e7995f81e7$export$2e2bcd8739ae039 = $b8d7b5e7995f81e7$var$DatePicker;

});
parcelRegister("1BRZx", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $48de19f2c65a8561$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $48de19f2c65a8561$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("lLHJE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fe32780a1f5c05c$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $2fe32780a1f5c05c$var$packageName = "platform-pkg";
const $2fe32780a1f5c05c$var$packageVersion = "0.0.0-use.local";
const $2fe32780a1f5c05c$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $2fe32780a1f5c05c$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $2fe32780a1f5c05c$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $2fe32780a1f5c05c$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $47or1.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $47or1.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1u9xN.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $47or1.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date()),
            l10n: (0, $cK9J2.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $cK9J2.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2fe32780a1f5c05c$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gNwsY.Menu,
            // SingleValue is defined in the render because of UI generator limitations
            ...!showClearIndicator && {
                ClearIndicator: (0, $RoXqn.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $47or1.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $2fe32780a1f5c05c$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    children: ({ id: valueId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                            appearance: this.props.appearance,
                            "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                            label: label || undefined,
                            autoFocus: autoFocus,
                            clearControlLabel: clearControlLabel,
                            closeMenuOnSelect: true,
                            enableAnimation: false,
                            inputId: id,
                            inputValue: actualSelectInputValue,
                            isDisabled: isDisabled,
                            isRequired: isRequired,
                            menuIsOpen: menuIsOpen,
                            onBlur: this.onSelectBlur,
                            onChange: this.onSelectChange,
                            onFocus: this.onSelectFocus,
                            onInputChange: this.handleSelectInputChange,
                            placeholder: (0, $47or1.getPlaceholder)({
                                placeholder: this.props.placeholder,
                                l10n: this.state.l10n
                            }),
                            styles: mergedStyles,
                            value: initialValue,
                            ...selectProps,
                            // up when you alter some of the properties in the `selectComponents`
                            // object. These errors are still present, and I suspect have always
                            // been present, without changing the unrelated code. Ignoring as the
                            // component still works as expected despite this error. And also
                            // because the select refresh team may solve it later.
                            components: {
                                ...selectComponents,
                                SingleValue: (0, $7OE9J.makeSingleValue)({
                                    id: valueId,
                                    lang: this.props.locale
                                })
                            },
                            // selectProps or not and what wil be overwritten
                            isClearable: true,
                            isInvalid: isInvalid,
                            spacing: spacing,
                            testId: testId,
                            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                            calendarContainerRef: calendarProps.calendarContainerRef,
                            calendarDisabled: calendarProps.calendarDisabled,
                            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                            calendarLocale: calendarProps.calendarLocale,
                            calendarMaxDate: calendarProps.calendarMaxDate,
                            calendarMinDate: calendarProps.calendarMinDate,
                            calendarRef: calendarProps.calendarRef,
                            calendarValue: calendarProps.calendarValue,
                            calendarView: calendarProps.calendarView,
                            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                            nextMonthLabel: nextMonthLabel,
                            onCalendarChange: calendarProps.onCalendarChange,
                            onCalendarSelect: calendarProps.onCalendarSelect,
                            previousMonthLabel: previousMonthLabel,
                            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                            menuInnerWrapper: calendarProps.menuInnerWrapper
                        })
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($2fe32780a1f5c05c$var$styles.iconContainerStyles, value && !hideIcon ? $2fe32780a1f5c05c$var$styles.iconSpacingWithClearButtonStyles : $2fe32780a1f5c05c$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #292A2E)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $2fe32780a1f5c05c$var$DatePicker = (0, $dUaMU.default)({
    componentName: 'datePicker',
    packageName: $2fe32780a1f5c05c$var$packageName,
    packageVersion: $2fe32780a1f5c05c$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $2fe32780a1f5c05c$var$packageName,
            packageVersion: $2fe32780a1f5c05c$var$packageVersion
        }
    })
})($2fe32780a1f5c05c$export$df43d21f5faca9f7));
var $2fe32780a1f5c05c$export$2e2bcd8739ae039 = $2fe32780a1f5c05c$var$DatePicker;

});
parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e82594be434237a3254dda0015850bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        name: "CalendarIcon",
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.displayName = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});


parcelRegister("cK9J2", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("RoXqn", function(module, exports) {
$parcel$export(module.exports, "EmptyComponent", () => $f314d4d8e1112a31$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $f314d4d8e1112a31$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $f314d4d8e1112a31$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $f314d4d8e1112a31$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $f314d4d8e1112a31$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $f314d4d8e1112a31$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $f314d4d8e1112a31$export$5e30e9a24d6c1203 = ()=>null;
const $f314d4d8e1112a31$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $f314d4d8e1112a31$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $f314d4d8e1112a31$export$9e6d8fcf62256b85 = 'h:mma';
const $f314d4d8e1112a31$export$75032c84f56650eb = 'YYYY/MM/DD';
function $f314d4d8e1112a31$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("47or1", function(module, exports) {
$parcel$export(module.exports, "isDateDisabled", () => $0a9aca5af48d76f0$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $0a9aca5af48d76f0$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $0a9aca5af48d76f0$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $0a9aca5af48d76f0$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $5PwWU = parcelRequire("5PwWU");

var $RoXqn = parcelRequire("RoXqn");
const $0a9aca5af48d76f0$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $0a9aca5af48d76f0$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(parsedDate)}`;
    return newIso;
};
const $0a9aca5af48d76f0$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $RoXqn.defaultDateFormat));
    return l10n.parseDate(date);
};
const $0a9aca5af48d76f0$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $RoXqn.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $RoXqn.placeholderDatetime));
};

});
parcelRegister("5PwWU", function(module, exports) {
$parcel$export(module.exports, "convertTokens", () => $0e0ecc26a93a278c$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $0e0ecc26a93a278c$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $0e0ecc26a93a278c$var$v1tokens = Object.keys($0e0ecc26a93a278c$var$tokensMap).sort().reverse();
const $0e0ecc26a93a278c$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$0e0ecc26a93a278c$var$v1tokens.join('|') + '|.)', 'g');
function $0e0ecc26a93a278c$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($0e0ecc26a93a278c$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $0e0ecc26a93a278c$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("hmV0i", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $85a1248019ae74fb$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $85a1248019ae74fb$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $85a1248019ae74fb$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $85a1248019ae74fb$var$styles.calendarButtonInclusionStyles : $85a1248019ae74fb$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gNwsY", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $41b3b0700e22b1c1$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $cSUzd = parcelRequire("cSUzd");

var $3rigy = parcelRequire("3rigy");

var $7G7nX = parcelRequire("7G7nX");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $41b3b0700e22b1c1$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $41b3b0700e22b1c1$var$menuStyles = null;
const $41b3b0700e22b1c1$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $41b3b0700e22b1c1$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rko12b0 _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs130s"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("cSUzd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1db3bdfc4d701b2$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hWhuM = parcelRequire("hWhuM");

var $jOHXZ = parcelRequire("jOHXZ");

var $1p4Fz = parcelRequire("1p4Fz");

var $h2Y6s = parcelRequire("h2Y6s");

var $7pqrO = parcelRequire("7pqrO");

var $8m7JM = parcelRequire("8m7JM");

var $5Pa93 = parcelRequire("5Pa93");

var $cM3gB = parcelRequire("cM3gB");

var $lPLOh = parcelRequire("lPLOh");

var $jtNxE = parcelRequire("jtNxE");
const $d1db3bdfc4d701b2$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d1db3bdfc4d701b2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d1db3bdfc4d701b2$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $h2Y6s.blankStringArray), defaultSelected: defaultSelected = (0, $h2Y6s.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $3Vuhz.default), onChange: onChange = (0, $3Vuhz.default), onFocus: onFocus = (0, $3Vuhz.default), onSelect: onSelect = (0, $3Vuhz.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $7pqrO.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $cM3gB.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $lPLOh.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $8m7JM.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jtNxE.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $5Pa93.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $d1db3bdfc4d701b2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hWhuM.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1p4Fz.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jOHXZ.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    });
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d1db3bdfc4d701b2$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d1db3bdfc4d701b2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d1db3bdfc4d701b2$var$Calendar.displayName = 'Calendar';
var $d1db3bdfc4d701b2$export$2e2bcd8739ae039 = $d1db3bdfc4d701b2$var$Calendar;

});
parcelRegister("hWhuM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fe58087a91a587c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $gl2vi = parcelRequire("gl2vi");

var $806LH = parcelRequire("806LH");

var $ld0cd = parcelRequire("ld0cd");

var $cqfIR = parcelRequire("cqfIR");

var $8PCRQ = parcelRequire("8PCRQ");

var $cQxBL = parcelRequire("cQxBL");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $8fe58087a91a587c$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gl2vi.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld0cd))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqfIR))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$8fe58087a91a587c$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fe58087a91a587c$export$2e2bcd8739ae039 = $8fe58087a91a587c$var$Header;

});
parcelRegister("ld0cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a1ef6001ab87a1d8d52e3fa36b1ca44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70af6cd1d0cef8e$var$_react = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f70af6cd1d0cef8e$var$_baseNew = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f70af6cd1d0cef8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $f70af6cd1d0cef8e$var$_react.default.createElement($f70af6cd1d0cef8e$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $f70af6cd1d0cef8e$var$_default = module.exports.default = $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon;

});

parcelRegister("cqfIR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b4e628ea814f393cf264d604c04f2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b41be71667434a$var$_react = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90b41be71667434a$var$_baseNew = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90b41be71667434a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b41be71667434a$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $90b41be71667434a$var$_react.default.createElement($90b41be71667434a$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$90b41be71667434a$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $90b41be71667434a$var$_default = module.exports.default = $90b41be71667434a$var$ChevronDoubleRightIcon;

});


parcelRegister("jOHXZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7776188040914bac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $17gD3 = parcelRequire("17gD3");

var $48tPc = parcelRequire("48tPc");
const $7776188040914bac$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $17gD3.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$7776188040914bac$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7776188040914bac$export$2e2bcd8739ae039 = $7776188040914bac$var$WeekDays;

});
parcelRegister("17gD3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f55ebb7772d4c5d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $hYvlq = parcelRequire("hYvlq");
const $7f55ebb7772d4c5d$var$dateCellSiblingStyle = null;
const $7f55ebb7772d4c5d$var$dateCellTodayStyle = null;
const $7f55ebb7772d4c5d$var$dateCellPrevSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellDisabledStyle = null;
const $7f55ebb7772d4c5d$var$dateCellStyles = null;
const $7f55ebb7772d4c5d$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $3Vuhz.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rkofajl _11c82smr _1h6d3acm _1dqonqa1 _189e1dm9 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysdkaa _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$7f55ebb7772d4c5d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f55ebb7772d4c5d$export$2e2bcd8739ae039 = $7f55ebb7772d4c5d$var$Date;

});
parcelRegister("hYvlq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});


parcelRegister("48tPc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f5de1de4465d4ec$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");
const $4f5de1de4465d4ec$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f5de1de4465d4ec$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        testId: testId,
        xcss: $4f5de1de4465d4ec$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f5de1de4465d4ec$export$2e2bcd8739ae039 = $4f5de1de4465d4ec$var$WeekDayGrid;

});


parcelRegister("1p4Fz", function(module, exports) {
$parcel$export(module.exports, "default", () => $be65a37818b8364c$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $48tPc = parcelRequire("48tPc");
const $be65a37818b8364c$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $be65a37818b8364c$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.100",
                xcss: $be65a37818b8364c$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$be65a37818b8364c$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be65a37818b8364c$export$2e2bcd8739ae039 = $be65a37818b8364c$var$WeekHeader;

});

parcelRegister("h2Y6s", function(module, exports) {
$parcel$export(module.exports, "arrowKeys", () => $be18158d85881f31$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $be18158d85881f31$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $be18158d85881f31$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $be18158d85881f31$export$8fa20d70624f8b9d);
const $be18158d85881f31$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $be18158d85881f31$export$3ae905d9742bef55 = 7;
const $be18158d85881f31$export$c9b7c010035d60c6 = 12;
const $be18158d85881f31$export$8fa20d70624f8b9d = [];

});

parcelRegister("7pqrO", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd0ab84481a095dc$export$2e2bcd8739ae039);

var $7O2l7 = parcelRequire("7O2l7");

var $3c3v8 = parcelRequire("3c3v8");

var $ediHA = parcelRequire("ediHA");
function $dd0ab84481a095dc$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $3c3v8.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $7O2l7.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $7O2l7.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $7O2l7.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $7O2l7.default)(today, ()=>today || `${thisYear}-${(0, $ediHA.default)(thisMonth)}-${(0, $ediHA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $7O2l7.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $7O2l7.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("ediHA", function(module, exports) {
$parcel$export(module.exports, "default", () => $50fecd0d0148fc4a$export$2e2bcd8739ae039);
function $50fecd0d0148fc4a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("8m7JM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c971afa7669251e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c971afa7669251e8$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("5Pa93", function(module, exports) {
$parcel$export(module.exports, "default", () => $6571678cf382b203$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $cFI4x = parcelRequire("cFI4x");
function $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $h2Y6s.daysPerWeek) : 0;
            return (0, $cFI4x.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $h2Y6s.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
        return [];
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $6571678cf382b203$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $cFI4x.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $fdbAT.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("fdbAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $33e505eaecca4d6d$export$2e2bcd8739ae039);

var $ediHA = parcelRequire("ediHA");
function $33e505eaecca4d6d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $ediHA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $ediHA.default)(date.day)}`;
}

});

parcelRegister("cFI4x", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fc98c4c7dc36d65$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $h2Y6s = parcelRequire("h2Y6s");

var $d9oTA = parcelRequire("d9oTA");
function $5fc98c4c7dc36d65$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $h2Y6s.daysPerWeek) - weekStartDay + firstDay) % (0, $h2Y6s.daysPerWeek));
    const lastDate = (0, $d9oTA.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $h2Y6s.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $d9oTA.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $h2Y6s.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $h2Y6s.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $h2Y6s.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $h2Y6s.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $h2Y6s.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("d9oTA", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdb6610bba124d19$export$2e2bcd8739ae039);
function $bdb6610bba124d19$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("cM3gB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e11abbd67514b7e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $d9oTA = parcelRequire("d9oTA");
const $e11abbd67514b7e7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $h2Y6s.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $e11abbd67514b7e7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $h2Y6s.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $e11abbd67514b7e7$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $h2Y6s.daysPerWeek);
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $h2Y6s.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("lPLOh", function(module, exports) {
$parcel$export(module.exports, "default", () => $395ce53b4353da25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");
function $395ce53b4353da25$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $h2Y6s.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jtNxE", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a6b7d4c4da291b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cK9J2 = parcelRequire("cK9J2");
function $01a6b7d4c4da291b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $cK9J2.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("7G7nX", function(module, exports) {
$parcel$export(module.exports, "default", () => $68ce7a484b05c143$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $anoAR = parcelRequire("anoAR");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");
const $68ce7a484b05c143$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $68ce7a484b05c143$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $anoAR.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6G5P1.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $3Vuhz.default);
    }
}

});
parcelRegister("anoAR", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("1u9xN", function(module, exports) {
$parcel$export(module.exports, "getShortISOString", () => $a3c204a1b42604a4$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $a3c204a1b42604a4$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $5PwWU = parcelRequire("5PwWU");
function $a3c204a1b42604a4$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)('YYYY-MM-DD'));
}
function $a3c204a1b42604a4$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $a3c204a1b42604a4$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("7OE9J", function(module, exports) {
$parcel$export(module.exports, "makeSingleValue", () => $8e54d9aa121b2675$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $8e54d9aa121b2675$export$6e30bf8cb1347b56 = // TODO: Make ID required
({ id: id, lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                id: id,
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("k2Uo2", function(module, exports) {
$parcel$export(module.exports, "default", () => $00683ba6c52d5435$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $00683ba6c52d5435$var$packageName = "platform-pkg";
const $00683ba6c52d5435$var$packageVersion = "0.0.0-use.local";
const $00683ba6c52d5435$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz1rpy _152tze3t _rjxpze3t _30l3azsu",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $00683ba6c52d5435$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $00683ba6c52d5435$var$packageName,
    packageVersion: $00683ba6c52d5435$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $00683ba6c52d5435$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, _forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: /* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: /* eslint-enable @repo/internal/react/use-noop */ selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$00683ba6c52d5435$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $cK9J2.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $47or1.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $47or1.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $1u9xN.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $47or1.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $00683ba6c52d5435$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const valueId = (0, $gl2vi.useId)();
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        id: valueId,
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gNwsY.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $47or1.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gl2vi.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $00683ba6c52d5435$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy ? `${ariaDescribedBy} ${valueId}` : valueId,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $47or1.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($00683ba6c52d5435$var$styles.iconContainerStyles, value && !hideIcon ? $00683ba6c52d5435$var$styles.iconSpacingWithClearButtonStyles : $00683ba6c52d5435$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                            ...iconProps,
                            color: "var(--ds-icon, #292A2E)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $00683ba6c52d5435$export$2e2bcd8739ae039 = $00683ba6c52d5435$var$DatePicker;

});


parcelRegister("h3OS7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac8e88b2b26eb9d1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ac8e88b2b26eb9d1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholderDate: {
        "id": "common-date.utils.date-messages.placeholder-date",
        "defaultMessage": "e.g. 2018/12/31"
    }
});

});

parcelRegister("fgNUD", function(module, exports) {
$parcel$export(module.exports, "default", () => $463b2e2732c3d1c8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
// eslint-disable-next-line jira/react/no-class-components
class $463b2e2732c3d1c8$var$SuppressEscKey extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            role: "presentation",
            onKeyDown: this.onKeyEvent,
            onKeyUp: this.onKeyEvent
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.onKeyEvent = (e)=>{
            const { key: key } = e;
            if (key === 'Escape') {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }
        };
    }
}
var $463b2e2732c3d1c8$export$2e2bcd8739ae039 = $463b2e2732c3d1c8$var$SuppressEscKey;

});

parcelRegister("fvP65", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec9049b7382a0d67$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ec9049b7382a0d67$var$messages = (0, $7qGN1.defineMessages)({
    releaseDate: {
        "id": "project-directories.versions.release-version-modal.content.release-date.release-date",
        "defaultMessage": "Release date"
    }
});
var $ec9049b7382a0d67$export$2e2bcd8739ae039 = $ec9049b7382a0d67$var$messages;

});



parcelRegister("7LVYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $aed7db7de0dec685$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $7zFqE = parcelRequire("7zFqE");

var $1j2EU = parcelRequire("1j2EU");

var $gLW5o = parcelRequire("gLW5o");

var $delku = parcelRequire("delku");
const $aed7db7de0dec685$var$mapStateToProps = ()=>{
    const renderVersionPickerFactory = (0, $LFmXM.default)((shouldSwapIssues, isSaving, projectKey, versionId)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zFqE.default), {
                isDisabled: !shouldSwapIssues || isSaving,
                projectKey: projectKey,
                ignore: [
                    versionId
                ],
                versionStatuses: [
                    'UNRELEASED'
                ],
                ...props
            }));
    return (state)=>{
        const { projectKey: projectKey, shouldSwapIssues: shouldSwapIssues, isSaving: isSaving, versionId: versionId } = (0, $gLW5o.getPropsForVersionPicker)(state);
        return {
            toDoInProgressIssuesCount: (0, $gLW5o.getTodoInProgressIssuesCount)(state),
            isSaving: (0, $gLW5o.isSaving)(state),
            shouldSwapIssues: (0, $gLW5o.isSwapSelected)(state),
            errors: (0, $gLW5o.getErrors)(state),
            renderVersionPicker: renderVersionPickerFactory(shouldSwapIssues, isSaving, projectKey, versionId)
        };
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aed7db7de0dec685$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $1j2EU.releaseVersionUpdate)(version)),
        // @ts-expect-error - TS7006 - Parameter 'swap' implicitly has an 'any' type.
        onSwapIssuesSelected: (swap)=>dispatch((0, $1j2EU.swapIssues)(swap))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aed7db7de0dec685$var$mapDispatchToProps = (dispatch)=>$aed7db7de0dec685$var$dispatcher(dispatch);
var $aed7db7de0dec685$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($aed7db7de0dec685$var$mapStateToProps, $aed7db7de0dec685$var$mapDispatchToProps)((0, $delku.default));

});
parcelRegister("delku", function(module, exports) {
$parcel$export(module.exports, "default", () => $87dd23580bddc453$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6svxr = parcelRequire("6svxr");

var $gPG64 = parcelRequire("gPG64");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $idGBm = parcelRequire("idGBm");

var $eOn0y = parcelRequire("eOn0y");
// eslint-disable-next-line jira/react/no-class-components
class $87dd23580bddc453$var$SwapIssues extends (0, $eJOHy.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            moveUnfixedIssuesTo: update.moveUnfixedIssuesTo
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, toDoInProgressIssuesCount: toDoInProgressIssuesCount, shouldSwapIssues: shouldSwapIssues, errors: errors, isSaving: isSaving, renderVersionPicker: renderVersionPicker } = this.props;
        const { moveUnfixedIssuesTo: moveUnfixedIssuesToError } = errors;
        const invalidVersionChosenIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $eOn0y.default).invalidVersionChosenIssueTermRefreshGalaxia : (0, $eOn0y.default).invalidVersionChosenIssueTermRefresh;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "UnresolvedIssue",
            isRequired: true,
            label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eOn0y.default).unresolvedIssuesHeaderIssueTermRefresh : (0, $eOn0y.default).unresolvedIssuesHeader, {
                issues: toDoInProgressIssuesCount
            })
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
                isDisabled: isSaving,
                isChecked: shouldSwapIssues,
                onChange: this.onMoveIssuesSelected,
                label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eOn0y.default).unresolvedIssuesMoveIssueTermRefresh : (0, $eOn0y.default).unresolvedIssuesMove, {
                    issues: toDoInProgressIssuesCount
                }),
                testId: "version-modals.release-version-modal.content.swap-issues.move-radio"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87dd23580bddc453$var$VersionPickerContainer, null, renderVersionPicker({
                onSelected: this.onSwapIssues
            })), moveUnfixedIssuesToError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($87dd23580bddc453$var$ValidationError, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? invalidVersionChosenIssueTermRefreshGalaxia : (0, $eOn0y.default).invalidVersionChosen, {
                issues: toDoInProgressIssuesCount
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
                isDisabled: isSaving,
                isChecked: !shouldSwapIssues,
                onChange: this.onRemoveVersionFromIssuesSelected,
                label: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $eOn0y.default).unresolvedIssuesIgnoreIssueTermRefresh : (0, $eOn0y.default).unresolvedIssuesIgnore),
                testId: "version-modals.release-version-modal.content.swap-issues.ignore-radio"
            })));
    }
    constructor(...args){
        super(...args), this.onSwapIssues = (version)=>{
            if (version) this.inputChange({
                moveUnfixedIssuesTo: version.id
            });
            else this.inputChange({
                moveUnfixedIssuesTo: ''
            });
        }, this.onMoveIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(true);
        }, this.onRemoveVersionFromIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(false);
        };
    }
}
var $87dd23580bddc453$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($87dd23580bddc453$var$SwapIssues);
const $87dd23580bddc453$var$VersionPickerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx16xz _otyru2gc _18u01ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87dd23580bddc453$var$ValidationError = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _syaz1tmw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eOn0y", function(module, exports) {
$parcel$export(module.exports, "default", () => $0500860c03032044$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0500860c03032044$var$messages = (0, $7qGN1.defineMessages)({
    unresolvedIssuesHeader: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header",
        "defaultMessage": "Unresolved {issues, plural, one {issue} other {issues}}"
    },
    unresolvedIssuesMove: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move",
        "defaultMessage": "Move unresolved {issues, plural, one {issue} other {issues}} to"
    },
    unresolvedIssuesIgnore: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore",
        "defaultMessage": "Ignore unresolved issues"
    },
    invalidVersionChosen: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}."
    },
    unresolvedIssuesHeaderIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header-issue-term-refresh",
        "defaultMessage": "Unresolved {issues, plural, one {work item} other {work items}}"
    },
    unresolvedIssuesMoveIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move-issue-term-refresh",
        "defaultMessage": "Move unresolved {issues, plural, one {work item} other {work items}} to"
    },
    unresolvedIssuesIgnoreIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore-issue-term-refresh",
        "defaultMessage": "Ignore unresolved work items"
    },
    invalidVersionChosenIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this work item} other {these work items}}."
    },
    invalidVersionChosenIssueTermRefreshGalaxia: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh-galaxia",
        "defaultMessage": "Can't use this version. Change this version to another in your space or remove it from {issues, plural, one {this work item} other {these work items}}."
    }
});
var $0500860c03032044$export$2e2bcd8739ae039 = $0500860c03032044$var$messages;

});



parcelRegister("kb64x", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ab1a4e29040d254$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lc0OY = parcelRequire("lc0OY");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $fKemo = parcelRequire("fKemo");
class $1ab1a4e29040d254$export$7c6e2c02157bb7d2 extends (0, $eJOHy.Component) {
    renderDescriptionWithIssues() {
        const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, unresolvedIssuesUrl: unresolvedIssuesUrl } = this.props;
        const unresolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lc0OY.default), {
            href: unresolvedIssuesUrl
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $fKemo.default).descriptionWithIssuesCountIssueTermRefresh : (0, $fKemo.default).descriptionWithIssuesCount, {
            issues: unresolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $fKemo.default).descriptionWithIssues,
            values: {
                issueCountLink: unresolvedIssueJqlViewLink
            }
        }));
    }
    renderDescriptionWithoutIssues() {
        const { intl: { formatMessage: formatMessage }, resolvedIssueUrl: resolvedIssueUrl, resolvedIssuesCount: resolvedIssuesCount } = this.props;
        const resolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lc0OY.default), {
            href: resolvedIssueUrl
        }, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $fKemo.default).descriptionWithoutIssuesIssueTermRefresh : (0, $fKemo.default).descriptionWithoutIssues, {
            doneIssues: resolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $fKemo.default).descriptionWithoutIssuesRestMessage,
            values: {
                issueCountLink: resolvedIssueJqlViewLink
            }
        }));
    }
    render() {
        const { unresolvedIssuesCount: unresolvedIssuesCount, SwapIssues: SwapIssues, ReleaseDate: ReleaseDate, ReleaseAutomationBanner: ReleaseAutomationBanner } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, unresolvedIssuesCount > 0 ? this.renderDescriptionWithIssues() : this.renderDescriptionWithoutIssues(), unresolvedIssuesCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SwapIssues, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ReleaseDate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraSoftwareReleasesVersionDetail",
            teamName: "jolt",
            id: "releaseAutomationBanner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ReleaseAutomationBanner, null)));
    }
}
var $1ab1a4e29040d254$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($1ab1a4e29040d254$export$7c6e2c02157bb7d2);

});
parcelRegister("fKemo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c635f3b611b80a8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4c635f3b611b80a8$var$messages = (0, $7qGN1.defineMessages)({
    descriptionWithIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues",
        "defaultMessage": "This release contains {issueCountLink}."
    },
    descriptionWithIssuesCount: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count",
        "defaultMessage": "{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}"
    },
    descriptionWithoutIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {issue} other {issues}}"
    },
    descriptionWithoutIssuesRestMessage: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-rest-message",
        "defaultMessage": "{issueCountLink} will be released."
    },
    descriptionWithIssuesCountIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count-issue-term-refresh",
        "defaultMessage": "{issues, plural, one {{issues} unresolved work item} other {{issues} unresolved work items}}"
    },
    descriptionWithoutIssuesIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-issue-term-refresh",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {work item} other {work items}}"
    }
});
var $4c635f3b611b80a8$export$2e2bcd8739ae039 = $4c635f3b611b80a8$var$messages;

});



parcelRegister("fZ8fz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5300abc07ddf2ca$export$2e2bcd8739ae039);
/* ReleaseModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/filename-case */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lJKII = parcelRequire("lJKII");

var $fdpHV = parcelRequire("fdpHV");

var $6sjW5 = parcelRequire("6sjW5");

var $4B7rn = parcelRequire("4B7rn");

var $idGBm = parcelRequire("idGBm");


var $4cTDP = parcelRequire("4cTDP");

var $gsea4 = parcelRequire("gsea4");

var $jmAOT = parcelRequire("jmAOT");
class $f5300abc07ddf2ca$export$b77f092f9cf63f1e extends (0, $eJOHy.Component) {
    render() {
        const { Content: Content, unresolvedIssuesCount: unresolvedIssuesCount, isInitiating: isInitiating, onCancel: onCancel, intl: { formatMessage: formatMessage }, name: name } = this.props;
        if (isInitiating) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
            isOpen: true,
            width: "small" // @ts-expect-error - TS2769 - No overload matches this call.
            ,
            onClose: onCancel,
            testId: "version-modals.release-version-modal.release-version-modal",
            messageId: "version-modals.release-version-modal.modal-dialog.release-version-modal",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
            hasCloseButton: (0, $4cTDP.fg)('enghealth-41206-modal-header-close-button')
        }, unresolvedIssuesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
            appearance: "warning"
        }, formatMessage((0, $jmAOT.default).header, {
            name: name
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, formatMessage((0, $jmAOT.default).header, {
            name: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null)), this.renderFooter(this.props)));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2344 - Type '{ new (): HTMLElement; prototype: HTMLElement; }' does not satisfy the constraint 'keyof IntrinsicElements | ForwardRefExoticComponent<any> | (new (props: any) => Component<any, {}, any>) | ((props: any, context?: any) => ReactElement<...> | null)'.
        this.onButtonMounted = (node)=>{
            this.button = node;
        }, // focus needs to be set on button in order to hide date-picker
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onRelease = (...args)=>{
            if (this.button) this.button.focus();
            this.props.onRelease(this.props.shouldRedirectToCreateReleaseNotes, args[args.length - 1]);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/react-no-unneeded-arrow-function-properties
        this.renderFooter = (props)=>{
            const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, isSaving: isSaving, onCancel: onCancel, isReleaseDisabled: isReleaseDisabled, shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes, setRedirectToCreateReleaseNotesStatus: setRedirectToCreateReleaseNotesStatus, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5300abc07ddf2ca$var$FooterContainer, {
                showReleaseNotesPrompt: shouldShowCreateReleaseNotesOption
            }, shouldShowCreateReleaseNotesOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gsea4.CreateReleaseNotesPrompt), {
                onChange: setRedirectToCreateReleaseNotesStatus,
                value: shouldRedirectToCreateReleaseNotes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f5300abc07ddf2ca$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $f5300abc07ddf2ca$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                onClick: this.onRelease,
                appearance: unresolvedIssuesCount ? 'warning' : 'primary',
                type: "submit",
                isDisabled: isReleaseDisabled,
                ref: this.onButtonMounted
            }, formatMessage((0, $jmAOT.default).release)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "subtle-link",
                isDisabled: false,
                onClick: onCancel
            }, formatMessage((0, $jmAOT.default).cancel)))));
        };
    }
}
var $f5300abc07ddf2ca$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('releaseVersions', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))((0, $6sjW5.default)({
    onRelease: (isCreateReleaseNotesOptedIn)=>({
            name: 'release',
            isCreateReleaseNotesOptedIn: isCreateReleaseNotesOptedIn
        }),
    onCancel: 'cancel'
})((0, $idGBm.injectIntlV2)($f5300abc07ddf2ca$export$b77f092f9cf63f1e)));
const $f5300abc07ddf2ca$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5300abc07ddf2ca$var$ButtonsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5300abc07ddf2ca$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showReleaseNotesPrompt: showReleaseNotesPrompt, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.showReleaseNotesPrompt ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gsea4", function(module, exports) {
$parcel$export(module.exports, "CreateReleaseNotesPrompt", () => $feb16466561619fd$export$d8a8f048cf64e9ff);
/* CreateReleaseNotesPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $86tBw = parcelRequire("86tBw");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $fXpHV = parcelRequire("fXpHV");
const $feb16466561619fd$export$d8a8f048cf64e9ff = ({ onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onValueChange = (0, $eJOHy.useCallback)((event)=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'checkbox'
        }), 'releaseModalCreateReleaseNotesCheckbox');
        onChange(event.target.checked);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($feb16466561619fd$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        name: "createReleaseNotes",
        label: formatMessage((0, $fXpHV.default).createReleaseNotesTitle),
        isChecked: value,
        onChange: onValueChange
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $feb16466561619fd$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("86tBw", function(module, exports) {
$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzg1nfn _1dk71nfn _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    }));
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("fXpHV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d262568acd2c14e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5d262568acd2c14e$var$messages = (0, $7qGN1.defineMessages)({
    createReleaseNotesTitle: {
        "id": "project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title",
        "defaultMessage": "Create release notes"
    }
});
var $5d262568acd2c14e$export$2e2bcd8739ae039 = $5d262568acd2c14e$var$messages;

});


parcelRegister("jmAOT", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a212cb4beb1a86$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $08a212cb4beb1a86$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-directories.versions.release-version-modal.header",
        "defaultMessage": "Release {name}"
    },
    release: {
        "id": "project-directories.versions.release-version-modal.release",
        "defaultMessage": "Release"
    },
    cancel: {
        "id": "project-directories.versions.release-version-modal.cancel",
        "defaultMessage": "Cancel"
    }
});
var $08a212cb4beb1a86$export$2e2bcd8739ae039 = $08a212cb4beb1a86$var$messages;

});




parcelRegister("lY5Wl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e13b1304d5bbd58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<897739c2f9784bd5c6c8d9745294b23d>>
 * @relayHash 8db6e0cd88e1c708a67c7a6bb7fd5b8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441de3c880d4177455c0d6e8ae98a6f2af92fa46c233a198cc39edf9e4a252a5
const $0e13b1304d5bbd58$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "editReleaseModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "editReleaseForm_softwareReleasesReleaseModalsRelay"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "editReleaseModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "message"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "441de3c880d4177455c0d6e8ae98a6f2af92fa46c233a198cc39edf9e4a252a5",
            "metadata": {},
            "name": "editReleaseModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0e13b1304d5bbd58$var$node.hash = "78bd9d672cd7c6a79f8f0214003cbacd";
var $0e13b1304d5bbd58$export$2e2bcd8739ae039 = $0e13b1304d5bbd58$var$node;

});

parcelRegister("gVv7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $728595492b70cc1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eff6bbb8fd1c5cbef9a0b7352a9b5a38>>
 * @relayHash 1abf975667e0c9ee5b3f2be70e2c73a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7ac237c42a6f8772ca697f1e101e98fdbe98411d3c61d3395eb3afa396b6eb0
const $728595492b70cc1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "releaseNoteConfiguration"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    }, v6 = {
        "kind": "ScalarField",
        "name": "releasesNotesPreferenceType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueKeyConfig"
    }, v8 = {
        "kind": "ScalarField",
        "name": "issueFieldIds"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeIds"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "releaseNoteConfiguration",
            "variableName": "releaseNoteConfiguration"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "isSystem"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v17 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v19 = [
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueFieldEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ], v20 = [
        "searchString"
    ], v21 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.version.id"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraReleaseNotesConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v9 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesConfiguration"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v10 /*: any*/ ,
                                                        "concreteType": "JiraIssueTypeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesOptionsIssueTypes",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "FragmentSpread",
                                                                            "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                                                            }
                                                        ],
                                                        "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesOptionsIssueTypes"
                                                },
                                                {
                                                    "args": v11 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "embeddedPageReleaseNotes_softwareReleasesAddReleaseNotesModal_EmbeddedPageReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                                                },
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "availableSites",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v12 /*: any*/ ,
                                                                                    "action": "LOG",
                                                                                    "path": "jira.version.availableSites.edges.node.isSystem"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "LOG",
                                                                        "path": "jira.version.availableSites.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "LOG",
                                                            "path": "jira.version.availableSites.edges"
                                                        }
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraReleaseNotesConfiguration",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "xsmall"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueTypes"
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "releaseNotes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v19 /*: any*/ ,
                                            "storageKey": "releaseNotesOptionsIssueFields(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": v20 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "args": v21 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "nativeReleaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v19 /*: any*/ ,
                                            "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                                        },
                                        {
                                            "args": v21 /*: any*/ ,
                                            "filters": v20 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "nativeReleaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                            "kind": "LinkedField",
                                            "name": "availableSites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "type": "JiraVersion"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e7ac237c42a6f8772ca697f1e101e98fdbe98411d3c61d3395eb3afa396b6eb0",
            "metadata": {},
            "name": "uiReleaseNotesModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$728595492b70cc1f$var$node.hash = "b8c5823683fa1dc8a3117a965fb8027e";
var $728595492b70cc1f$export$2e2bcd8739ae039 = $728595492b70cc1f$var$node;

});

parcelRegister("eYqSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f69592492a21317$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09d9943381c0ee532233ab0c4d4b436a>>
 * @relayHash f8586efc80ea28a4eafc78b9413f626e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99aa9d7945ae892264764cfa6f33e773b4a15ec64bc45b6db2b6a04345af90fc
const $8f69592492a21317$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": [
                "ARCHIVED",
                "UNRELEASED",
                "RELEASED"
            ]
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 6
        },
        {
            "kind": "Variable",
            "name": "jiraProjectId",
            "variableName": "projectAri"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mergeReleaseModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "mergeReleaseModal_softwareReleasesReleaseModalsRelay_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mergeReleaseModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "projectAri"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v1 /*: any*/ ,
                            "filters": [
                                "jiraProjectId",
                                "filter",
                                "searchString"
                            ],
                            "handle": "connection",
                            "key": "mergeReleaseModal_versionsForProject",
                            "kind": "LinkedHandle",
                            "name": "versionsForProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "99aa9d7945ae892264764cfa6f33e773b4a15ec64bc45b6db2b6a04345af90fc",
            "metadata": {},
            "name": "mergeReleaseModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f69592492a21317$var$node.hash = "18d434f389db050d0bda57545ded9c74";
var $8f69592492a21317$export$2e2bcd8739ae039 = $8f69592492a21317$var$node;

});

parcelRegister("cFcNJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $30291cc97629d772$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $30291cc97629d772$var$messages = (0, $7qGN1.defineMessages)({
    releaseAction: {
        "id": "project-versions.table.actions.release-action",
        "defaultMessage": "Release"
    },
    unreleaseAction: {
        "id": "project-versions.table.actions.unrelease-action",
        "defaultMessage": "Unrelease"
    },
    archiveAction: {
        "id": "project-versions.table.actions.archive-action",
        "defaultMessage": "Archive"
    },
    unarchiveAction: {
        "id": "project-versions.table.actions.unarchive-action",
        "defaultMessage": "Unarchive"
    },
    mergeAction: {
        "id": "project-versions.table.actions.merge-action",
        "defaultMessage": "Merge"
    },
    editAction: {
        "id": "project-versions.table.actions.edit-action",
        "defaultMessage": "Edit"
    },
    deleteAction: {
        "id": "project-versions.table.actions.delete-action",
        "defaultMessage": "Delete"
    },
    deleteActionDisabledTooltip: {
        "id": "project-versions.table.actions.delete-action-disabled-tooltip",
        "defaultMessage": "You don't have permission to delete a version."
    },
    genericUpdateFailedFlagTitle: {
        "id": "project-versions.table.actions.generic-update-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "project-versions.table.actions.release-failed-flag-description",
        "defaultMessage": "We were not able to update the version released status. Please refresh the page and try again."
    },
    archiveFailedFlagDescription: {
        "id": "project-versions.table.actions.archive-failed-flag-description",
        "defaultMessage": "We were not able to update the version archived status. Please refresh the page and try again."
    },
    archiveTitle: {
        "id": "project-versions.table.actions.archive-title",
        "defaultMessage": "{name} archived"
    },
    unarchiveTitle: {
        "id": "project-versions.table.actions.unarchive-title",
        "defaultMessage": "{name} unarchived"
    },
    releaseTitle: {
        "id": "project-versions.table.actions.release-title",
        "defaultMessage": "{name} released"
    },
    unReleaseTitle: {
        "id": "project-versions.table.actions.un-release-title",
        "defaultMessage": "{name} unreleased"
    },
    deleteTitle: {
        "id": "project-versions.table.actions.delete-title",
        "defaultMessage": "{name} deleted"
    },
    deleteFailedTitle: {
        "id": "project-versions.table.actions.delete-failed-title",
        "defaultMessage": "We couldn't delete that version"
    },
    deleteFailedDescription: {
        "id": "project-versions.table.actions.delete-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    },
    moreActionsTooltip: {
        "id": "project-versions.table.actions.more-actions-tooltip",
        "defaultMessage": "More actions"
    },
    moreActionsLabel: {
        "id": "project-versions.table.actions.more-actions-label",
        "defaultMessage": "More actions for {versionName}"
    }
});
var $30291cc97629d772$export$2e2bcd8739ae039 = $30291cc97629d772$var$messages;

});


parcelRegister("3PDhY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f56c2e9b5569ab00$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $hVUVT = parcelRequire("hVUVT");

var $eFw7D = parcelRequire("eFw7D");
function $f56c2e9b5569ab00$export$1f74963c34e8bfec(props) {
    const defaultDescriptionGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $eFw7D.default).defaultDescriptionGalaxia : (0, $eFw7D.default).defaultDescription;
    const headerGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $eFw7D.default).headerGalaxia : (0, $eFw7D.default).header;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { statusFilter: statusFilter, searchFilter: searchFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hVUVT))),
        headingLevel: 2,
        header: formatMessage(headerGalaxia),
        description: formatMessage(!searchFilter && statusFilter.length > 0 ? (0, $eFw7D.default).noMatchingStatusDescription : defaultDescriptionGalaxia)
    });
}
var $f56c2e9b5569ab00$export$2e2bcd8739ae039 = $f56c2e9b5569ab00$export$1f74963c34e8bfec;

});
parcelRegister("hVUVT", function(module, exports) {
module.exports = new URL("release.e083327a.svg", import.meta.url).toString();

});

parcelRegister("eFw7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $36de86db4f94f039$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $36de86db4f94f039$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "project-versions.table.empty.header",
        "defaultMessage": "No matching versions"
    },
    noMatchingStatusDescription: {
        "id": "project-versions.table.empty.no-matching-status-description",
        "defaultMessage": "There aren't any versions in this project with that status. Check your filters and try again."
    },
    defaultDescription: {
        "id": "project-versions.table.empty.default-description",
        "defaultMessage": "There aren't any versions in this project that match your search. Check your search terms and filters and try again."
    },
    headerGalaxia: {
        "id": "project-versions.table.empty.header-galaxia",
        "defaultMessage": "There aren't any versions in this space with that status. Check your filters and try again."
    },
    defaultDescriptionGalaxia: {
        "id": "project-versions.table.empty.default-description-galaxia",
        "defaultMessage": "There aren't any versions in this space that match your search. Check your search terms and filters and try again."
    }
});
var $36de86db4f94f039$export$2e2bcd8739ae039 = $36de86db4f94f039$var$messages;

});


parcelRegister("lAMEV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dce8ad29a624694$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6dce8ad29a624694$var$messages = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "project-versions.table.show-more",
        "defaultMessage": "Show {count} more"
    },
    moreActionsLabel: {
        "id": "project-versions.table.more-actions-label",
        "defaultMessage": "More actions"
    },
    done: {
        "id": "project-versions.table.done",
        "defaultMessage": "{done} done"
    },
    inProgress: {
        "id": "project-versions.table.in-progress",
        "defaultMessage": "{inProgress} in progress"
    },
    toDo: {
        "id": "project-versions.table.to-do",
        "defaultMessage": "{toDo} to do"
    },
    empty: {
        "id": "project-versions.table.empty",
        "defaultMessage": "No issues"
    },
    emptyIssueTermRefresh: {
        "id": "project-versions.table.empty-issue-term-refresh",
        "defaultMessage": "No work items"
    },
    releaseVersionsTableLabel: {
        "id": "project-versions.table.release-versions-label",
        "defaultMessage": "Release versions"
    }
});
var $6dce8ad29a624694$export$2e2bcd8739ae039 = $6dce8ad29a624694$var$messages;

});

parcelRegister("cYHXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b9689800842ac1f$export$2e2bcd8739ae039);

var $fEk4c = parcelRequire("fEk4c");

var $1ytKa = parcelRequire("1ytKa");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $6sjW5 = parcelRequire("6sjW5");

var $as6H2 = parcelRequire("as6H2");

var $jGzvY = parcelRequire("jGzvY");

var $fRyaf = parcelRequire("fRyaf");

var $c9uTK = parcelRequire("c9uTK");

var $jErxO = parcelRequire("jErxO");
const $2b9689800842ac1f$var$NameCell = ({ jiraVersion: jiraVersion, jiraProject: jiraProject, onClick: onClick })=>{
    const version = (0, $j4oe4.useFragment)((0, $1ytKa.default), jiraVersion);
    const project = (0, $j4oe4.useFragment)((0, $fEk4c.default), jiraProject);
    const href = (0, $jErxO.getVersionIssuesUrl)(project.key, project.projectType === 'SOFTWARE', version.versionId, version.name); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onLinkClick = (...args)=>{
        onClick(args[args.length - 1]);
    };
    return project.projectType === 'SOFTWARE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b9689800842ac1f$var$LinkWithAnalytics, {
        to: (0, $jGzvY.softwareVersionDetailRoute),
        params: {
            projectKey: project.key,
            versionId: version.versionId,
            tab: 'release-report-all-issues'
        },
        prefetch: "hover",
        "data-testid": "project-versions.ui.table.name.name",
        onClick: onLinkClick
    }, version.name) : // This will point to a JQL search page for non-Software projects
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b9689800842ac1f$var$LinkWithAnalytics, {
        href: href,
        "data-testid": "project-versions.ui.table.name.name" // @ts-expect-error - Type '(arg1: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'.
        ,
        onClick: onClick
    }, version.name);
};
var $2b9689800842ac1f$export$2e2bcd8739ae039 = (0, $6sjW5.default)({
    onClick: 'version'
})($2b9689800842ac1f$var$NameCell);
const $2b9689800842ac1f$var$StyledLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRyaf.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b9689800842ac1f$var$StyledLinkComponent, props));
const $2b9689800842ac1f$var$LinkWithAnalytics = (0, $as6H2.default)('link', {
    onClick: 'clicked'
})($2b9689800842ac1f$var$StyledLink); // "display: block" so the link fits the full width of the cell, which...
// - Makes it easier to click.
// - Allows link prefetching to start earlier.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b9689800842ac1f$var$StyledLinkComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fEk4c", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9d85fb774d151aa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<387a395668a8f8986a97ae76047df2b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9d85fb774d151aa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "name_projectVersions_NameCell_jiraProject",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        }
    ],
    "type": "JiraProject"
};
$d9d85fb774d151aa$var$node.hash = "a64f354b68d1237c5efb3aba5192d28c";
var $d9d85fb774d151aa$export$2e2bcd8739ae039 = $d9d85fb774d151aa$var$node;

});

parcelRegister("1ytKa", function(module, exports) {
$parcel$export(module.exports, "default", () => $47df2687e552256f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c330eecc5e1bd35632a84504f504bdd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $47df2687e552256f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "name_projectVersions_NameCell_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        }
    ],
    "type": "JiraVersion"
};
$47df2687e552256f$var$node.hash = "ff19770b46145efacc61452e92184dda";
var $47df2687e552256f$export$2e2bcd8739ae039 = $47df2687e552256f$var$node;

});

parcelRegister("fRyaf", function(module, exports) {
$parcel$export(module.exports, "Container", () => $af8bec37546b71d4$export$42a852a2b6b56249);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $af8bec37546b71d4$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_slp31hna _ca0qu2gc _n3tdu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jErxO", function(module, exports) {
$parcel$export(module.exports, "getVersionIssuesUrl", () => $2709ec91f034486f$export$ddba25f62ccdd322);

var $bnIBr = parcelRequire("bnIBr");
const $2709ec91f034486f$var$getVersionPageUrl = (projectKey, versionId)=>`/projects/${projectKey}/versions/${versionId}`;
const $2709ec91f034486f$var$getVersionIssuesJql = (projectKey, versionName)=>{
    const jql = `project = ${(0, $bnIBr.toQuotedString)(projectKey)} AND fixVersion = ${(0, $bnIBr.toQuotedString)(versionName)}`;
    return (0, $bnIBr.createAllWorkUrl)(jql);
};
const $2709ec91f034486f$export$ddba25f62ccdd322 = (projectKey, isSoftwareProject, versionId, versionName)=>{
    if (isSoftwareProject) return $2709ec91f034486f$var$getVersionPageUrl(projectKey, versionId);
    return $2709ec91f034486f$var$getVersionIssuesJql(projectKey, versionName);
};

});


parcelRegister("gu0u0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4d0485a7eae0cd3$export$2e2bcd8739ae039);

var $bxOKO = parcelRequire("bxOKO");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $cPax5 = parcelRequire("cPax5");

var $6clie = parcelRequire("6clie");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fRyaf = parcelRequire("fRyaf");

var $ai8dy = parcelRequire("ai8dy");
const $b4d0485a7eae0cd3$var$VersionProgress = ({ query: query })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const progress = (0, $j4oe4.useFragment)((0, $bxOKO.default), query);
    const doneCount = progress.done.totalCount;
    const inProgressCount = progress.inProgress.totalCount;
    const toDoCount = progress.toDo.totalCount;
    return toDoCount || inProgressCount || doneCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4d0485a7eae0cd3$var$BarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPax5.default), {
        sum: doneCount + inProgressCount + toDoCount,
        remainingTooltipContent: formatMessage((0, $ai8dy.default).toDo, {
            toDo: toDoCount
        }),
        backgroundColor: "var(--ds-border, #0B120E24)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6clie.default), {
        value: doneCount,
        tooltipContent: formatMessage((0, $ai8dy.default).done, {
            done: doneCount
        }),
        color: "var(--ds-border-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6clie.default), {
        value: inProgressCount,
        tooltipContent: formatMessage((0, $ai8dy.default).inProgress, {
            inProgress: inProgressCount
        }),
        color: "var(--ds-border-information, #357DE8)"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4d0485a7eae0cd3$var$TextContainer, null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $ai8dy.default).emptyIssueTermRefresh : (0, $ai8dy.default).empty));
};
const $b4d0485a7eae0cd3$var$TextContainer = (0, $fRyaf.Container); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4d0485a7eae0cd3$var$BarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $fRyaf.Container), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1wm8",
            __cmplp.className
        ])
    });
});
var $b4d0485a7eae0cd3$export$2e2bcd8739ae039 = $b4d0485a7eae0cd3$var$VersionProgress;

});
parcelRegister("bxOKO", function(module, exports) {
$parcel$export(module.exports, "default", () => $28dd0a58513b2e31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6de3ee3e2e04c97ca99155ca8f2c271>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $28dd0a58513b2e31$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "progressBar_projectVersions_VersionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "done",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "DONE"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "done.totalCount"
                        }
                    ],
                    "storageKey": "issues(filter:\"DONE\")"
                },
                "action": "THROW",
                "path": "done"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgress",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "IN_PROGRESS"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgress.totalCount"
                        }
                    ],
                    "storageKey": "issues(filter:\"IN_PROGRESS\")"
                },
                "action": "THROW",
                "path": "inProgress"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "toDo",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "TODO"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "toDo.totalCount"
                        }
                    ],
                    "storageKey": "issues(filter:\"TODO\")"
                },
                "action": "THROW",
                "path": "toDo"
            }
        ],
        "type": "JiraVersion"
    };
}();
$28dd0a58513b2e31$var$node.hash = "728b280b2216bb0f2cdb74b3d92d96fb";
var $28dd0a58513b2e31$export$2e2bcd8739ae039 = $28dd0a58513b2e31$var$node;

});

parcelRegister("cPax5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed5bf8b77b781038$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");


var $idGBm = parcelRequire("idGBm");

var $6clie = parcelRequire("6clie");

var $luPRu = parcelRequire("luPRu");
// eslint-disable-next-line jira/react/no-class-components
class $ed5bf8b77b781038$var$ProgressBar extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            children: null,
            sum: 0,
            remainingTooltipContent: '',
            // TODO: Use tokens for colors
            backgroundColor: (0, $7bb4c1736002a04a$exports).N30,
            height: 10
        };
    }
    validateElementsAndCalculateElementsWidth() {
        const { children: children } = this.props;
        let sumOfElementsValues = 0;
        const validatedElements = [];
        (0, $eJOHy.Children).map(children, (child)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const childEl = child;
            if (childEl.props.value && childEl.props.value > 0) {
                sumOfElementsValues += childEl.props.value;
                validatedElements.push(childEl);
            }
        });
        return {
            validatedElements: validatedElements,
            elementsSum: sumOfElementsValues
        };
    }
    render() {
        const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum = 0, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding, intl: { formatMessage: formatMessage } } = this.props;
        if (!children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed5bf8b77b781038$var$ProgressWrapper, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: backgroundColor,
            elementsGrow: 0,
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius
        });
        const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
        const correctedSum = Number.isNaN(sum) ? 0 : sum;
        const remaining = correctedSum - elementsSum;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed5bf8b77b781038$var$ProgressWrapper, {
            ...this.props,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius,
            tooltipHoverPadding: tooltipHoverPadding,
            ariaLive: "polite",
            role: "progressbar",
            "aria-valuemax": correctedSum,
            "aria-valuenow": elementsSum,
            "aria-label": this.props['aria-label'] || formatMessage((0, $luPRu.default).progressBarAriaLabel)
        }, validatedElements, remaining > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6clie.default), {
            value: remaining,
            tooltipContent: remainingTooltipContent,
            color: backgroundColor,
            tooltipHoverPadding: tooltipHoverPadding
        }));
    }
}
var $ed5bf8b77b781038$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($ed5bf8b77b781038$var$ProgressBar);
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed5bf8b77b781038$var$ProgressWrapper = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1750df9-0"
})`width:100%;height:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
    const radius = `${borderRadius || elementsHeight / 2}px`;
    return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
}}}`;
$ed5bf8b77b781038$var$ProgressWrapper.displayName = 'ProgressWrapper';

});
parcelRegister("6clie", function(module, exports) {
$parcel$export(module.exports, "default", () => $bca6fac105a432e7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $k71qx = parcelRequire("k71qx");
const $bca6fac105a432e7$var$SingleElementWithTooltip = (props)=>{
    const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
    const TooltipTag = (0, $eJOHy.useMemo)(()=>{
        const singleElementProps = {
            alt: tooltipContent
        };
        // FIXME: Fix that by extracting the forwarded component
        return /*#__PURE__*/ (0, $eJOHy.forwardRef)((tagProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bca6fac105a432e7$var$SingleElement, {
                elementGrow: value,
                color: color,
                // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
                innerRef: ref,
                tooltipHoverPadding: tooltipHoverPadding,
                ...tagProps,
                ...typeof tooltipContent === 'string' ? singleElementProps : {}
            }));
    }, [
        value,
        color,
        tooltipHoverPadding,
        tooltipContent
    ]);
    return(// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent,
        position: position,
        tag: TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null)));
};
class $bca6fac105a432e7$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: 0,
            tooltipContent: ''
        };
    }
    render() {
        const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
        const hasTooltipContent = Boolean(tooltipContent);
        if (hasTooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bca6fac105a432e7$var$SingleElementWithTooltip, {
            ...this.props,
            tooltipContent: tooltipContent
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bca6fac105a432e7$var$SingleElement, {
            elementGrow: value,
            color: color,
            alt: tooltipContent
        });
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bca6fac105a432e7$var$SingleElement = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-234u1k-0"
})`flex-grow:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
$bca6fac105a432e7$var$SingleElement.displayName = 'SingleElement';

});

parcelRegister("luPRu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c944de1bbd555e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7c944de1bbd555e6$var$messages = (0, $7qGN1.defineMessages)({
    progressBarAriaLabel: {
        "id": "common.components.progress-bar.aria-label",
        "defaultMessage": "Progress Bar"
    }
});
var $7c944de1bbd555e6$export$2e2bcd8739ae039 = $7c944de1bbd555e6$var$messages;

});


parcelRegister("ai8dy", function(module, exports) {
$parcel$export(module.exports, "default", () => $653e78142695efae$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $653e78142695efae$var$messages = (0, $7qGN1.defineMessages)({
    done: {
        "id": "project-versions.table.progress-bar.done",
        "defaultMessage": "{done} done"
    },
    inProgress: {
        "id": "project-versions.table.progress-bar.in-progress",
        "defaultMessage": "{inProgress} in progress"
    },
    toDo: {
        "id": "project-versions.table.progress-bar.to-do",
        "defaultMessage": "{toDo} to do"
    },
    empty: {
        "id": "project-versions.table.progress-bar.empty",
        "defaultMessage": "No issues"
    },
    emptyIssueTermRefresh: {
        "id": "project-versions.table.progress-bar.empty-issue-term-refresh",
        "defaultMessage": "No work items"
    }
});
var $653e78142695efae$export$2e2bcd8739ae039 = $653e78142695efae$var$messages;

});


parcelRegister("8nIFm", function(module, exports) {
$parcel$export(module.exports, "ReleaseDateCell", () => $0afd2a2f050d3523$export$c0bb7e6ec18f1eec);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $cYcBU = parcelRequire("cYcBU");
const $0afd2a2f050d3523$export$c0bb7e6ec18f1eec = ({ releaseDate: releaseDate, overdue: overdue })=>{
    const { formatDate: formatDate } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $0afd2a2f050d3523$var$releaseDateCellStyles,
            overdue && $0afd2a2f050d3523$var$overdueReleaseDateCellStyles
        ]
    }, (0, $cYcBU.getFormattedVersionDate)(releaseDate, formatDate));
};
const $0afd2a2f050d3523$var$releaseDateCellStyles = (0, $1DXK0.xcss)({
    wordWrap: 'break-word',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $0afd2a2f050d3523$var$overdueReleaseDateCellStyles = (0, $1DXK0.xcss)({
    color: 'color.text.danger'
});

});

parcelRegister("89ror", function(module, exports) {
$parcel$export(module.exports, "updateStoreOnMove", () => $fe3c03d4b8e1e469$export$82bdc89cde99e0a0);

var $37Ewn = parcelRequire("37Ewn");

var $kqd31 = parcelRequire("kqd31");
const $fe3c03d4b8e1e469$export$82bdc89cde99e0a0 = ({ store: store, connectionId: connectionId, sourceVersionAri: sourceVersionAri, operationType: operationType, beforeVersionAri: beforeVersionAri })=>{
    const connectionRecord = store.get(connectionId);
    if (connectionRecord == null) return;
    const sourceVersionDataId = (0, $kqd31.default)({
        id: sourceVersionAri
    }, 'JiraVersion') ?? '';
    const sourceVersionRecord = store.get(sourceVersionDataId);
    if (sourceVersionRecord == null) return;
    const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const connectionEdges = connectionRecord.getLinkedRecords(EDGES) || [];
    let updatedEdges = [
        ...connectionEdges
    ];
    const indexOfEdgeToMove = updatedEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === sourceVersionAri);
    const edgeToMove = updatedEdges.splice(indexOfEdgeToMove, 1)[0];
    switch(operationType){
        case 'move-position':
            {
                // This is a bit confusing because we are sorting the versions connection by sequence
                // in descending order, whereas the "beforeKey" and "afterKey" values from the
                // DynamicTable onRankEnd callback assume that the record on the top of the table is
                // the "first" and therefore earliest record. This means that if we want to move an
                // edge to appear "after" another edge in terms of sequence (higher on the table), we
                // have to use the callback's "beforeKey" value
                const indexOfEdgeAfter = connectionEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === beforeVersionAri);
                if (indexOfEdgeAfter > indexOfEdgeToMove) updatedEdges.splice(indexOfEdgeAfter - 1, 0, edgeToMove);
                else updatedEdges.splice(indexOfEdgeAfter, 0, edgeToMove);
                break;
            }
        case 'move-to-start':
            // Again, the "start" in this case refers to the lowest sequence number, so the edge we
            // are moving needs to be added to the end of the connection
            updatedEdges = [
                ...updatedEdges,
                edgeToMove
            ];
            break;
        case 'move-to-end':
            updatedEdges = [
                edgeToMove,
                ...updatedEdges
            ];
            break;
        default:
            break;
    }
    connectionRecord.setLinkedRecords(updatedEdges, EDGES);
};

});


parcelRegister("l82eg", function(module, exports) {
$parcel$export(module.exports, "isVersionAdminContext", () => $7a78b255dc4723bf$export$1de6bf38ac6f624a);
$parcel$export(module.exports, "getProjectType", () => $7a78b255dc4723bf$export$3dd0da95519c1a33);

var $FhXEJ = parcelRequire("FhXEJ");

var $dOwXt = parcelRequire("dOwXt");

var $eSnSE = parcelRequire("eSnSE");
const $7a78b255dc4723bf$export$1de6bf38ac6f624a = ()=>{
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const pathname = (0, $dOwXt.default)() && (0, $dOwXt.default)().pathname || '';
    const isVersionAdminContextSatisfied = pathname.endsWith && pathname.endsWith('/administer-versions');
    // Is it possible for any projects to satisfy this condition in jira-cloud? Can we remove this?
    if (isVersionAdminContextSatisfied) (0, $eSnSE.default).safeInfoWithoutCustomerData('@atlassian/jira-project-versions', 'isVersionAdminContext is true');
    return isVersionAdminContextSatisfied;
};
const $7a78b255dc4723bf$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'BUSINESS':
            return 0, $FhXEJ.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $FhXEJ.SOFTWARE_PROJECT;
        case 'SERVICE_DESK':
            return 0, $FhXEJ.SERVICE_DESK_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};

});


parcelRegister("TALfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddfa7ac58314469e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $3aa9n = parcelRequire("3aa9n");

var $3ugTQ = parcelRequire("3ugTQ");
const $ddfa7ac58314469e$export$fa156a01818e3239 = (projectKey)=>(0, $3ugTQ.performPostRequest)(`/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
    });
const $ddfa7ac58314469e$var$AddProjectToHistory = ({ projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: ()=>$ddfa7ac58314469e$export$fa156a01818e3239(projectKey)
    });
var $ddfa7ac58314469e$export$2e2bcd8739ae039 = $ddfa7ac58314469e$var$AddProjectToHistory;

});

parcelRegister("gWu57", function(module, exports) {
$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.300"
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: [
            hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStyles,
            (0, $4cTDP.fg)('global_rovo_button_in_jira') && $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles
        ]
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});
const $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.500'
});

});




//# sourceMappingURL=async-relay-project-versions.dd7d8f12.js.map
